/*global Geo_InitMap, escape: true*/
/*jslint browser: true*/
"use strict";

/**
* what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
* @version v4.2.0
* @link https://github.com/ten1seven/what-input
* @license MIT
*/
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define("whatInput",[],t):"object"==typeof exports?exports.whatInput=t():e.whatInput=t();}(this,function(){return function(e){function t(o){if(n[o]){return n[o].exports;}var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports;}var n={};return t.m=e,t.c=n,t.p="",t(0);}([function(e,t){"use strict";e.exports=function(){var e="initial",t=null,n=document.documentElement,o=["input","select","textarea"],i=[],r=[16,17,18,91,93],u=[9],d={keydown:"keyboard",mousedown:"mouse",mousemove:"mouse",MSPointerDown:"pointer",MSPointerMove:"pointer",pointerdown:"pointer",pointermove:"pointer",touchstart:"touch"},s=[],a=!1,c=!1,p={x:null,y:null},f={2:"touch",3:"touch",4:"mouse"},v=!1;try{var m=Object.defineProperty({},"passive",{get:function(){v=!0;}});window.addEventListener("test",null,m);}catch(e){}var w=function(){window.PointerEvent?(n.addEventListener("pointerdown",l),n.addEventListener("pointermove",y)):window.MSPointerEvent?(n.addEventListener("MSPointerDown",l),n.addEventListener("MSPointerMove",y)):(n.addEventListener("mousedown",l),n.addEventListener("mousemove",y),"ontouchstart"in window&&(n.addEventListener("touchstart",x),n.addEventListener("touchend",x))),n.addEventListener(b(),y,!!v&&{passive:!0}),n.addEventListener("keydown",l);},l=function(n){if(!a){var i=n.which,s=d[n.type];if("pointer"===s&&(s=L(n)),e!==s||t!==s){var c=document.activeElement,p=!1;(c&&c.nodeName&&-1===o.indexOf(c.nodeName.toLowerCase())||-1!==u.indexOf(i))&&(p=!0),("touch"===s||"mouse"===s||"keyboard"===s&&i&&p&&-1===r.indexOf(i))&&(e=t=s,h());}}},h=function(){n.setAttribute("data-whatinput",e),n.setAttribute("data-whatintent",e),-1===s.indexOf(e)&&(s.push(e),n.className+=" whatinput-types-"+e),E("input");},y=function(e){if(p.x!==e.screenX||p.y!==e.screenY?(c=!1,p.x=e.screenX,p.y=e.screenY):c=!0,!a&&!c){var o=d[e.type];"pointer"===o&&(o=L(e)),t!==o&&(t=o,n.setAttribute("data-whatintent",t),E("intent"));}},x=function(e){"touchstart"===e.type?(a=!1,l(e)):a=!0;},E=function(e){for(var n=0,o=i.length;n<o;n++){i[n].type===e&&i[n].function.call(void 0,t);}},L=function(e){return"number"==typeof e.pointerType?f[e.pointerType]:"pen"===e.pointerType?"touch":e.pointerType;},b=function(){return"onwheel"in document.createElement("div")?"wheel":void 0!==document.onmousewheel?"mousewheel":"DOMMouseScroll";};return"addEventListener"in window&&Array.prototype.indexOf&&function(){d[b()]="mouse",w(),h();}(),{ask:function(n){return"loose"===n?t:e;},types:function(){return s;},ignoreKeys:function(e){r=e;},onChange:function(e,t){i.push({function:e,type:t});}};}();}]);});

/*!
    Modaal - accessible modals - v0.4.4
    by Humaan, for all humans.
    http://humaan.com
 */
!function(a){function t(a){var t={},o=!1;a.attr("data-modaal-type")&&(o=!0,t.type=a.attr("data-modaal-type")),a.attr("data-modaal-content-source")&&(o=!0,t.content_source=a.attr("data-modaal-content-source")),a.attr("data-modaal-animation")&&(o=!0,t.animation=a.attr("data-modaal-animation")),a.attr("data-modaal-animation-speed")&&(o=!0,t.animation_speed=a.attr("data-modaal-animation-speed")),a.attr("data-modaal-after-callback-delay")&&(o=!0,t.after_callback_delay=a.attr("data-modaal-after-callback-delay")),a.attr("data-modaal-is-locked")&&(o=!0,t.is_locked="true"===a.attr("data-modaal-is-locked")),a.attr("data-modaal-hide-close")&&(o=!0,t.hide_close="true"===a.attr("data-modaal-hide-close")),a.attr("data-modaal-background")&&(o=!0,t.background=a.attr("data-modaal-background")),a.attr("data-modaal-overlay-opacity")&&(o=!0,t.overlay_opacity=a.attr("data-modaal-overlay-opacity")),a.attr("data-modaal-overlay-close")&&(o=!0,t.overlay_close="false"!==a.attr("data-modaal-overlay-close")),a.attr("data-modaal-accessible-title")&&(o=!0,t.accessible_title=a.attr("data-modaal-accessible-title")),a.attr("data-modaal-start-open")&&(o=!0,t.start_open="true"===a.attr("data-modaal-start-open")),a.attr("data-modaal-fullscreen")&&(o=!0,t.fullscreen="true"===a.attr("data-modaal-fullscreen")),a.attr("data-modaal-custom-class")&&(o=!0,t.custom_class=a.attr("data-modaal-custom-class")),a.attr("data-modaal-close-text")&&(o=!0,t.close_text=a.attr("data-modaal-close-text")),a.attr("data-modaal-close-aria-label")&&(o=!0,t.close_aria_label=a.attr("data-modaal-close-aria-label")),a.attr("data-modaal-background-scroll")&&(o=!0,t.background_scroll="true"===a.attr("data-modaal-background-scroll")),a.attr("data-modaal-width")&&(o=!0,t.width=parseInt(a.attr("data-modaal-width"))),a.attr("data-modaal-height")&&(o=!0,t.height=parseInt(a.attr("data-modaal-height"))),a.attr("data-modaal-confirm-button-text")&&(o=!0,t.confirm_button_text=a.attr("data-modaal-confirm-button-text")),a.attr("data-modaal-confirm-cancel-button-text")&&(o=!0,t.confirm_cancel_button_text=a.attr("data-modaal-confirm-cancel-button-text")),a.attr("data-modaal-confirm-title")&&(o=!0,t.confirm_title=a.attr("data-modaal-confirm-title")),a.attr("data-modaal-confirm-content")&&(o=!0,t.confirm_content=a.attr("data-modaal-confirm-content")),a.attr("data-modaal-gallery-active-class")&&(o=!0,t.gallery_active_class=a.attr("data-modaal-gallery-active-class")),a.attr("data-modaal-loading-content")&&(o=!0,t.loading_content=a.attr("data-modaal-loading-content")),a.attr("data-modaal-loading-class")&&(o=!0,t.loading_class=a.attr("data-modaal-loading-class")),a.attr("data-modaal-ajax-error-class")&&(o=!0,t.ajax_error_class=a.attr("data-modaal-ajax-error-class")),a.attr("data-modaal-instagram-id")&&(o=!0,t.instagram_id=a.attr("data-modaal-instagram-id")),o&&a.modaal(t);}var o={init:function(t,o){var e=this;if(e.dom=a("body"),e.$elem=a(o),e.options=a.extend({},a.fn.modaal.options,e.$elem.data(),t),e.xhr=null,e.scope={is_open:!1,id:"modaal_"+(new Date).getTime()+Math.random().toString(16).substring(2),source:e.options.content_source?e.options.content_source:e.$elem.attr("href")},e.$elem.attr("data-modaal-scope",e.scope.id),e.private_options={active_class:"is_active"},e.lastFocus=null,e.options.is_locked||"confirm"==e.options.type||e.options.hide_close?e.scope.close_btn="":e.scope.close_btn='<button type="button" class="modaal-close" id="modaal-close" aria-label="'+e.options.close_aria_label+'"><span>'+e.options.close_text+"</span></button>","none"===e.options.animation&&(e.options.animation_speed=0,e.options.after_callback_delay=0),a(o).on("click.Modaal",function(a){a.preventDefault(),e.create_modaal(e,a);}),!0===e.options.outer_controls){var i="outer";}else {var i="inner";}e.scope.prev_btn='<button type="button" class="modaal-gallery-control modaal-gallery-prev modaal-gallery-prev-'+i+'" id="modaal-gallery-prev" aria-label="Previous image (use left arrow to change)"><span>Previous Image</span></button>',e.scope.next_btn='<button type="button" class="modaal-gallery-control modaal-gallery-next modaal-gallery-next-'+i+'" id="modaal-gallery-next" aria-label="Next image (use right arrow to change)"><span>Next Image</span></button>',!0===e.options.start_open&&e.create_modaal(e);},create_modaal:function(a,t){var o,a=this;if(a.lastFocus=a.$elem,!1!==a.options.should_open&&("function"!=typeof a.options.should_open||!1!==a.options.should_open())){switch(a.options.before_open.call(a,t),a.options.type){case"inline":a.create_basic();break;case"ajax":o=a.options.source(a.$elem,a.scope.source),a.fetch_ajax(o);break;case"confirm":a.options.is_locked=!0,a.create_confirm();break;case"image":a.create_image();break;case"iframe":o=a.options.source(a.$elem,a.scope.source),a.create_iframe(o);break;case"video":a.create_video(a.scope.source);break;case"instagram":a.create_instagram();}a.watch_events();}},watch_events:function(){var t=this;t.dom.off("click.Modaal keyup.Modaal keydown.Modaal"),t.dom.on("keydown.Modaal",function(o){var e=o.keyCode,i=o.target;9==e&&t.scope.is_open&&(a.contains(document.getElementById(t.scope.id),i)||a("#"+t.scope.id).find('*[tabindex="0"]').focus());}),t.dom.on("keyup.Modaal",function(o){var e=o.keyCode,i=o.target;return o.shiftKey&&9==o.keyCode&&t.scope.is_open&&(a.contains(document.getElementById(t.scope.id),i)||a("#"+t.scope.id).find(".modaal-close").focus()),!t.options.is_locked&&27==e&&t.scope.is_open?!a(document.activeElement).is("input:not(:checkbox):not(:radio)")&&void t.modaal_close():"image"==t.options.type?(37==e&&t.scope.is_open&&!a("#"+t.scope.id+" .modaal-gallery-prev").hasClass("is_hidden")&&t.gallery_update("prev"),void(39==e&&t.scope.is_open&&!a("#"+t.scope.id+" .modaal-gallery-next").hasClass("is_hidden")&&t.gallery_update("next"))):void 0;}),t.dom.on("click.Modaal",function(o){var e=a(o.target);if(!t.options.is_locked&&(t.options.overlay_close&&e.is(".modaal-inner-wrapper")||e.is(".modaal-close")||e.closest(".modaal-close").length)){return void t.modaal_close();}if(e.is(".modaal-confirm-btn")){return e.is(".modaal-ok")&&t.options.confirm_callback.call(t,t.lastFocus),e.is(".modaal-cancel")&&t.options.confirm_cancel_callback.call(t,t.lastFocus),void t.modaal_close();}if(e.is(".modaal-gallery-control")){if(e.hasClass("is_hidden")){return;}return e.is(".modaal-gallery-prev")&&t.gallery_update("prev"),void(e.is(".modaal-gallery-next")&&t.gallery_update("next"));}});},build_modal:function(t){var o=this,e="";"instagram"==o.options.type&&(e=" modaal-instagram");var i,l="video"==o.options.type?"modaal-video-wrap":"modaal-content";switch(o.options.animation){case"fade":i=" modaal-start_fade";break;case"slide-down":i=" modaal-start_slidedown";break;default:i=" modaal-start_none";}var n="";o.options.fullscreen&&(n=" modaal-fullscreen"),""===o.options.custom_class&&void 0===o.options.custom_class||(o.options.custom_class=" "+o.options.custom_class);var s="";o.options.width&&o.options.height&&"number"==typeof o.options.width&&"number"==typeof o.options.height?s=' style="max-width:'+o.options.width+"px;height:"+o.options.height+'px;overflow:auto;"':o.options.width&&"number"==typeof o.options.width?s=' style="max-width:'+o.options.width+'px;"':o.options.height&&"number"==typeof o.options.height&&(s=' style="height:'+o.options.height+'px;overflow:auto;"'),("image"==o.options.type||"video"==o.options.type||"instagram"==o.options.type||o.options.fullscreen)&&(s="");var d="";o.is_touch()&&(d=' style="cursor:pointer;"');var r='<div class="modaal-wrapper modaal-'+o.options.type+i+e+n+o.options.custom_class+'" id="'+o.scope.id+'"><div class="modaal-outer-wrapper"><div class="modaal-inner-wrapper"'+d+">";"video"!=o.options.type&&(r+='<div class="modaal-container"'+s+">"),r+='<div class="'+l+' modaal-focus" aria-hidden="false" aria-label="'+o.options.accessible_title+" - "+o.options.close_aria_label+'" role="dialog">',"inline"==o.options.type?r+='<div class="modaal-content-container" role="document"></div>':r+=t,r+="</div>"+o.scope.close_btn,"video"!=o.options.type&&(r+="</div>"),r+="</div>","image"==o.options.type&&!0===o.options.outer_controls&&(r+=o.scope.prev_btn+o.scope.next_btn),r+="</div></div>",a("#"+o.scope.id+"_overlay").length<1&&o.dom.append(r),"inline"==o.options.type&&t.appendTo("#"+o.scope.id+" .modaal-content-container"),o.modaal_overlay("show");},create_basic:function(){var t=this,o=a(t.scope.source),e="";o.length?(e=o.contents().detach(),o.empty()):e="Content could not be loaded. Please check the source and try again.",t.build_modal(e);},create_instagram:function(){var t=this,o=t.options.instagram_id,e="",i="Instagram photo couldn't be loaded, please check the embed code and try again.";if(t.build_modal('<div class="modaal-content-container'+(""!=t.options.loading_class?" "+t.options.loading_class:"")+'">'+t.options.loading_content+"</div>"),""!=o&&null!==o&&void 0!==o){var l="https://api.instagram.com/oembed?url=http://instagr.am/p/"+o+"/";a.ajax({url:l,dataType:"jsonp",cache:!1,success:function(o){t.dom.append('<div id="temp-ig" style="width:0;height:0;overflow:hidden;">'+o.html+"</div>"),t.dom.attr("data-igloaded")?window.instgrm.Embeds.process():t.dom.attr("data-igloaded","true");var e="#"+t.scope.id+" .modaal-content-container";a(e).length>0&&setTimeout(function(){a("#temp-ig").contents().clone().appendTo(e),a("#temp-ig").remove();},1e3);},error:function(){e=i;var o=a("#"+t.scope.id+" .modaal-content-container");o.length>0&&(o.removeClass(t.options.loading_class).addClass(t.options.ajax_error_class),o.html(e));}});}else {e=i;}return!1;},fetch_ajax:function(t){var o=this;null==o.options.accessible_title&&(o.options.accessible_title="Dialog Window"),null!==o.xhr&&(o.xhr.abort(),o.xhr=null),o.build_modal('<div class="modaal-content-container'+(""!=o.options.loading_class?" "+o.options.loading_class:"")+'">'+o.options.loading_content+"</div>"),o.xhr=a.ajax(t,{success:function(t){var e=a("#"+o.scope.id).find(".modaal-content-container");e.length>0&&(e.removeClass(o.options.loading_class),e.html(t),o.options.ajax_success.call(o,e));},error:function(t){if("abort"!=t.statusText){var e=a("#"+o.scope.id+" .modaal-content-container");e.length>0&&(e.removeClass(o.options.loading_class).addClass(o.options.ajax_error_class),e.html("Content could not be loaded. Please check the source and try again."));}}});},create_confirm:function(){var a,t=this;a='<div class="modaal-content-container"><h1 id="modaal-title">'+t.options.confirm_title+'</h1><div class="modaal-confirm-content">'+t.options.confirm_content+'</div><div class="modaal-confirm-wrap"><button type="button" class="modaal-confirm-btn modaal-ok" aria-label="Confirm">'+t.options.confirm_button_text+'</button><button type="button" class="modaal-confirm-btn modaal-cancel" aria-label="Cancel">'+t.options.confirm_cancel_button_text+"</button></div></div></div>",t.build_modal(a);},create_image:function(){var t,o,e=this,i="";if(e.$elem.is("[data-group]")||e.$elem.is("[rel]")){var l=e.$elem.is("[data-group]"),n=l?e.$elem.attr("data-group"):e.$elem.attr("rel"),s=a(l?'[data-group="'+n+'"]':'[rel="'+n+'"]');s.removeAttr("data-gallery-active","is_active"),e.$elem.attr("data-gallery-active","is_active"),o=s.length-1;var d=[];i='<div class="modaal-gallery-item-wrap">',s.each(function(t,o){var e="",i="",l="",n=!1,s=!1,r=o.getAttribute("data-modaal-desc"),c=o.getAttribute("data-gallery-active");a(o).attr("data-modaal-content-source")?e=a(o).attr("data-modaal-content-source"):a(o).attr("href")?e=a(o).attr("href"):a(o).attr("src")?e=a(o).attr("src"):(e="trigger requires href or data-modaal-content-source attribute",s=!0),""!=r&&null!==r&&void 0!==r?(i=r,l='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image '+(t+1)+" - </span>"+r.replace(/</g,"&lt;").replace(/>/g,"&gt;")+"</div>"):l='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image '+(t+1)+"</span></div>",c&&(n=!0);var m={url:e,alt:i,rawdesc:r,desc:l,active:n,src_error:s};d.push(m);});for(var r=0;r<d.length;r++){var c="",m=d[r].rawdesc?"Image: "+d[r].rawdesc:"Image "+r+" no description";d[r].active&&(c=" "+e.private_options.active_class);var p=d[r].src_error?d[r].url:'<img src="'+d[r].url+'" alt=" " style="width:100%">';i+='<div class="modaal-gallery-item gallery-item-'+r+c+'" aria-label="'+m+'">'+p+d[r].desc+"</div>";}i+="</div>",1!=e.options.outer_controls&&(i+=e.scope.prev_btn+e.scope.next_btn);}else{var u,_=!1;e.$elem.attr("data-modaal-content-source")?u=e.$elem.attr("data-modaal-content-source"):e.$elem.attr("href")?u=e.$elem.attr("href"):e.$elem.attr("src")?u=e.$elem.attr("src"):(u="trigger requires href or data-modaal-content-source attribute",_=!0);var v="",f="",m="";e.$elem.attr("data-modaal-desc")?(m=e.$elem.attr("data-modaal-desc"),v=e.$elem.attr("data-modaal-desc"),f='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image - </span>'+v.replace(/</g,"&lt;").replace(/>/g,"&gt;")+"</div>"):m="Image with no description";var p=_?u:'<img src="'+u+'" alt=" " style="width:100%">';i='<div class="modaal-gallery-item is_active" aria-label="'+m+'">'+p+f+"</div>";}t=i,e.build_modal(t),a(".modaal-gallery-item.is_active").is(".gallery-item-0")&&a(".modaal-gallery-prev").hide(),a(".modaal-gallery-item.is_active").is(".gallery-item-"+o)&&a(".modaal-gallery-next").hide();},gallery_update:function(t){var o=this,e=a("#"+o.scope.id),i=e.find(".modaal-gallery-item"),l=i.length-1;if(0==l){return!1;}var n=e.find(".modaal-gallery-prev"),s=e.find(".modaal-gallery-next"),d=0,r=0,c=e.find(".modaal-gallery-item."+o.private_options.active_class),m="next"==t?c.next(".modaal-gallery-item"):c.prev(".modaal-gallery-item");return o.options.before_image_change.call(o,c,m),("prev"!=t||!e.find(".gallery-item-0").hasClass("is_active"))&&(("next"!=t||!e.find(".gallery-item-"+l).hasClass("is_active"))&&void c.stop().animate({opacity:0},250,function(){m.addClass("is_next").css({position:"absolute",display:"block",opacity:0});var t=a(document).width(),i=t>1140?280:50;d=e.find(".modaal-gallery-item.is_next").width(),r=e.find(".modaal-gallery-item.is_next").height();var p=e.find(".modaal-gallery-item.is_next img").prop("naturalWidth"),u=e.find(".modaal-gallery-item.is_next img").prop("naturalHeight");p>t-i?(d=t-i,e.find(".modaal-gallery-item.is_next").css({width:d}),e.find(".modaal-gallery-item.is_next img").css({width:d}),r=e.find(".modaal-gallery-item.is_next").find("img").height()):(d=p,r=u),e.find(".modaal-gallery-item-wrap").stop().animate({width:d,height:r},250,function(){c.removeClass(o.private_options.active_class+" "+o.options.gallery_active_class).removeAttr("style"),c.find("img").removeAttr("style"),m.addClass(o.private_options.active_class+" "+o.options.gallery_active_class).removeClass("is_next").css("position",""),m.stop().animate({opacity:1},250,function(){a(this).removeAttr("style").css({width:"100%"}),a(this).find("img").css("width","100%"),e.find(".modaal-gallery-item-wrap").removeAttr("style"),o.options.after_image_change.call(o,m);}),e.find(".modaal-gallery-item").removeAttr("tabindex"),e.find(".modaal-gallery-item."+o.private_options.active_class).attr("tabindex","0").focus(),e.find(".modaal-gallery-item."+o.private_options.active_class).is(".gallery-item-0")?n.stop().animate({opacity:0},150,function(){a(this).hide();}):n.stop().css({display:"block",opacity:n.css("opacity")}).animate({opacity:1},150),e.find(".modaal-gallery-item."+o.private_options.active_class).is(".gallery-item-"+l)?s.stop().animate({opacity:0},150,function(){a(this).hide();}):s.stop().css({display:"block",opacity:n.css("opacity")}).animate({opacity:1},150);});}));},create_video:function(a){var t,o=this;t='<iframe src="'+a+'" class="modaal-video-frame" frameborder="0" allowfullscreen></iframe>',o.build_modal('<div class="modaal-video-container">'+t+"</div>");},create_iframe:function(a){var t,o=this;t=null!==o.options.width||void 0!==o.options.width||null!==o.options.height||void 0!==o.options.height?'<iframe src="'+a+'" class="modaal-iframe-elem" frameborder="0" allowfullscreen></iframe>':'<div class="modaal-content-container">Please specify a width and height for your iframe</div>',o.build_modal(t);},modaal_open:function(){var t=this,o=a("#"+t.scope.id),e=t.options.animation;"none"===e&&(o.removeClass("modaal-start_none"),t.options.after_open.call(t,o)),"fade"===e&&o.removeClass("modaal-start_fade"),"slide-down"===e&&o.removeClass("modaal-start_slide_down");var i=o;a(".modaal-wrapper *[tabindex=0]").removeAttr("tabindex"),i="image"==t.options.type?a("#"+t.scope.id).find(".modaal-gallery-item."+t.private_options.active_class):o.find(".modaal-iframe-elem").length?o.find(".modaal-iframe-elem"):o.find(".modaal-video-wrap").length?o.find(".modaal-video-wrap"):o.find(".modaal-focus"),i.attr("tabindex","0").focus(),"none"!==e&&setTimeout(function(){t.options.after_open.call(t,o);},t.options.after_callback_delay);},modaal_close:function(){var t=this,o=a("#"+t.scope.id);t.options.before_close.call(t,o),null!==t.xhr&&(t.xhr.abort(),t.xhr=null),"none"===t.options.animation&&o.addClass("modaal-start_none"),"fade"===t.options.animation&&o.addClass("modaal-start_fade"),"slide-down"===t.options.animation&&o.addClass("modaal-start_slide_down"),setTimeout(function(){"inline"==t.options.type&&a("#"+t.scope.id+" .modaal-content-container").contents().detach().appendTo(t.scope.source),o.remove(),t.options.after_close.call(t),t.scope.is_open=!1;},t.options.after_callback_delay),t.modaal_overlay("hide"),null!=t.lastFocus&&t.lastFocus.focus();},modaal_overlay:function(t){var o=this;"show"==t?(o.scope.is_open=!0,o.options.background_scroll||o.dom.addClass("modaal-noscroll"),a("#"+o.scope.id+"_overlay").length<1&&o.dom.append('<div class="modaal-overlay" id="'+o.scope.id+'_overlay"></div>'),a("#"+o.scope.id+"_overlay").css("background",o.options.background).stop().animate({opacity:o.options.overlay_opacity},o.options.animation_speed,function(){o.modaal_open();})):"hide"==t&&a("#"+o.scope.id+"_overlay").stop().animate({opacity:0},o.options.animation_speed,function(){a(this).remove(),o.dom.removeClass("modaal-noscroll");});},is_touch:function(){return"ontouchstart"in window||navigator.maxTouchPoints;}},e=[];a.fn.modaal=function(t){return this.each(function(i){var l=a(this).data("modaal");if(l){if("string"==typeof t){switch(t){case"open":l.create_modaal(l);break;case"close":l.modaal_close();}}}else{var n=Object.create(o);n.init(t,this),a.data(this,"modaal",n),e.push({element:a(this).attr("class"),options:t});}});},a.fn.modaal.options={type:"inline",content_source:null,animation:"fade",animation_speed:300,after_callback_delay:350,is_locked:!1,hide_close:!1,background:"#000",overlay_opacity:"0.8",overlay_close:!0,accessible_title:"Dialog Window",start_open:!1,fullscreen:!1,custom_class:"",background_scroll:!1,should_open:!0,close_text:"Close",close_aria_label:"Close (Press escape to close)",width:null,height:null,before_open:function(){},after_open:function(){},before_close:function(){},after_close:function(){},source:function(a,t){return t;},confirm_button_text:"Confirm",confirm_cancel_button_text:"Cancel",confirm_title:"Confirm Title",confirm_content:"<p>This is the default confirm dialog content. Replace me through the options</p>",confirm_callback:function(){},confirm_cancel_callback:function(){},gallery_active_class:"gallery_active_item",outer_controls:!1,before_image_change:function(a,t){},after_image_change:function(a){},loading_content:'<div class="modaal-loading-spinner"><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div>',loading_class:"is_loading",ajax_error_class:"modaal-error",ajax_success:function(){},instagram_id:null},a(function(){var o=a(".modaal");o.length&&o.each(function(){t(a(this));});var i=new MutationObserver(function(o){o.forEach(function(o){if(o.addedNodes&&o.addedNodes.length>0){[].some.call(o.addedNodes,function(o){var i=a(o);(i.is("a")||i.is("button"))&&(i.hasClass("modaal")?t(i):e.forEach(function(t){if(t.element==i.attr("class")){return a(i).modaal(t.options),!1;}}));});}});}),l={subtree:!0,attributes:!0,childList:!0,characterData:!0};setTimeout(function(){i.observe(document.body,l);},500);});}(jQuery,window,document);

/*
       (accessible)
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1@accessible360.1
  Author: Jason Webb (Accessible360)
 Website: https://accessible360.com
    Docs: https://accessible360.github.io/accessible-slick
    Repo: https://github.com/Accessible360/accessible-slick
  Issues: https://github.com/Accessible360/accessible-slick/issues

 */
  !function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(d){"use strict";var s,l=window.Slick||{};s=0,(l=function(i,e){var t,o=this;o.defaults={adaptiveHeight:!1,appendArrows:d(i),appendDots:d(i),arrows:!0,arrowsPlacement:null,asNavFor:null,prevArrow:'<button class="slick-prev" type="button"><span class="slick-prev-icon" aria-hidden="true"></span><span class="slick-sr-only">Previous</span></button>',nextArrow:'<button class="slick-next" type="button"><span class="slick-next-icon" aria-hidden="true"></span><span class="slick-sr-only">Next</span></button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(i,e){return d('<button type="button"><span class="slick-dot-icon" aria-hidden="true"></span><span class="slick-sr-only">Go to slide '+(e+1)+"</span></button>")},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,infinite:!0,initialSlide:0,instructionsText:null,lazyLoad:"ondemand",mobileFirst:!1,playIcon:'<span class="slick-play-icon" aria-hidden="true"></span>',pauseIcon:'<span class="slick-pause-icon" aria-hidden="true"></span>',pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,regionLabel:"carousel",respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useAutoplayToggleButton:!0,useCSS:!0,useGroupRole:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},o.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,$instructionsText:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$pauseButton:null,$pauseIcon:null,$playIcon:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},d.extend(o,o.initials),o.activeBreakpoint=null,o.animType=null,o.animProp=null,o.breakpoints=[],o.breakpointSettings=[],o.cssTransitions=!1,o.focussed=!1,o.interrupted=!1,o.hidden="hidden",o.paused=!0,o.positionProp=null,o.respondTo=null,o.rowCount=1,o.shouldClick=!0,o.$slider=d(i),o.$slidesCache=null,o.transformType=null,o.transitionType=null,o.visibilityChange="visibilitychange",o.windowWidth=0,o.windowTimer=null,t=d(i).data("slick")||{},o.options=d.extend({},o.defaults,e,t),o.currentSlide=o.options.initialSlide,o.originalSettings=o.options,void 0!==document.mozHidden?(o.hidden="mozHidden",o.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(o.hidden="webkitHidden",o.visibilityChange="webkitvisibilitychange"),o.autoPlay=d.proxy(o.autoPlay,o),o.autoPlayClear=d.proxy(o.autoPlayClear,o),o.autoPlayIterator=d.proxy(o.autoPlayIterator,o),o.autoPlayToggleHandler=d.proxy(o.autoPlayToggleHandler,o),o.changeSlide=d.proxy(o.changeSlide,o),o.clickHandler=d.proxy(o.clickHandler,o),o.selectHandler=d.proxy(o.selectHandler,o),o.setPosition=d.proxy(o.setPosition,o),o.swipeHandler=d.proxy(o.swipeHandler,o),o.dragHandler=d.proxy(o.dragHandler,o),o.instanceUid=s++,o.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,o.registerBreakpoints(),o.init(!0)}).prototype.addSlide=l.prototype.slickAdd=function(i,e,t){var o=this;if("boolean"==typeof e)t=e,e=null;else if(e<0||e>=o.slideCount)return!1;o.unload(),"number"==typeof e?0===e&&0===o.$slides.length?d(i).appendTo(o.$slideTrack):t?d(i).insertBefore(o.$slides.eq(e)):d(i).insertAfter(o.$slides.eq(e)):!0===t?d(i).prependTo(o.$slideTrack):d(i).appendTo(o.$slideTrack),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slides.each(function(i,e){d(e).attr("data-slick-index",i),d(e).attr("role","group"),d(e).attr("aria-label","slide "+i)}),o.$slidesCache=o.$slides,o.reinit()},l.prototype.animateHeight=function(){var i,e=this;1===e.options.slidesToShow&&!0===e.options.adaptiveHeight&&!1===e.options.vertical&&(i=e.$slides.eq(e.currentSlide).outerHeight(!0),e.$list.animate({height:i},e.options.speed))},l.prototype.animateSlide=function(i,e){var t={},o=this;o.animateHeight(),!0===o.options.rtl&&!1===o.options.vertical&&(i=-i),!1===o.transformsEnabled?!1===o.options.vertical?o.$slideTrack.animate({left:i},o.options.speed,o.options.easing,e):o.$slideTrack.animate({top:i},o.options.speed,o.options.easing,e):!1===o.cssTransitions?(!0===o.options.rtl&&(o.currentLeft=-o.currentLeft),d({animStart:o.currentLeft}).animate({animStart:i},{duration:o.options.speed,easing:o.options.easing,step:function(i){i=Math.ceil(i),!1===o.options.vertical?t[o.animType]="translate("+i+"px, 0px)":t[o.animType]="translate(0px,"+i+"px)",o.$slideTrack.css(t)},complete:function(){e&&e.call()}})):(o.applyTransition(),i=Math.ceil(i),!1===o.options.vertical?t[o.animType]="translate3d("+i+"px, 0px, 0px)":t[o.animType]="translate3d(0px,"+i+"px, 0px)",o.$slideTrack.css(t),e&&setTimeout(function(){o.disableTransition(),e.call()},o.options.speed))},l.prototype.getNavTarget=function(){var i=this.options.asNavFor;return i&&null!==i&&(i=d(i).not(this.$slider)),i},l.prototype.asNavFor=function(e){var i=this.getNavTarget();null!==i&&"object"==typeof i&&i.each(function(){var i=d(this).slick("getSlick");i.unslicked||i.slideHandler(e,!0)})},l.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},l.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},l.prototype.autoPlayClear=function(){this.autoPlayTimer&&clearInterval(this.autoPlayTimer)},l.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},l.prototype.autoPlayToggleHandler=function(){var i=this;i.paused?(i.$playIcon.css("display","none"),i.$pauseIcon.css("display","inline"),i.$pauseButton.find(".slick-play-text").attr("style","display: none"),i.$pauseButton.find(".slick-pause-text").removeAttr("style"),i.slickPlay()):(i.$playIcon.css("display","inline"),i.$pauseIcon.css("display","none"),i.$pauseButton.find(".slick-play-text").removeAttr("style"),i.$pauseButton.find(".slick-pause-text").attr("style","display: none"),i.slickPause())},l.prototype.buildArrows=function(){var i=this;if(!0===i.options.arrows)if(i.$prevArrow=d(i.options.prevArrow).addClass("slick-arrow"),i.$nextArrow=d(i.options.nextArrow).addClass("slick-arrow"),i.slideCount>i.options.slidesToShow){if(i.htmlExpr.test(i.options.prevArrow))if(null!=i.options.arrowsPlacement)switch(i.options.arrowsPlacement){case"beforeSlides":case"split":console.log("test"),i.$prevArrow.prependTo(i.options.appendArrows);break;case"afterSlides":i.$prevArrow.appendTo(i.options.appendArrows)}else i.$prevArrow.prependTo(i.options.appendArrows);if(i.htmlExpr.test(i.options.nextArrow))if(null!=i.options.arrowsPlacement)switch(i.options.arrowsPlacement){case"beforeSlides":console.log("test2"),i.$prevArrow.after(i.$nextArrow);break;case"afterSlides":case"split":i.$nextArrow.appendTo(i.options.appendArrows)}else i.$nextArrow.appendTo(i.options.appendArrows);!0!==i.options.infinite&&i.$prevArrow.addClass("slick-disabled").prop("disabled",!0)}else i.$prevArrow.add(i.$nextArrow).addClass("slick-hidden").prop("disabled",!0)},l.prototype.buildDots=function(){var i,e,t=this;if(!0===t.options.dots&&t.slideCount>t.options.slidesToShow){for(t.$slider.addClass("slick-dotted"),e=d("<ul />").addClass(t.options.dotsClass),i=0;i<=t.getDotCount();i+=1)e.append(d("<li />").append(t.options.customPaging.call(this,t,i)));t.$dots=e.appendTo(t.options.appendDots),t.$dots.find("li").first().addClass("slick-active")}},l.prototype.buildOut=function(){var t=this;t.$slides=t.$slider.children(t.options.slide+":not(.slick-cloned)").addClass("slick-slide"),t.slideCount=t.$slides.length,t.$slides.each(function(i,e){d(e).attr("data-slick-index",i).data("originalStyling",d(e).attr("style")||""),t.options.useGroupRole&&d(e).attr("role","group").attr("aria-label","slide "+(i+1))}),t.$slider.addClass("slick-slider"),t.$slider.attr("role","region"),t.$slider.attr("aria-label",t.options.regionLabel),t.$slideTrack=0===t.slideCount?d('<div class="slick-track"/>').appendTo(t.$slider):t.$slides.wrapAll('<div class="slick-track"/>').parent(),t.$list=t.$slideTrack.wrap('<div class="slick-list"/>').parent(),t.$slideTrack.css("opacity",0),!0!==t.options.centerMode&&!0!==t.options.swipeToSlide||(t.options.slidesToScroll=1),d("img[data-lazy]",t.$slider).not("[src]").addClass("slick-loading"),t.setupInfinite(),t.buildArrows(),t.buildDots(),t.updateDots(),t.setSlideClasses("number"==typeof t.currentSlide?t.currentSlide:0),!0===t.options.draggable&&t.$list.addClass("draggable"),t.options.autoplay&&t.options.useAutoplayToggleButton&&(t.$pauseIcon=d(t.options.pauseIcon).attr("aria-hidden",!0),t.$playIcon=d(t.options.playIcon).attr("aria-hidden",!0),t.$pauseButton=d('<button type="button" class="slick-autoplay-toggle-button">'),t.$pauseButton.append(t.$pauseIcon),t.$pauseButton.append(t.$playIcon.css("display","none")),t.$pauseButton.append(d('<span class="slick-pause-text slick-sr-only">Pause</span>')),t.$pauseButton.append(d('<span class="slick-play-text slick-sr-only" style="display: none">Play</span>')),t.$pauseButton.prependTo(t.$slider)),null!=t.options.instructionsText&&""!=t.options.instructionsText&&(t.$instructionsText=d('<p class="slick-instructions slick-sr-only">'+t.options.instructionsText+"</p>"),t.$instructionsText.prependTo(t.$slider))},l.prototype.buildRows=function(){var i,e,t,o=this,s=document.createDocumentFragment(),n=o.$slider.children();if(0<o.options.rows){for(t=o.options.slidesPerRow*o.options.rows,e=Math.ceil(n.length/t),i=0;i<e;i++){for(var l=document.createElement("div"),r=0;r<o.options.rows;r++){for(var a=document.createElement("div"),d=0;d<o.options.slidesPerRow;d++){var p=i*t+(r*o.options.slidesPerRow+d);n.get(p)&&a.appendChild(n.get(p))}l.appendChild(a)}s.appendChild(l)}o.$slider.empty().append(s),o.$slider.children().children().children().css({width:100/o.options.slidesPerRow+"%",display:"inline-block"})}},l.prototype.checkResponsive=function(i,e){var t,o,s,n=this,l=!1,r=n.$slider.width(),a=window.innerWidth||d(window).width();if("window"===n.respondTo?s=a:"slider"===n.respondTo?s=r:"min"===n.respondTo&&(s=Math.min(a,r)),n.options.responsive&&n.options.responsive.length&&null!==n.options.responsive){for(t in o=null,n.breakpoints)n.breakpoints.hasOwnProperty(t)&&(!1===n.originalSettings.mobileFirst?s<n.breakpoints[t]&&(o=n.breakpoints[t]):s>n.breakpoints[t]&&(o=n.breakpoints[t]));null!==o?null!==n.activeBreakpoint&&o===n.activeBreakpoint&&!e||(n.activeBreakpoint=o,"unslick"===n.breakpointSettings[o]?n.unslick(o):(n.options=d.extend({},n.originalSettings,n.breakpointSettings[o]),!0===i&&(n.currentSlide=n.options.initialSlide),n.refresh(i)),l=o):null!==n.activeBreakpoint&&(n.activeBreakpoint=null,n.options=n.originalSettings,!0===i&&(n.currentSlide=n.options.initialSlide),n.refresh(i),l=o),i||!1===l||n.$slider.trigger("breakpoint",[n,l])}},l.prototype.changeSlide=function(i,e){var t,o,s=this,n=d(i.currentTarget);switch(n.is("a")&&i.preventDefault(),n.is("li")||(n=n.closest("li")),t=s.slideCount%s.options.slidesToScroll!=0?0:(s.slideCount-s.currentSlide)%s.options.slidesToScroll,i.data.message){case"previous":o=0==t?s.options.slidesToScroll:s.options.slidesToShow-t,s.slideCount>s.options.slidesToShow&&s.slideHandler(s.currentSlide-o,!1,e);break;case"next":o=0==t?s.options.slidesToScroll:t,s.slideCount>s.options.slidesToShow&&s.slideHandler(s.currentSlide+o,!1,e);break;case"index":var l=0===i.data.index?0:i.data.index||n.index()*s.options.slidesToScroll;s.slideHandler(s.checkNavigable(l),!1,e),n.children().trigger("focus");break;default:return}},l.prototype.checkNavigable=function(i){var e=this.getNavigableIndexes(),t=0;if(i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},l.prototype.cleanUpEvents=function(){var i=this;i.options.autoplay&&i.options.useAutoplayToggleButton&&i.$pauseButton.off("click.slick",i.autoPlayToggleHandler),i.options.dots&&null!==i.$dots&&d("li",i.$dots).off("click.slick",i.changeSlide).off("mouseenter.slick",d.proxy(i.interrupt,i,!0)).off("mouseleave.slick",d.proxy(i.interrupt,i,!1)),i.$slider.off("focus.slick blur.slick"),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow&&i.$prevArrow.off("click.slick",i.changeSlide),i.$nextArrow&&i.$nextArrow.off("click.slick",i.changeSlide)),i.$list.off("touchstart.slick mousedown.slick",i.swipeHandler),i.$list.off("touchmove.slick mousemove.slick",i.swipeHandler),i.$list.off("touchend.slick mouseup.slick",i.swipeHandler),i.$list.off("touchcancel.slick mouseleave.slick",i.swipeHandler),i.$list.off("click.slick",i.clickHandler),d(document).off(i.visibilityChange,i.visibility),i.cleanUpSlideEvents(),d(window).off("orientationchange.slick.slick-"+i.instanceUid,i.orientationChange),d(window).off("resize.slick.slick-"+i.instanceUid,i.resize),d("[draggable!=true]",i.$slideTrack).off("dragstart",i.preventDefault),d(window).off("load.slick.slick-"+i.instanceUid,i.setPosition)},l.prototype.cleanUpSlideEvents=function(){var i=this;i.$list.off("mouseenter.slick",d.proxy(i.interrupt,i,!0)),i.$list.off("mouseleave.slick",d.proxy(i.interrupt,i,!1))},l.prototype.cleanUpRows=function(){var i;0<this.options.rows&&((i=this.$slides.children().children()).removeAttr("style"),this.$slider.empty().append(i))},l.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},l.prototype.destroy=function(i){var e=this;e.autoPlayClear(),e.touchObject={},e.cleanUpEvents(),d(".slick-cloned",e.$slider).detach(),e.options.autoplay&&e.options.useAutoplayToggleButton&&e.$pauseButton.remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.$prevArrow.length&&(e.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").prop("disabled",!1).css("display",""),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove()),e.$nextArrow&&e.$nextArrow.length&&(e.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").prop("disabled",!1).css("display",""),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove()),e.$slides&&(e.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){d(this).attr("style",d(this).data("originalStyling"))}),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.detach(),e.$list.detach(),e.$slider.append(e.$slides)),e.cleanUpRows(),e.$slider.removeClass("slick-slider"),e.$slider.removeClass("slick-initialized"),e.$slider.removeClass("slick-dotted"),e.unslicked=!0,i||e.$slider.trigger("destroy",[e])},l.prototype.disableTransition=function(i){var e={};e[this.transitionType]="",!1===this.options.fade?this.$slideTrack.css(e):this.$slides.eq(i).css(e)},l.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},l.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},l.prototype.filterSlides=l.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},l.prototype.focusHandler=function(){var t=this;t.$slider.off("focus.slick blur.slick").on("focus.slick","*",function(i){var e=d(this);setTimeout(function(){t.options.pauseOnFocus&&e.is(":focus")&&(t.focussed=!0,t.autoPlay())},0)}).on("blur.slick","*",function(i){d(this);t.options.pauseOnFocus&&(t.focussed=!1,t.autoPlay())})},l.prototype.getCurrent=l.prototype.slickCurrentSlide=function(){return this.currentSlide},l.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},l.prototype.getLeft=function(i){var e,t,o,s,n=this,l=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),l=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(l=i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,l=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(l=n.slideOffset=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+l,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},l.prototype.getOption=l.prototype.slickGetOption=function(i){return this.options[i]},l.prototype.getNavigableIndexes=function(){for(var i=this,e=0,t=0,o=[],s=!1===i.options.infinite?i.slideCount:(e=-1*i.options.slidesToScroll,t=-1*i.options.slidesToScroll,2*i.slideCount);e<s;)o.push(e),e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;return o},l.prototype.getSlick=function(){return this},l.prototype.getSlideCount=function(){var s,n=this,i=!0===n.options.centerMode?Math.floor(n.$list.width()/2):0,l=-1*n.swipeLeft+i;return!0===n.options.swipeToSlide?(n.$slideTrack.find(".slick-slide").each(function(i,e){var t=d(e).outerWidth(),o=e.offsetLeft;if(!0!==n.options.centerMode&&(o+=t/2),l<o+t)return s=e,!1}),Math.abs(d(s).attr("data-slick-index")-n.currentSlide)||1):n.options.slidesToScroll},l.prototype.goTo=l.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},l.prototype.init=function(i){var e=this;d(e.$slider).hasClass("slick-initialized")||(d(e.$slider).addClass("slick-initialized"),e.buildRows(),e.buildOut(),e.setProps(),e.startLoad(),e.loadSlider(),e.initializeEvents(),e.updateArrows(),e.updateDots(),e.checkResponsive(!0),e.focusHandler()),i&&e.$slider.trigger("init",[e]),e.options.autoplay&&(e.paused=!1,e.autoPlay()),e.updateSlideVisibility(),null!=e.options.accessibility&&console.warn("accessibility setting is no longer supported."),null!=e.options.focusOnChange&&console.warn("focusOnChange is no longer supported."),null!=e.options.focusOnSelect&&console.warn("focusOnSelect is no longer supported.")},l.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide))},l.prototype.initDotEvents=function(){var i=this;!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&d("li",i.$dots).on("click.slick",{message:"index"},i.changeSlide),!0===i.options.dots&&!0===i.options.pauseOnDotsHover&&i.slideCount>i.options.slidesToShow&&d("li",i.$dots).on("mouseenter.slick",d.proxy(i.interrupt,i,!0)).on("mouseleave.slick",d.proxy(i.interrupt,i,!1))},l.prototype.initSlideEvents=function(){var i=this;i.options.pauseOnHover&&(i.$list.on("mouseenter.slick",d.proxy(i.interrupt,i,!0)),i.$list.on("mouseleave.slick",d.proxy(i.interrupt,i,!1)))},l.prototype.initializeEvents=function(){var i=this;i.initArrowEvents(),i.initDotEvents(),i.initSlideEvents(),i.options.autoplay&&i.options.useAutoplayToggleButton&&i.$pauseButton.on("click.slick",i.autoPlayToggleHandler),i.$list.on("touchstart.slick mousedown.slick",{action:"start"},i.swipeHandler),i.$list.on("touchmove.slick mousemove.slick",{action:"move"},i.swipeHandler),i.$list.on("touchend.slick mouseup.slick",{action:"end"},i.swipeHandler),i.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},i.swipeHandler),i.$list.on("click.slick",i.clickHandler),d(document).on(i.visibilityChange,d.proxy(i.visibility,i)),d(window).on("orientationchange.slick.slick-"+i.instanceUid,d.proxy(i.orientationChange,i)),d(window).on("resize.slick.slick-"+i.instanceUid,d.proxy(i.resize,i)),d("[draggable!=true]",i.$slideTrack).on("dragstart",i.preventDefault),d(window).on("load.slick.slick-"+i.instanceUid,i.setPosition),d(i.setPosition)},l.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},l.prototype.lazyLoad=function(){var i,e,t,n=this;function o(i){d("img[data-lazy]",i).each(function(){var i=d(this),e=d(this).attr("data-lazy"),t=d(this).attr("data-srcset"),o=d(this).attr("data-sizes")||n.$slider.attr("data-sizes"),s=document.createElement("img");s.onload=function(){i.animate({opacity:0},100,function(){t&&(i.attr("srcset",t),o&&i.attr("sizes",o)),i.attr("src",e).animate({opacity:1},200,function(){i.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,i,e])})},s.onerror=function(){i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,i,e])},s.src=e})}if(!0===n.options.centerMode?t=!0===n.options.infinite?(e=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(e=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),n.options.slidesToShow/2+1+2+n.currentSlide):(e=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,t=Math.ceil(e+n.options.slidesToShow),!0===n.options.fade&&(0<e&&e--,t<=n.slideCount&&t++)),i=n.$slider.find(".slick-slide").slice(e,t),"anticipated"===n.options.lazyLoad)for(var s=e-1,l=t,r=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)s<0&&(s=n.slideCount-1),i=(i=i.add(r.eq(s))).add(r.eq(l)),s--,l++;o(i),n.slideCount<=n.options.slidesToShow?o(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?o(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&o(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},l.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},l.prototype.next=l.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},l.prototype.orientationChange=function(){this.checkResponsive(),this.setPosition()},l.prototype.pause=l.prototype.slickPause=function(){this.autoPlayClear(),this.paused=!0},l.prototype.play=l.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},l.prototype.postSlide=function(i){var e=this;e.unslicked||(e.$slider.trigger("afterChange",[e,i]),e.animating=!1,e.slideCount>e.options.slidesToShow&&e.setPosition(),e.swipeLeft=null,e.options.autoplay&&e.autoPlay(),e.updateSlideVisibility())},l.prototype.prev=l.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},l.prototype.preventDefault=function(i){i.preventDefault()},l.prototype.progressiveLazyLoad=function(i){i=i||1;var e,t,o,s,n,l=this,r=d("img[data-lazy]",l.$slider);r.length?(e=r.first(),t=e.attr("data-lazy"),o=e.attr("data-srcset"),s=e.attr("data-sizes")||l.$slider.attr("data-sizes"),(n=document.createElement("img")).onload=function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,e,t]),l.progressiveLazyLoad()},n.onerror=function(){i<3?setTimeout(function(){l.progressiveLazyLoad(i+1)},500):(e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,e,t]),l.progressiveLazyLoad())},n.src=t):l.$slider.trigger("allImagesLoaded",[l])},l.prototype.refresh=function(i){var e,t=this,o=t.slideCount-t.options.slidesToShow;!t.options.infinite&&t.currentSlide>o&&(t.currentSlide=o),t.slideCount<=t.options.slidesToShow&&(t.currentSlide=0),e=t.currentSlide,t.destroy(!0),d.extend(t,t.initials,{currentSlide:e}),t.init(),i||t.changeSlide({data:{message:"index",index:e}},!1)},l.prototype.registerBreakpoints=function(){var i,e,t,o=this,s=o.options.responsive||null;if("array"===d.type(s)&&s.length){for(i in o.respondTo=o.options.respondTo||"window",s)if(t=o.breakpoints.length-1,s.hasOwnProperty(i)){for(e=s[i].breakpoint;0<=t;)o.breakpoints[t]&&o.breakpoints[t]===e&&o.breakpoints.splice(t,1),t--;o.breakpoints.push(e),o.breakpointSettings[e]=s[i].settings}o.breakpoints.sort(function(i,e){return o.options.mobileFirst?i-e:e-i})}},l.prototype.reinit=function(){var i=this;i.$slides=i.$slideTrack.children(i.options.slide).addClass("slick-slide"),i.slideCount=i.$slides.length,i.currentSlide>=i.slideCount&&0!==i.currentSlide&&(i.currentSlide=i.currentSlide-i.options.slidesToScroll),i.slideCount<=i.options.slidesToShow&&(i.currentSlide=0),i.registerBreakpoints(),i.setProps(),i.setupInfinite(),i.buildArrows(),i.updateArrows(),i.initArrowEvents(),i.buildDots(),i.updateDots(),i.initDotEvents(),i.cleanUpSlideEvents(),i.initSlideEvents(),i.checkResponsive(!1,!0),i.setSlideClasses("number"==typeof i.currentSlide?i.currentSlide:0),i.setPosition(),i.focusHandler(),i.paused=!i.options.autoplay,i.autoPlay(),i.$slider.trigger("reInit",[i])},l.prototype.resize=function(){var i=this;d(window).width()!==i.windowWidth&&(clearTimeout(i.windowDelay),i.windowDelay=window.setTimeout(function(){i.windowWidth=d(window).width(),i.checkResponsive(),i.unslicked||i.setPosition()},50))},l.prototype.removeSlide=l.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},l.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled||(!(s={})===o.cssTransitions?s[o.animType]="translate("+e+", "+t+")":s[o.animType]="translate3d("+e+", "+t+", 0px)"),o.$slideTrack.css(s)},l.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},l.prototype.setFade=function(){var t,o=this;o.$slides.each(function(i,e){t=o.slideWidth*i*-1,!0===o.options.rtl?d(e).css({position:"relative",right:t,top:0,zIndex:o.options.zIndex-2,opacity:0}):d(e).css({position:"relative",left:t,top:0,zIndex:o.options.zIndex-2,opacity:0})}),o.$slides.eq(o.currentSlide).css({zIndex:o.options.zIndex-1,opacity:1})},l.prototype.setHeight=function(){var i,e=this;1===e.options.slidesToShow&&!0===e.options.adaptiveHeight&&!1===e.options.vertical&&(i=e.$slides.eq(e.currentSlide).outerHeight(!0),e.$list.css("height",i))},l.prototype.setOption=l.prototype.slickSetOption=function(){var i,e,t,o,s,n=this,l=!1;if("object"===d.type(arguments[0])?(t=arguments[0],l=arguments[1],s="multiple"):"string"===d.type(arguments[0])&&(o=arguments[1],l=arguments[2],"responsive"===(t=arguments[0])&&"array"===d.type(arguments[1])?s="responsive":void 0!==arguments[1]&&(s="single")),"single"===s)n.options[t]=o;else if("multiple"===s)d.each(t,function(i,e){n.options[i]=e});else if("responsive"===s)for(e in o)if("array"!==d.type(n.options.responsive))n.options.responsive=[o[e]];else{for(i=n.options.responsive.length-1;0<=i;)n.options.responsive[i].breakpoint===o[e].breakpoint&&n.options.responsive.splice(i,1),i--;n.options.responsive.push(o[e])}l&&(n.unload(),n.reinit())},l.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},l.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},l.prototype.setSlideClasses=function(i){var e,t,o,s,n=this,l=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true").attr("aria-label",function(){return d(this).attr("aria-label").replace(" (centered)","")});n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode?(o=n.options.slidesToShow%2==0?1:0,s=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(s<=i&&i<=n.slideCount-1-s?n.$slides.slice(i-s+o,i+s+1).addClass("slick-active").removeAttr("aria-hidden"):(e=n.options.slidesToShow+i,l.slice(e-s+1+o,e+s+2).addClass("slick-active").removeAttr("aria-hidden")),0===i?l.eq(n.options.slidesToShow+n.slideCount+1).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"}):i===n.slideCount-1&&l.eq(n.options.slidesToShow).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"})),n.$slides.eq(i).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"})):0<=i&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").removeAttr("aria-hidden"):l.length<=n.options.slidesToShow?l.addClass("slick-active").removeAttr("aria-hidden"):(t=n.slideCount%n.options.slidesToShow,e=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?l.slice(e-(n.options.slidesToShow-t),e+t).addClass("slick-active").removeAttr("aria-hidden"):l.slice(e,e+n.options.slidesToShow).addClass("slick-active").removeAttr("aria-hidden")),"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},l.prototype.setupInfinite=function(){var i,e,t,o=this;if(!0===o.options.fade&&(o.options.centerMode=!1),!0===o.options.infinite&&!1===o.options.fade&&(e=null,o.slideCount>o.options.slidesToShow)){for(t=!0===o.options.centerMode?o.options.slidesToShow+1:o.options.slidesToShow,i=o.slideCount;i>o.slideCount-t;--i)e=i-1,d(o.$slides[e]).clone(!0).attr("id","").attr("data-slick-index",e-o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");for(i=0;i<t+o.slideCount;i+=1)e=i,d(o.$slides[e]).clone(!0).attr("id","").attr("data-slick-index",e+o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");o.$slideTrack.find(".slick-cloned").find("[id]").each(function(){d(this).attr("id","")})}},l.prototype.interrupt=function(i){i||this.autoPlay(),this.interrupted=i},l.prototype.selectHandler=function(i){var e=d(i.target).is(".slick-slide")?d(i.target):d(i.target).parents(".slick-slide"),t=(t=parseInt(e.attr("data-slick-index")))||0;this.slideCount<=this.options.slidesToShow?this.slideHandler(t,!1,!0):this.slideHandler(t)},l.prototype.slideHandler=function(i,e,t){var o,s,n,l,r,a,d=this;if(e=e||!1,!(!0===d.animating&&!0===d.options.waitForAnimate||!0===d.options.fade&&d.currentSlide===i))if(!1===e&&d.asNavFor(i),o=i,r=d.getLeft(o),l=d.getLeft(d.currentSlide),d.currentLeft=null===d.swipeLeft?l:d.swipeLeft,!1===d.options.infinite&&!1===d.options.centerMode&&(i<0||i>d.getDotCount()*d.options.slidesToScroll))!1===d.options.fade&&(o=d.currentSlide,!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(l,function(){d.postSlide(o)}):d.postSlide(o));else if(!1===d.options.infinite&&!0===d.options.centerMode&&(i<0||i>d.slideCount-d.options.slidesToScroll))!1===d.options.fade&&(o=d.currentSlide,!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(l,function(){d.postSlide(o)}):d.postSlide(o));else{if(d.options.autoplay&&clearInterval(d.autoPlayTimer),s=o<0?d.slideCount%d.options.slidesToScroll!=0?d.slideCount-d.slideCount%d.options.slidesToScroll:d.slideCount+o:o>=d.slideCount?d.slideCount%d.options.slidesToScroll!=0?0:o-d.slideCount:o,d.animating=!0,d.$slider.trigger("beforeChange",[d,d.currentSlide,s]),n=d.currentSlide,d.currentSlide=s,d.setSlideClasses(d.currentSlide),d.options.asNavFor&&(a=(a=d.getNavTarget()).slick("getSlick")).slideCount<=a.options.slidesToShow&&a.setSlideClasses(d.currentSlide),d.updateDots(),d.updateArrows(),!0===d.options.fade)return!0!==t?(d.fadeSlideOut(n),d.fadeSlide(s,function(){d.postSlide(s)})):d.postSlide(s),void d.animateHeight();!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(r,function(){d.postSlide(s)}):d.postSlide(s)}},l.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},l.prototype.swipeDirection=function(){var i=this,e=i.touchObject.startX-i.touchObject.curX,t=i.touchObject.startY-i.touchObject.curY,o=Math.atan2(t,e),s=Math.round(180*o/Math.PI);return s<0&&(s=360-Math.abs(s)),s<=45&&0<=s||s<=360&&315<=s?!1===i.options.rtl?"left":"right":135<=s&&s<=225?!1===i.options.rtl?"right":"left":!0===i.options.verticalSwiping?35<=s&&s<=135?"down":"up":"vertical"},l.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1;if(o.interrupted=!1,o.shouldClick=!(10<o.touchObject.swipeLength),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},l.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},l.prototype.swipeMove=function(i){var e,t,o,s,n,l=this,r=void 0!==i.originalEvent?i.originalEvent.touches:null;return!(!l.dragging||l.scrolling||r&&1!==r.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==r?r[0].pageX:i.clientX,l.touchObject.curY=void 0!==r?r[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),n=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&4<n?!(l.scrolling=!0):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=n),t=l.swipeDirection(),void 0!==i.originalEvent&&4<l.touchObject.swipeLength&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,(l.touchObject.edgeHit=!1)===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},l.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return!(t.touchObject={});void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},l.prototype.unfilterSlides=l.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},l.prototype.unload=function(){var i=this;d(".slick-cloned",i.$slider).remove(),i.$dots&&i.$dots.remove(),i.$prevArrow&&i.htmlExpr.test(i.options.prevArrow)&&i.$prevArrow.remove(),i.$nextArrow&&i.htmlExpr.test(i.options.nextArrow)&&i.$nextArrow.remove(),i.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},l.prototype.unslick=function(i){this.$slider.trigger("unslick",[this,i]),this.destroy()},l.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2);!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").prop("disabled",!1),i.$nextArrow.removeClass("slick-disabled").prop("disabled",!1),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").prop("disabled",!0),i.$nextArrow.removeClass("slick-disabled").prop("disabled",!1)):(i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode||i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode)&&(i.$nextArrow.addClass("slick-disabled").prop("disabled",!0),i.$prevArrow.removeClass("slick-disabled").prop("disabled",!1)))},l.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").find("button").removeAttr("aria-current").end().end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active").find("button").attr("aria-current",!0).end().end())},l.prototype.updateSlideVisibility=function(){this.$slideTrack.find(".slick-slide").attr("aria-hidden","true").find("a, input, button, select").attr("tabindex","-1"),this.$slideTrack.find(".slick-active").removeAttr("aria-hidden").find("a, input, button, select").removeAttr("tabindex")},l.prototype.visibility=function(){this.options.autoplay&&(document[this.hidden]?this.interrupted=!0:this.interrupted=!1)},d.fn.slick=function(){for(var i,e=this,t=arguments[0],o=Array.prototype.slice.call(arguments,1),s=e.length,n=0;n<s;n++)if("object"==typeof t||void 0===t?e[n].slick=new l(e[n],t):i=e[n].slick[t].apply(e[n].slick,o),void 0!==i)return i;return e}});

/**
 * jQuery FocusPoint; version: 1.1.3
 * Author: http://jonathonmenz.com
 * Source: https://github.com/jonom/jquery-focuspoint
 * Copyright (c) 2014 J. Menz; MIT License
 */
!function($){var t={reCalcOnWindowResize:!0,throttleDuration:17},n=function(t){var n=t.find("img").attr("src");t.data("imageSrc",n),i(n,function(n,i){t.data({imageW:i.width,imageH:i.height}),r(t)})},i=function(t,n){$("<img />").one("load",function(){n(null,{width:this.width,height:this.height})}).attr("src",t)},a=function(t,n){var i=!1;return function(){var a=Array.prototype.slice.call(arguments,0);if(i)return!1;i=!0,setTimeout(function(){i=!1,t.apply(null,a)},n)}},o=function(t,n,i,a,o){var r=Math.floor(n/2),e=(a+1)/2,u=Math.floor(i/t),f=Math.floor(e*u);o&&(f=u-f);var c=f-r,s=u-f,h=n-r;return s<h&&(c-=h-s),c<0&&(c=0),-100*c/n+"%"},r=function(t){var i=t.data("imageW"),a=t.data("imageH"),r=t.data("imageSrc");if(!i&&!a&&!r)return n(t);var e=t.width(),u=t.height(),f=parseFloat(t.data("focusX")),c=parseFloat(t.data("focusY")),s=t.find("img").first(),h=0,d=0;if(!(e>0&&u>0&&i>0&&a>0))return!1;var l=i/e,w=a/u;s.css({"max-width":"","max-height":""}),i>e&&a>u&&s.css(l>w?"max-height":"max-width","100%"),l>w?h=o(w,e,i,f):l<w&&(d=o(l,u,a,c,!0)),s.css({top:d,left:h})},e=$(window),u=function(t,n){var i=n.throttleDuration?a(function(){r(t)},n.throttleDuration):function(){r(t)},o=!1;return r(t),{adjustFocus:function(){return r(t)},windowOn:function(){if(!o)return e.on("resize",i),o=!0},windowOff:function(){if(o)return e.off("resize",i),o=!1,!0}}};$.fn.focusPoint=function(n){if("string"==typeof n)return this.each(function(){$(this).data("focusPoint")[n]()});var i=$.extend({},t,n);return this.each(function(){var t=$(this),n=u(t,i);t.data("focusPoint")&&t.data("focusPoint").windowOff(),t.data("focusPoint",n),i.reCalcOnWindowResize&&n.windowOn()})},$.fn.adjustFocus=function(){return this.each(function(){r($(this))})}}(jQuery);

/**
 * jQuery CountUp
 */
function formatter(t,e){return t.toFixed(e.decimals)}$.fn.countTo=function(t){return t=t||{},$(this).each(function(){var e=$.extend({},$.fn.countTo.defaults,{from:$(this).data("from"),to:$(this).data("to"),speed:$(this).data("speed"),refreshInterval:$(this).data("refresh-interval"),decimals:$(this).data("decimals")},t),a=Math.ceil(e.speed/e.refreshInterval),o=(e.to-e.from)/a,n=this,r=$(this),l=0,s=e.from,f=r.data("countTo")||{};function i(t){var a=e.formatter.call(n,t,e);r.hasClass("Percent")?r.html(a+"%"):r.hasClass("Dollar")?r.html("$"+a):r.html(a)}r.data("countTo",f),f.interval&&clearInterval(f.interval),f.interval=setInterval(function t(){s+=o,l++,i(s),"function"==typeof e.onUpdate&&e.onUpdate.call(n,s),l>=a&&(r.removeData("countTo"),clearInterval(f.interval),s=e.to,"function"==typeof e.onComplete&&e.onComplete.call(n,s))},e.refreshInterval),i(s)})},$.fn.countTo.defaults={from:0,to:0,speed:500,refreshInterval:100,decimals:0,formatter:formatter,onUpdate:null,onComplete:null};

/* aos */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AOS=t():e.AOS=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="dist/",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},r=n(1),a=(o(r),n(6)),u=o(a),c=n(7),f=o(c),s=n(8),d=o(s),l=n(9),p=o(l),m=n(10),b=o(m),v=n(11),y=o(v),g=n(14),h=o(g),w=[],k=!1,x={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded",throttleDelay:99,debounceDelay:50,disableMutationObserver:!1},j=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e&&(k=!0),k)return w=(0,y.default)(w,x),(0,b.default)(w,x.once),w},O=function(){w=(0,h.default)(),j()},_=function(){w.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay")})},S=function(e){return e===!0||"mobile"===e&&p.default.mobile()||"phone"===e&&p.default.phone()||"tablet"===e&&p.default.tablet()||"function"==typeof e&&e()===!0},z=function(e){x=i(x,e),w=(0,h.default)();var t=document.all&&!window.atob;return S(x.disable)||t?_():(document.querySelector("body").setAttribute("data-aos-easing",x.easing),document.querySelector("body").setAttribute("data-aos-duration",x.duration),document.querySelector("body").setAttribute("data-aos-delay",x.delay),"DOMContentLoaded"===x.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?j(!0):"load"===x.startEvent?window.addEventListener(x.startEvent,function(){j(!0)}):document.addEventListener(x.startEvent,function(){j(!0)}),window.addEventListener("resize",(0,f.default)(j,x.debounceDelay,!0)),window.addEventListener("orientationchange",(0,f.default)(j,x.debounceDelay,!0)),window.addEventListener("scroll",(0,u.default)(function(){(0,b.default)(w,x.once)},x.throttleDelay)),x.disableMutationObserver||(0,d.default)("[data-aos]",O),w)};e.exports={init:z,refresh:j,refreshHard:O}},function(e,t){},,,,,function(e,t){(function(t){"use strict";function n(e,t,n){function o(t){var n=b,o=v;return b=v=void 0,k=t,g=e.apply(o,n)}function r(e){return k=e,h=setTimeout(s,t),_?o(e):g}function a(e){var n=e-w,o=e-k,i=t-n;return S?j(i,y-o):i}function c(e){var n=e-w,o=e-k;return void 0===w||n>=t||n<0||S&&o>=y}function s(){var e=O();return c(e)?d(e):void(h=setTimeout(s,a(e)))}function d(e){return h=void 0,z&&b?o(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),k=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(O())}function m(){var e=O(),n=c(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(s,t),o(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,k=0,_=!1,S=!1,z=!0;if("function"!=typeof e)throw new TypeError(f);return t=u(t)||0,i(n)&&(_=!!n.leading,S="maxWait"in n,y=S?x(u(n.maxWait)||0,t):y,z="trailing"in n?!!n.trailing:z),m.cancel=l,m.flush=p,m}function o(e,t,o){var r=!0,a=!0;if("function"!=typeof e)throw new TypeError(f);return i(o)&&(r="leading"in o?!!o.leading:r,a="trailing"in o?!!o.trailing:a),n(e,t,{leading:r,maxWait:t,trailing:a})}function i(e){var t="undefined"==typeof e?"undefined":c(e);return!!e&&("object"==t||"function"==t)}function r(e){return!!e&&"object"==("undefined"==typeof e?"undefined":c(e))}function a(e){return"symbol"==("undefined"==typeof e?"undefined":c(e))||r(e)&&k.call(e)==d}function u(e){if("number"==typeof e)return e;if(a(e))return s;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(l,"");var n=m.test(e);return n||b.test(e)?v(e.slice(2),n?2:8):p.test(e)?s:+e}var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},f="Expected a function",s=NaN,d="[object Symbol]",l=/^\s+|\s+$/g,p=/^[-+]0x[0-9a-f]+$/i,m=/^0b[01]+$/i,b=/^0o[0-7]+$/i,v=parseInt,y="object"==("undefined"==typeof t?"undefined":c(t))&&t&&t.Object===Object&&t,g="object"==("undefined"==typeof self?"undefined":c(self))&&self&&self.Object===Object&&self,h=y||g||Function("return this")(),w=Object.prototype,k=w.toString,x=Math.max,j=Math.min,O=function(){return h.Date.now()};e.exports=o}).call(t,function(){return this}())},function(e,t){(function(t){"use strict";function n(e,t,n){function i(t){var n=b,o=v;return b=v=void 0,O=t,g=e.apply(o,n)}function r(e){return O=e,h=setTimeout(s,t),_?i(e):g}function u(e){var n=e-w,o=e-O,i=t-n;return S?x(i,y-o):i}function f(e){var n=e-w,o=e-O;return void 0===w||n>=t||n<0||S&&o>=y}function s(){var e=j();return f(e)?d(e):void(h=setTimeout(s,u(e)))}function d(e){return h=void 0,z&&b?i(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),O=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(j())}function m(){var e=j(),n=f(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(s,t),i(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,O=0,_=!1,S=!1,z=!0;if("function"!=typeof e)throw new TypeError(c);return t=a(t)||0,o(n)&&(_=!!n.leading,S="maxWait"in n,y=S?k(a(n.maxWait)||0,t):y,z="trailing"in n?!!n.trailing:z),m.cancel=l,m.flush=p,m}function o(e){var t="undefined"==typeof e?"undefined":u(e);return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==("undefined"==typeof e?"undefined":u(e))}function r(e){return"symbol"==("undefined"==typeof e?"undefined":u(e))||i(e)&&w.call(e)==s}function a(e){if("number"==typeof e)return e;if(r(e))return f;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=p.test(e);return n||m.test(e)?b(e.slice(2),n?2:8):l.test(e)?f:+e}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c="Expected a function",f=NaN,s="[object Symbol]",d=/^\s+|\s+$/g,l=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,m=/^0o[0-7]+$/i,b=parseInt,v="object"==("undefined"==typeof t?"undefined":u(t))&&t&&t.Object===Object&&t,y="object"==("undefined"==typeof self?"undefined":u(self))&&self&&self.Object===Object&&self,g=v||y||Function("return this")(),h=Object.prototype,w=h.toString,k=Math.max,x=Math.min,j=function(){return g.Date.now()};e.exports=n}).call(t,function(){return this}())},function(e,t){"use strict";function n(e,t){var n=window.document,r=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver,a=new r(o);i=t,a.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}function o(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),n=Array.prototype.slice.call(e.removedNodes),o=t.concat(n).filter(function(e){return e.hasAttribute&&e.hasAttribute("data-aos")}).length;o&&i()})}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){};t.default=n},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(){return navigator.userAgent||navigator.vendor||window.opera||""}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,u=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,c=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,f=function(){function e(){n(this,e)}return i(e,[{key:"phone",value:function(){var e=o();return!(!r.test(e)&&!a.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=o();return!(!u.test(e)&&!c.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),e}();t.default=new f},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t,n){var o=e.node.getAttribute("data-aos-once");t>e.position?e.node.classList.add("aos-animate"):"undefined"!=typeof o&&("false"===o||!n&&"true"!==o)&&e.node.classList.remove("aos-animate")},o=function(e,t){var o=window.pageYOffset,i=window.innerHeight;e.forEach(function(e,r){n(e,i+o,t)})};t.default=o},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(12),r=o(i),a=function(e,t){return e.forEach(function(e,n){e.node.classList.add("aos-init"),e.position=(0,r.default)(e.node,t.offset)}),e};t.default=a},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(13),r=o(i),a=function(e,t){var n=0,o=0,i=window.innerHeight,a={offset:e.getAttribute("data-aos-offset"),anchor:e.getAttribute("data-aos-anchor"),anchorPlacement:e.getAttribute("data-aos-anchor-placement")};switch(a.offset&&!isNaN(a.offset)&&(o=parseInt(a.offset)),a.anchor&&document.querySelectorAll(a.anchor)&&(e=document.querySelectorAll(a.anchor)[0]),n=(0,r.default)(e).top,a.anchorPlacement){case"top-bottom":break;case"center-bottom":n+=e.offsetHeight/2;break;case"bottom-bottom":n+=e.offsetHeight;break;case"top-center":n+=i/2;break;case"bottom-center":n+=i/2+e.offsetHeight;break;case"center-center":n+=i/2+e.offsetHeight/2;break;case"top-top":n+=i;break;case"bottom-top":n+=e.offsetHeight+i;break;case"center-top":n+=e.offsetHeight/2+i}return a.anchorPlacement||a.offset||isNaN(t)||(o=t),n+o};t.default=a},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}};t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){return e=e||document.querySelectorAll("[data-aos]"),Array.prototype.map.call(e,function(e){return{node:e}})};t.default=n}])});

// GLOBAL VARIABLES
var $window = $(window),
	$body = $('body');

function windowSize() {
	'use strict';

	var w = Math.max($window.width(), window.innerWidth),
		type = 'Default';

	if (w >= 1441) {
		type = 'XL';
	} else if (w < 1441 && w >= 1281) {
		type = 'Large';
	} else if (w < 1281 && w >= 1024) {
		type = 'Medium';
	} else if (w < 1024 && w >= 440) {
		type = 'Small';
	} else {
		type = 'Default';
	}

	// change the css file of the tag with id="stl" and rel="stylesheet"
	$body.removeClass('XL Large Medium Small Default').addClass(type);
}

function isAndroidDevice() {
	//check for android device
	if (/Android/i.test(navigator.userAgent)) {
		return true;
	} else {
		return false;
	}
}

function alertPanel() {
	/* Site Search Modaal */
	if($('.modaal-alert').length) {
		$('.modaal-alert').modaal({
			content_source: '#modaal-alert'
		});
	}
	/* Show Alert Panel if Cookie 'AlertPanel' does not exist yet */
	/*	
		Alert Panel - As long as a panel called "Alert-Panel" exists and it has a class of 'ShowPanel',
		the alert will show on all pages the first time an user hits the site no mattter what page 
		they are on. Once the alert is closed by the user, a cookie will be set and it will not show 
		the alert on subsequent pages until the session has expired (the browser is closed) and the 
		site is viewed again. 
	*/
	// if (!$.cookie('AlertPanel')) {
	// 	$('#AlertPanel .cmspanel').show();
	// }
	// /* 'Add-Alert-Close-Button' Option for Alert Panel */
	// if ($('#AlertPanel .cmspanel .Add-Alert-Close-Button').length) {
	// 	$('#AlertPanel .cmspanel .BasicPanel').append('<button type="button" class="closebtn"><span class="close-icon"></span><span class="sr-only">Close Alert for Session Duration</span></button>');
	// 	$('#AlertPanel .cmspanel').on('click', 'button.closebtn', function() {
	// 		// Set the opacity of div to 0 (transparent)
	// 		$('#AlertPanel .cmspanel').css('opacity','0');
	// 		// Hide the div after 600ms (the same amount of milliseconds it takes to fade out)
	// 		setTimeout(function(){ $('#AlertPanel .cmspanel').css('display','none'); }, 600);
	// 		$.cookie("AlertPanel", "closed", { path: '/' });
	// 	});
	// }
}

// function header01() {
// 	if ($('.accordion.MobileMenuTabs').length) {
// 		/* show/hide mouse functionality */
// 		$('.accordion.MobileMenuTabs').on('click', '.tablist button.toggle', function () {
// 			var activeTab = $(this).attr('id');

// 			if ($(this).attr('aria-expanded') === 'true') { // this tab is already opened, let's close it
            
// 				// Remove active state from all the buttons
// 				$('.accordion.MobileMenuTabs > .tablist button.toggle').removeClass('Active').attr({
// 					'aria-expanded': 'false',
// 					'tabindex': '-1'
// 				});

// 				// keep focus on this button
// 				$(this).attr('tabindex', '0').trigger('focus');

// 				// Hide all the tab panels 
// 				$(this).parents('.accordion.MobileMenuTabs').find('.listitem').attr({
// 					'aria-hidden': 'true',
// 					'tabindex': '-1'
// 				}).hide();

// 				return false;
// 			} else {
// 				// Remove active state from all the buttons
// 				$('.accordion.MobileMenuTabs > .tablist button.toggle').removeClass('Active').attr({
// 					'aria-expanded': 'false',
// 					'tabindex': '-1'
// 				});

// 				// apply active state to selected button
// 				$(this).attr({
// 					'aria-expanded': 'true',
// 					'tabindex': '0'
// 				}).addClass('Active');

// 				// Hide all the tab panels 
// 				$(this).parents('.accordion.MobileMenuTabs').find('.listitem').attr({
// 					// 'aria-expanded': 'false',
// 					'aria-hidden': 'true',
// 					'tabindex': '-1'
// 				}).hide();

// 				// Activate the correct tab panel
// 				$('[aria-labelledby="' + activeTab + '"]').attr({
// 					'aria-hidden': 'false',
// 					'tabindex': '0'
// 				}).show();

// 				return false;
// 			}
// 		});

// 		/* Keyboard Codes
//             9 = tab
//             13 = enter
//             16 = shift
//             32 = space bar
//             37 = left arrow
//             38 = up arrow
//             39 = right arrow
//             40 = down arrow
//         */

// 		/* show/hide keyboard functionality */
// 		$('.accordion.MobileMenuTabs > .tablist button.toggle').on('keydown', function (e) {
// 			// enter or space
// 			if ((e.which === 13) || (e.which === 32)) {
// 				//console.log("Enter or space bar pressed");
// 				$(this).trigger('click');
// 				return false;
// 			} else if (e.altKey) {
// 				// do nothing
// 				return true;
// 			} else if ((e.which === 37) || (e.which === 38)) {
// 				//console.log("left arrow or up arrow pressed");
// 				if ($(this).is(':first-child')) {
// 					// loop to last child
// 					$(this).parent().find('button.toggle:last-child').trigger('focus');
// 				} else {
// 					$(this).prev('button.toggle').trigger('focus');
// 				}
// 				return false;
// 			} else if ((e.which === 39) || (e.which === 40)) {
// 				//console.log("right arrow or down arrow pressed");
// 				if ($(this).is(':last-child')) {
// 					// loop back to first button
// 					$(this).parent().find('button.toggle:first-child').trigger('focus');
// 				} else {
// 					$(this).next('button.toggle').trigger('focus');
// 				}
// 				return false;
// 			}
// 		});
// 	}
// }

// function header01_AlsoOnResize() {
// 	$('body.Small, body.Default').each(function () {
// 		$('#MainNavWrap').prependTo('#HeaderTop .MobileMenuTabs .content.Menu .NavContent');
// 		$('#SecondaryNavWrap').appendTo('#HeaderTop .MobileMenuTabs .content.Menu .NavContent');
// 		$('#GeolocationControl').appendTo('#HeaderTop .MobileMenuTabs .content.Menu .NavContent');

// 		// change mobile menu back into a tabpanel if they haven't been turned back already
// 		if ($('.accordion.MobileMenuTabs').hasClass('desktop-tabs')) {
// 			// If formated for desktop, reapply all the attributes that make this a tab container on mobile 
// 			// Add tabindex to the entire "tabpanel" to allow the correct panel to get focus
// 			$('.accordion.MobileMenuTabs > .listitem ').attr({
// 				'aria-hidden': 'true',
// 				'tabindex': '0'
// 			}).hide();

// 			// reset the buttons
// 			$('.accordion.MobileMenuTabs > .tablist > button.toggle ').attr({
// 				'aria-expanded': 'false',
// 			}).removeAttr('aria-disabled disabled');

// 			// Allow the first button to get focus
// 			$('.accordion.MobileMenuTabs > .tablist > button.toggle:first-child ').attr('tabindex', '0');

// 			// Re-add the aria-labelledby attribute
// 			var accordionCount = 0;
// 			$('.accordion.MobileMenuTabs > .tablist button.toggle').each(function () {
// 				var listItemCount = accordionCount + 1;
// 				$('.accordion.MobileMenuTabs').find('.listitem').eq(accordionCount).attr({
// 					'aria-labelledby': 'menu-accordion-' + listItemCount,
// 				});
// 				accordionCount++;
// 			});

// 			// Set Class Names Correctly
// 			$('.accordion.MobileMenuTabs').removeClass('desktop-tabs');
// 		}
// 	});

// 	$('body.XL, body.Large, body.Medium').each(function () {
// 		$('#MainNavWrap').appendTo('#MainNavWrap2');
// 		$('#GeolocationControl').prependTo('#HeaderTop .MobileMenuTabs .content.Search .NavContent');
// 		$('#SecondaryNavWrap').insertAfter('#HeaderTop .MobileMenuTabs .content.Search #GeolocationControl');

// 		// Change mobile menu to be regular divs and not a tabpanel

// 		// Show all tabs on Desktop
// 		// Remove all the attributes that make this tab container on mobile since it no longer functions as a tab container
// 		// Remove tabindex so the entire "tabpanel" does NOT get focus, and instead each individual element gets focus
// 		// Remove aria-labelledby because the item the labelled by is referring to is no longer visible in the DOM (hidden with CSS)
// 		// Remove aria-hidden because these are now visible on desktop
// 		$('.accordion.MobileMenuTabs > .listitem').removeAttr('tabindex aria-labelledby aria-hidden').show();

// 		// Hide all the buttons/triggers on desktop
// 		// .tablist is set to display:none in the style sheet for large breakpoints
// 		$('.accordion.MobileMenuTabs > .tablist button.toggle ').attr({
// 			'tabindex': '-1', // Never give these buttons focus
// 			'aria-disabled': true, // tell screen readers these buttons are disabled, just in case a screen reader whould ever get to these elements
// 			'disabled': 'disabled' // actually disable the functionality of these buttons
// 		}).removeClass('Active'); // if the button is active - remove active class

// 		$('.accordion.MobileMenuTabs').addClass('desktop-tabs');
// 	});
// }

function header02() {
	/* Adding Search Icon to Main Nav */
	$('#MainNav > ul').append('<li class="SearchItem"><button class="modaal-search" aria-controls="modaal-search" type="button"><span>Search</span></button></li>');

	/* Site Search Modaal */
	if($('.modaal-search').length) {
		$('.modaal-search').modaal({
			content_source: '#modaal-search'
		});
	}
	/* Setting nav absolute only if banner panel exists */
	if ($('#Banner > .cmspanel').length) {
		$('#MainNavWrap2 #MainNavWrap').addClass('AbsoluteNav');
	}
	/* Mobile Navigation */
	$('.CustomToggles').each(function () {
		// create variables to use for the triggers and payloads
		var $CT = $(this),
			$triggers = $CT.find('.Triggers>li'),
			$payloads = $CT.find('.Payloads>li');

		// loop thru the triggers - using "i" as the counter, you can associate the tigger with the payload
		$triggers.each(function (i, trigger) {

			// clicking a trigger will slide up all payloads and will only slide down
			// if the associated payload wasn't the one you triggered
			$(trigger).not('.DontOpen').on('click', function () {
				$triggers.removeClass('Active');

				if ($payloads.eq(i).is(':hidden')) {
					$payloads.slideUp();
					// slide down the associated payload
					// .slideDown(1000) is 1 second
					// .slideDown(1000, function(){ do.something })
					// do.something happens after the slideDown command is finished.
					// zIndexTop is a class to make sure that the one you
					// clicked on is always sliding over the others.
					$payloads.eq(i).addClass('zIndexTop').slideDown(300, function () {
						$(this).removeClass('zIndexTop');
						$triggers.eq(i).addClass('Active');
					});
				} else {
					$payloads.slideUp();
				}
			});
		});
	});
	$('#HeaderTop').on('click', 'button.Menu', function () {
		$('.NavContent').slideToggle();
		$(this).toggleClass('Active');
		if($('button.Menu.Active').length) {
			$('.NavContent').attr('aria-hidden', 'false');
			$(this).attr('aria-expanded', 'true');
		} else {
			$('.NavContent').attr('aria-hidden', 'true');
			$(this).attr('aria-expanded', 'false');
		}
		return false;
	});
}

function header02_AlsoOnResize() {
	$('body.Small, body.Default').each(function() {
		$('#MainNavWrap').insertBefore('#HeaderTop .NavContent #SecondaryNavWrap');
		$('#GeolocationControl').appendTo('#HeaderTop .NavContent');
		if ($('button.Menu').attr('aria-expanded') === "true") {
			$('#NavContent').attr('aria-hidden', 'false').show();
		} else {
			$('#NavContent').attr('aria-hidden', 'true');
		}
	});
	$('body.XL, body.Large, body.Medium').each(function() {
		$('#MainNavWrap').appendTo('#MainNavWrap2');
		$('.NavContent').removeAttr('style').removeAttr('aria-hidden');
		$('#GeolocationControl').insertAfter('#HeaderTop .NavContent #modaal-search');
	});
}

function header03() {
	// adding expand buttons via js so that it doesn't show if js is disabled or if there is not an unordered list.
	if ($('#HeaderTop #NavPanel #SecondaryNavWrap .cmspanel ul').length) {
		$('#Logo').append('<button id="MenuToggle" aria-expanded="false" aria-controls="MenuContent" class="toggle Menu" type="button"><span class="Icon"></span><span class="Text">Menu</span></button>');
		$('#HeaderTop #NavPanel #SecondaryNavWrap').wrap('<div id="MenuContent" class="NavContent"></div>');
		// $('#Logo').addClass('LeftOnMobile');
	}
	// Drop Downs for Mobile
	$('#Logo').on('click', '#MenuToggle', function () {
		$('#MenuContent').slideToggle();
		$(this).toggleClass('Active');
		if($('#MenuToggle.Active').length) {
			$('#MenuContent').attr('aria-hidden', 'false');
			$(this).attr('aria-expanded', 'true');
		} else {
			$('#MenuContent').attr('aria-hidden', 'true');
			$(this).attr('aria-expanded', 'false');
		}
		return false;
	});
}

function header03_AlsoOnResize() {
	$('body.Small, body.Default').each(function() {
		if ($('button#MenuToggle').attr('aria-expanded') === "true") {
			$('#MenuContent').attr('aria-hidden', 'false').show();
		} else {
			$('#MenuContent').attr('aria-hidden', 'true');
		}
	});
	$('body.XL, body.Large, body.Medium').each(function() {
		$('#MenuContent').removeAttr('style').removeAttr('aria-hidden');
	});
}

function header04() {
	$('#HeaderTop').on('click', 'button.Menu', function () {
		$('.NavContent').slideToggle();
		$(this).toggleClass('Active');
		if($('button.Menu.Active').length) {
			$('.NavContent').attr('aria-hidden', 'false');
			$(this).attr('aria-expanded', 'true');
		} else {
			$('.NavContent').attr('aria-hidden', 'true');
			$(this).attr('aria-expanded', 'false');
		}
		return false;
	});
}

function header04_AlsoOnResize() {
	$('body.Small, body.Default').each(function() {
		$('#MainNavWrap').appendTo('#HeaderTop .NavContent');
		$('#HeaderRight > .cmspanel').prependTo('#HeaderTop .NavContent');
		if ($('button.Menu').attr('aria-expanded') === "true") {
			$('#NavContent').attr('aria-hidden', 'false').show();
		} else {
			$('#NavContent').attr('aria-hidden', 'true');
		}
	});
	$('body.XL, body.Large, body.Medium').each(function() {
		$('#MainNavWrap').appendTo('#MainNavWrap2');
		$('#HeaderTop .NavContent > .cmspanel').appendTo('#HeaderRight');
		$('.NavContent').removeAttr('style').removeAttr('aria-hidden');
	});
}

function header05() {
	/* Adding Search Icon to Main Nav
    ----------------------------------------------------------------- */
	// $('#MainNav > ul').append('<li class="SearchItem"><button class="Search-Button" aria-controls="modaal-search" aria-expanded="false" type="button"><span class="sr-only">Search Site</span></button></li>');

	/* Nav Button & Search Button Functionality
    ----------------------------------------------------------------- */
	$(".Nav-Button").on("click", function() {
		if ($('.HasDropdown.Open').length) {
			$('.HasDropdown.Open button.CloseButton').trigger('click');
		}
		$body.addClass('NoScroll');
		$('.NavButtonWrap').appendTo('#Overlay-Top');
		$('#MyChartWrap').appendTo('#Overlay-Top');
		$('#MainNavWrap').appendTo('#Overlay-MainNav');
		$('#SecondaryNavWrap').appendTo('#Overlay-SecondaryNav');
		$('#NavSlide').toggleClass('OpenSlide CloseSlide').attr('aria-hidden', 'false');
		$('.Nav-Button').attr('aria-expanded', 'true');
		//$('#SecondaryNavWrap').appendTo('#Overlay-SecondaryNav');
		$('#HeaderTop > #LeftTopWrap').appendTo('#NavSlide .Logo-Placeholder');
		//$('#GeolocationControl').show();
		
		// Set focus to Overlay-Content when NavSlide has OpenSlide class
		if ($('#NavSlide').hasClass('OpenSlide')) {
			$('#NavSlide .Nav-Button-Close').attr('tabindex', '-1').focus();
		}
    });
	$(".Nav-Button-Close").on("click", function() {
		$('.Nav-Button').attr('aria-expanded', 'false');
		$('#NavSlide').toggleClass('OpenSlide CloseSlide').attr('aria-hidden', 'true');
		setTimeout(function() { 
			$('#NavSlide .Logo-Placeholder #LeftTopWrap').prependTo('#HeaderTop');
				$('#SecondaryNavWrap').insertAfter('#AlertPanel');
			$('#MainNavWrap').appendTo('#NavContent');
			$('#MyChartWrap').prependTo('#HeaderTopRight');
			$('.NavButtonWrap').appendTo('#MainNavWrap');
		}, 60);
		$body.removeClass('NoScroll');
		//$('#GeolocationControl').hide();
	});
	
	// Trap focus within NavSlide and close when tabbing past last element
	$('#NavSlide').on('keydown', function(e) {
		if (e.keyCode === 9 && $(this).hasClass('OpenSlide')) {
			var $focusable = $(this).find('a, input, button, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
			var $firstFocusable = $focusable.first();
			var $lastFocusable = $focusable.last();
			
			// Shift+Tab on first element - close NavSlide
			if (e.shiftKey && document.activeElement === $firstFocusable[0]) {
				e.preventDefault();
				$('.Nav-Button-Close').trigger('click');
				$('.Nav-Button').focus();
			}
			// Tab on last element - close NavSlide
			else if (!e.shiftKey && document.activeElement === $lastFocusable[0]) {
				e.preventDefault();
				$('.Nav-Button-Close').trigger('click');
				$('.Nav-Button').focus();
			}
		}
	});
	
	$(".SearchButton").on("click", function() {
		if ($('.HasDropdown.Open').length) {
			$('.HasDropdown.Open button.CloseButton').trigger('click');
		}
		if($('button.Nav-Button.Active').length) {
			$('.NavContent').attr('aria-hidden', 'true');
			$('button.Nav-Button').attr('aria-expanded', 'false');
			$('button.Nav-Button').removeClass('Active');
			$('.NavContent').removeClass('Open');
		}
		// $('#DropDownSearch').slideToggle();
		$(this).toggleClass('Active');
		if($('button.SearchButton.Active').length) {
			$('#DropDownSearch').attr('aria-hidden', 'false');
			$('#DropDownSearch').addClass('Open');
			$(this).addClass('Active');
			$(this).attr('aria-expanded', 'true');
			$('li.HasDropdown').removeClass('Open');
			// Focus on the first focusable element when opened
			setTimeout(function() {
				var $firstFocusable = $('#DropDownSearch').find('a, input, button, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible').first();
				if ($firstFocusable.length) {
					$firstFocusable.focus();
				}
			}, 100);
		} else {
			$('#DropDownSearch').attr('aria-hidden', 'true');
			$('#DropDownSearch').removeClass('Open');
			$(this).attr('aria-expanded', 'false');
		}
		return false;
	});
	
	// Handle keyboard navigation for SearchButton
	$(".SearchButton").on("keydown", function(e) {
		// Check if Tab key was pressed (key code 9)
		if (e.keyCode === 9 && !e.shiftKey && $(this).hasClass('Active')) {
			e.preventDefault();
			// Focus on the first focusable element in DropDownSearch
			var $firstFocusable = $('#DropDownSearch').find('a, input, button, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible').first();
			if ($firstFocusable.length) {
				$firstFocusable.focus();
			}
		}
	});

	// Trap focus within DropDownSearch when open
	$('#DropDownSearch').on('keydown', function(e) {
		if (e.keyCode === 9 && $('#DropDownSearch').hasClass('Open')) {
			var $focusable = $(this).find('a, input, button, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
			var $firstFocusable = $focusable.first();
			var $lastFocusable = $focusable.last();
			
			// Shift+Tab on first element - return to SearchButton
			if (e.shiftKey && document.activeElement === $firstFocusable[0]) {
				e.preventDefault();
				$('.SearchButton').focus();
			}
			// Tab on last element - return to SearchButton
			else if (!e.shiftKey && document.activeElement === $lastFocusable[0]) {
				e.preventDefault();
				$('.SearchButton').focus();
			}
		}
	});

	$('#DropDownSearch').on('click swiperight', 'button.CloseButton', function(e) {
		e.preventDefault();
		$('#DropDownSearch').attr('aria-hidden', 'true');
		$('#DropDownSearch').removeClass('Open');
		$('button.SearchButton').attr('aria-expanded', 'false');
		$('button.SearchButton').removeClass('Active');

		$('.SearchButton').focus();
	});
	
	$('#DropDownSearch').on('blur', 'button.CloseButton', function(e) {
		e.preventDefault();
		$('#DropDownSearch').attr('aria-hidden', 'true');
		$('#DropDownSearch').removeClass('Open');
		$('button.SearchButton').attr('aria-expanded', 'false');
		$('button.SearchButton').removeClass('Active');
		
	});
}

function header05_AlsoOnResize() {
	$('body.Small, body.Default').each(function() {
		$('.MenuButton').insertAfter('#HeaderBottom #Logo');
		$('#SearchButton').insertAfter('#HeaderBottom .MenuButton');
		// $('#MainNavWrap').appendTo('#HeaderTop .NavContent');
		// $('#HeaderRight > .cmspanel').prependTo('#HeaderTop .NavContent');
		// if ($('button.Menu').attr('aria-expanded') === "true") {
		// 	$('#NavContent').attr('aria-hidden', 'false').show();
		// } else {
		// 	$('#NavContent').attr('aria-hidden', 'true');
		// }
	});
	$('body.XL, body.Large, body.Medium').each(function() {
		$('.MenuButton').appendTo('#HeaderTop #HeaderTopRight');
		$('#SearchButton').appendTo('#HeaderTop #HeaderTopRight');
		// $('#MainNavWrap').appendTo('#MainNavWrap2');
		// $('#HeaderTop .NavContent > .cmspanel').appendTo('#HeaderRight');
		// $('.NavContent').removeAttr('style').removeAttr('aria-hidden');
	});
}


function MainNavDropDownsOnClick() {
	// Variable to keep track of the last focused button within <li>
    let lastFocusedButton = null;

    // Ensure <li> elements are not focusable directly
    $('#MainNav > ul > li').attr('tabindex', '-1'); // Remove tabindex from <li> to prevent it from receiving focus

    // Check if dropdowns exist in the template
    if ($('.MainNavDropdowns').length) {

        // Place within main nav list items
        $('.MainNavDropdowns > .cmspanel').each(function(item) {
            var itemNum = item + 1;
            $(this).appendTo('#MainNav > ul > li:nth-child(' + itemNum + ')').attr('tabindex', '-1').attr('aria-hidden', 'true');
        });

        // Remove original dropdown placeholder after the panels were moved out
        $('.MainNavDropdowns').remove();

        // Add classes to parent li and arrow element if dropdown exists
        $('#MainNav > ul > li').each(function() {
            if ($(this).find('.cmsPanelContent > *').length) {
                $(this).addClass('HasDropdown');
                $(this).find('> a, > strong').replaceWith('<button type="button" tabindex="0" aria-haspopup="menu" aria-controls="' + $(this).find('.cmspanel').attr('id') + '" aria-expanded="false"><span>' + $(this).find('> a, > strong').text() + '</span><span class="arrow-icon"><img class="Desktop" alt="Dropdown Menu Arrow" class="icon" width="12" height="6" src="/imgs/shared/2025/icon-nav-arrow-desktop.svg" /><img class="Mobile" alt="Dropdown Menu Arrow" class="icon" width="12" height="12" src="/imgs/shared/2025/icon-nav-arrow-mobile.svg" /></span></button>');
            }
        });

        // Click dropdown arrow button to activate dropdown menu
        $('#MainNav > ul > li').off('click', '> button').on('click', '> button', function (e) {
            e.preventDefault();
            $('#DropDownSearch').attr('aria-hidden', 'true').removeClass('Open');
            $('button.SearchButton').attr('aria-expanded', 'false').removeClass('Active');
            
            var li = $(e.target).closest('li.HasDropdown');
            if (li.hasClass('Open')) {
                li.removeClass('Open').addClass('Closed');
                $(e.target).attr('aria-expanded', 'false');
				$(e.target).parents('li.HasDropdown').find('.cmspanel').attr('aria-hidden', 'true').attr('tabindex', '-1'); //panel element
            } else {
                $('#MainNav > ul > li.HasDropdown').removeClass('Open').addClass('Closed'); // Close any open dropdowns
                $('#MainNav > ul > li.HasDropdown > button').attr('aria-expanded', 'false'); // Update aria-expanded
				$('#MainNav > ul > li.HasDropdown > .cmspanel').attr('aria-hidden', 'true').attr('tabindex', '-1');; //setting aria-hidden back to true on any panel
                li.removeClass('Closed').addClass('Open'); // Open the clicked dropdown
                $(e.target).attr('aria-expanded', 'true');
				$(e.target).parents('li.HasDropdown').find('.cmspanel').attr('aria-hidden', 'false').removeAttr('tabindex'); //set aria-hidden to false on open panel
            }
        });

        // Force close the dropdown menu with CloseButton
        $('#MainNav > ul > li .cmsPanelContent').append('<button class="CloseButton" tabindex="0">Hide submenu<span></span></button>');

        // Handle closing the dropdown with CloseButton
        $('#MainNav > ul > li').off('click', '.cmsPanelContent > button.CloseButton').on('click', '.cmsPanelContent > button.CloseButton', function(e) {
            e.preventDefault();
            
            // Track the last focused button
            lastFocusedButton = $(e.target).closest('li.HasDropdown').find('> button');
            
            // Close the dropdown
            $(e.target).closest('li.HasDropdown').removeClass('Open').addClass('Closed');
            $('#MainNav > ul > li.HasDropdown > button').attr('aria-expanded', 'false');
			$('li.HasDropdown').find('.cmspanel').attr('aria-hidden', 'true').attr('tabindex', '-1'); //panel element

            // Use a timeout to ensure focus is applied correctly after DOM updates
            setTimeout(function() {
                if (lastFocusedButton) {
                    lastFocusedButton.focus();
                }
            }, 100); // Slight delay to ensure focus is set after DOM updates
        });

        // Handle closing the dropdown with Escape key
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape') { // Escape key
                if ($('.Open').length) { // Check if any dropdown is open
                    var openLi = $('.Open');
                    lastFocusedButton = openLi.find('> button');
                    
                    // Close the dropdown
                    openLi.removeClass('Open').addClass('Closed');
                    $('#MainNav > ul > li.HasDropdown > button').attr('aria-expanded', 'false');
					$('li.HasDropdown').find('.cmspanel').attr('aria-hidden', 'true').attr('tabindex', '-1'); //panel element
					
                    // Use a timeout to ensure focus is applied correctly after DOM updates
                    setTimeout(function() {
                        if (lastFocusedButton) {
                            lastFocusedButton.focus();
                        }
                    }, 100); // Slight delay to ensure focus is set after DOM updates
                }
            }
        });

		$('#MainNav > ul > li').on('blur', '.cmsPanelContent > button.CloseButton', function(e) {
			e.preventDefault();
			$(e.target).parents('li.HasDropdown').removeClass('Open').addClass('Closed');
			$('li.HasDropdown').find('.cmspanel').attr('aria-hidden', 'true').attr('tabindex', '-1'); //panel element
		});

    }
}

function MainNavDropDownsOnHover() {
	//check if dropdowns exists in template
	if ($('.MainNavDropdowns').length) {

		//place panels within main nav list items
		$('.MainNavDropdowns > .cmspanel').each(function(item) {
			var itemNum = item + 1;
			$(this).appendTo('#MainNav > ul > li:nth-child(' + itemNum + ')').attr("tabindex", "-1");
		});

		//remove original dropdown placholder after the panels were moved out
		$('.MainNavDropdowns').remove();

		//including .HasDropdown class to parent li and arrow element if drop down exists
		$('#MainNav > ul > li').each(function() {
			if ($(this).find('.cmsPanelContent > *').length) {
				$(this).addClass('HasDropdown');
				$(this).find('> a, > strong').after('<button aria-haspopup="true" aria-expanded="false"><span><span class="sr-only">Show submenu</span></span></button');
			}
		});

		//hover functionality
		var hovertimer;
		var $li = $('#MainNav > ul > li')
			.on( "mouseenter", function() {
				var self = this;
				hovertimer = setTimeout(function(){
					$(self).addClass('Open');
					$(self).find('> button span span').text('Hide submenu');
					$(self).find('> button span span').text('Hide submenu');
					$(self).find('> button').attr('aria-expanded', 'true');
				}, 300);
			})
			.on( "mouseleave", function() {
				clearTimeout(hovertimer);
				$li.removeClass('Open');
				$li.find('> button span span').text('Show submenu');
				$li.find('> button span span').text('Show submenu');
				$li.find('> button').attr('aria-expanded', 'false');
			}
		);

		//click dropdown arrow button to activate dropdown menu
		$('#MainNav > ul > li').on('click', '> button', function (e) {
			e.preventDefault();
			$(e.target).parents('li.HasDropdown').addClass('Open');
			$(e.target).find('> span > span').text('Hide submenu');
			$(e.target).find('> button').attr('aria-expanded', 'true');
		});

		//force close the dropdown menu
		$('#MainNav > ul > li .cmsPanelContent').append('<button class="CloseButton">Hide submenu<span></span></button>');
		$('#MainNav > ul > li').on('click', '.cmsPanelContent > button.CloseButton', function(e) {
			e.preventDefault();
			$(e.target).parents('li.HasDropdown').removeClass('Open');
		});
        
		$('#MainNav > ul > li').on('blur', '.cmsPanelContent > button.CloseButton', function(e) {
			e.preventDefault();
			$(e.target).parents('li.HasDropdown').removeClass('Open');
		});
	}
}

function stickyNavigationDesktopOnly() {
	// STICKY NAV: Fixing Nav to top once scrolled there
	if ($(".StickyNavWrap").length) {
		var $window = $(window),
			$navigation = $('.StickyNavWrap'),
			offsetnav = $navigation.offset(),
			navHeight = $navigation.outerHeight();

		$window.on('scroll', function () {
			offsetnav = $navigation.offset();
			navHeight = $navigation.outerHeight();
			if (($window.scrollTop() > offsetnav.top) && $('body.Medium, body.Large, body.XL').length) {
				$('.StickyNav').addClass('Fixed');
				$navigation.css('height', navHeight);
			} else {
				$('.StickyNav').removeClass('Fixed');
				$navigation.removeAttr('style');
			}
		});
	}
}

function stickyNavigation() {
	// STICKY NAV: Fixing Nav to top once scrolled there
	if ($(".StickyNavWrap").length) {
		var $window = $(window),
			$navigation = $('.StickyNavWrap'),
			offsetnav = $navigation.offset(),
			navHeight = $navigation.outerHeight();

		$window.on('scroll', function () {
			offsetnav = $navigation.offset();
			navHeight = $navigation.outerHeight();
			if ($window.scrollTop() > offsetnav.top) {
				$('.StickyNav').addClass('Fixed');
				$navigation.css('height', navHeight);
			} else {
				$('.StickyNav').removeClass('Fixed');
				$navigation.removeAttr('style');
			}
		});
	}
}

function onlyOnErrorAppPage() {
	// pulling in actual navigation from home page into app/error pages
	if ($('body.ErrorApp').length > 0) {
		$('#Logo .cmspanel .cmsPanelContent a').each(function (i, el) {
			$.ajax({
				url: $(el).attr('href'),
				success: function (contents) {
					$('#MainNav').append($(contents).find('#MainNav').html());
				}
			});
		});
	}
}

function onlyOnHomePage() {
	// remove anchor around logo / removes need for separate panel for home page
	if ( window.location.pathname == '/' ) {
		$('#Logo .cmsPanelContent a > img').unwrap();
	}
}

function animationHandler() {
	// Animation Handler
	$('.animate').each(function () {
		// Grab the data-animation value to add class, grab offset and height to set the scroll position.
		var $this = $(this),
			anim = $this.data('animation'),
			delay = $this.data('delay'),
			duration = $this.data('duration'),
			offset = $(this).offset().top - ($(window).height() / 1.05);

		// If data-delay is added
		if ($this.data('delay')) {
			$this.css('animation-delay', delay);
		}

		// If data-duration is added
		if ($this.data('duration')) {
			$this.css('animation-duration', duration);
		}

		// Add the animation class when scroll position is met
		$(window).on('scroll', function () {
			if ($(window).scrollTop() >= offset) {
				$this.addClass(anim);
				$this.addClass('animated');
			}
		});
	});
}

function BasicSearch() {
	// Basic Search V2 - Updated 1/13/2012 mdeeter
	// Add Basic Search to the Advanced Search page....
	// Markup to look like this:
	//    <div class="basicSearch">
	//        <input type="text" name="keyword" class="theKeyword">
	//        <input type="hidden" class="theSearchPage" value="/doctors-locations/medicare gold/basic-search-results.aspx" >
	//        <input type="hidden" class="thisInputText" value="Name, Specialty, City, and ZIP Code" >
	//        <input type="hidden" class="querystr" value="keyword" >
	//        <input type="hidden" class="sorting" value="7" >
	//        <input type="hidden" class="errorText" value="Please enter in your search criteria." >
	//        <input type="button"  class="Button basicSearchButton" value="Search">
	//    </div>
	// NOTE: querystr and sorting inputs are OPTIONAL - if they don't exist, they default to "keyword" and "7" respectively
	$('.basicSearch').each(function(){
		var $BS = $(this),
			defaultText = $BS.find('input.thisInputText').val(),
			$input = $BS.find('input.theKeyword'),
			path = /^https?:\/\//i,
			searchPage;
        
		if (path.test($BS.find('input.theSearchPage').val()))
		{
			//absolute path in basic search value
			searchPage = $BS.find('input.theSearchPage').val() + '?';
		} else {
			//relative path in basic search value
			searchPage = $.url.attr('protocol') + '://' + $.url.attr('host') + $BS.find('input.theSearchPage').val() + '?';
		}
        
		var firstquerystr = $BS.find('input.querystr').val() || '',
			querystr = ( firstquerystr.length ) ? firstquerystr + '=' : 'keyword=',
			firstsorting = $BS.find('input.sorting').val() || '',
			sorting = firstsorting!=='0' ? ( firstsorting.length ? 'sort=' + firstsorting + '&' : 'sort=7&' ) : '',
			firsterrorText = $BS.find('input.errorText').val() || '',
			errorText = ( firsterrorText.length ) ? firsterrorText : 'Please enter in your search criteria.';
		if (defaultText.length){$input.val(defaultText);}
		// keyboard input bindings
		$input
			.on('focus', function() { if ( $(this).val()===defaultText ){ $(this).val(''); } })
			.on('blur', function() { if ( $(this).val()==='' ){ $(this).val( defaultText ); } })
			.on('keypress', function(e) {
				$BS.find('.error').slideUp().remove();
				if (e.key === 'Enter') {
					e.preventDefault(); // dont submit the ASP.Net form
					if (defaultText.length===0) {defaultText = '';}
					var kword = $(this).val();
					if (kword.length && kword !== defaultText){ window.location = (searchPage + sorting + querystr + kword); } else{ showBSError($input); }
				}
			});
		// clicking on the search button
		$BS.find('.basicSearchButton').on('click', function(){
			if (defaultText.length===0) {defaultText = '';}
			var kword = $input.val();
			if (kword.length && kword !== defaultText){ window.location = (searchPage + sorting + querystr + kword); } else{ showBSError($input); }
		});
		// show error message
		function showBSError(input){
			if ( $BS.find('.error').size()===0){ input.before('<div style="color:red" class="error">' + errorText + '</div>'); }

		}
		//turn autocomplete off on inputs within the main nav dropdowns
		$('#MainNav .cmspanel .theKeyword').attr('autocomplete', 'off');
	});
}

//added for third party form
function paymentForm() {
	var $form = $('#pjQuickShopCustomForm'),
		fieldPairs = [
			['#pj-patient-first-name', '#pj-cardholder-first-name'],
			['#pj-patient-last-name', '#pj-cardholder-last-name'],
			['#pj-patient-street-address', '#pj-cardholder-street-address'],
			['#pj-patient-city', '#pj-cardholder-city'],
			['#pj-patient-state', '#pj-cardholder-state'],
			['#pj-patient-zip', '#pj-cardholder-zip'],
			['#pj-patient-phone', '#pj-cardholder-phone'],
			['#pj-patient-email', '#pj-cardholder-email']
		];

	if ($form.length) {
		$form.find('#pj-patient-is-card-holder').on('change', function () {
			var isCardHolder = this.checked;

			$.each(fieldPairs, function (index, fieldPair) {
				$form.find(fieldPair[1]).val(isCardHolder ? $form.find(fieldPair[0]).val() : '');
			});
		});
	}
}

function removeEmptyElements() {
	/* (items from baby photos module, empty a from classes & events pg & news page, empty ul on classes & events-790144 ) */
	$('p.MoreLink, h3#VsMasterPage_MainContent_BabyPhotoCaption, h3#VsMasterPage_MainContent_BabySlogan, h4#VsMasterPage_MainContent_BabyName, h4#VsMasterPage_MainContent_BabySiblingsHeadline, a, ul, a#VsMasterPage_MainContent_SearchLinkButton, h3#VsMasterPage_MainContent_SearchClue').each(function () {
		if ($(this).html().trim().length <= 0) {
			$(this).remove();
		}
	});
}

function createCustomJumpLinks() {
	//Take the text from the JumpLinks nav and strip out spaces and special characters to use for the href. Then apply that link name to each jump nav section
	let regex = /(&amp;|&?)[ ()\-\/']+/g;
	$('.JumpLinks ul li a').each(function() {
		let href = $(this).attr('href');
		if (href === undefined || href.match(regex) || href.indexOf('#') === -1) {
			//does not have an href set or it does and it's invalid (has something in the regex) or does not have a hash
			href = $(this).html().replace(regex, ''); //set a href based on the link text with spaces and special characters stripped out
			$(this).attr('href', '#' + href);
		}
	});
	$('.InlinePanel, .InlineContent, .PageContentWrap').each(function() {
		if ($(this).find('.JumpNavSection').length) {
			if($(this).find('.JumpNavSection').attr('id') != null){
				var jumpId = $(this).find('.JumpNavSection').attr('id').replace(regex, '');
				$(this).addClass('JumpSections').attr('id', jumpId).find('.JumpNavSection').remove();
			}else{
				var jumpId = $(this).find('.JumpNavSection').text().replace(regex, '');
				$(this).addClass('JumpSections').attr('id', jumpId).find('.JumpNavSection').remove();
			}
		}
	});
}

function pageStructure() {
	//WRAPPING CONTENT FOR INLINE PANELS
    if (!$('#Hub-ContentSection').length) { 

        // first wrap each first level element within the .cmsPageContent div with a class of .PageContent,
        // then unwrap any .InlinePanel and .InlineContent divs from their .PageContent div (but not the ones with Right or Left class on them)
		// after this all first level content inside .cmsPageContent is either a .PageContent, .InlineContent or .InlinePanel
        $('.cmsPageContent').contents().filter(function(){
            return this.nodeType === 1;
        }).wrap('<div class="PageContent"></div>').end().filter('.InlinePanel, .InlineContent, .InlineContent-2up, .Banner').not('.InlinePanel.Right').not('.InlinePanel.Left').unwrap();

        //inside .InlineContent divs wrap contents with .InlineContentInner div
        $('.InlineContent:not(.JumpLinksWrap2)').wrapInner('<div class="InlineContentInner"><div class="InlineContentInner2"></div></div>');

        // then wrap all remaining .PageContent divs that are next to each other into .PageContentWrap div(s) to group
        $(':not(.PageContent) + .PageContent, * > .PageContent:first-of-type').each(function() {
            $(this).nextUntil(':not(.PageContent)').addBack().wrapAll('<div class="PageContentWrap ClearFix"><div class="PageContentInner"></div></div>');
        });

        // then remove the original individual .PageContent divs
        $('.PageContent > *').unwrap();

        // moving each of the panels within the .InlineContentPanels div into index appropriate div.InlinePanel in the cmspage
		$('.InlineContentPanels1 .cmspanel').each(function () {
			$(this).appendTo($('.cmspage').find('.InlinePanel1'));
        });
		$('.InlineContentPanels2 .cmspanel').each(function () {
            $(this).appendTo($('.cmspage').find('.InlinePanel2'));
        });
		$('.InlineContentPanels3 .cmspanel').each(function () {
            $(this).appendTo($('.cmspage').find('.InlinePanel3'));
        });
		$('.InlineContentPanels4 .cmspanel').each(function () {
            $(this).appendTo($('.cmspage').find('.InlinePanel4'));
        });
		$('.InlineContentPanels5 .cmspanel').each(function () {
            $(this).appendTo($('.cmspage').find('.InlinePanel5'));
        });
		$('.InlineContentPanels6 .cmspanel').each(function () {
            $(this).appendTo($('.cmspage').find('.InlinePanel6'));
        });
		$('.InlineContentPanels7 .cmspanel').each(function () {
            $(this).appendTo($('.cmspage').find('.InlinePanel7'));
        });
		$('.InlineContentPanels8 .cmspanel').each(function () {
			$(this).appendTo($('.cmspage').find('.InlinePanel8'));
        });

		//remove origional inline panel containers 
		$('div[class^="InlineContentPanels"]').remove();

        //wrapping form/dynamic/module content within it's own div to give margins
        $('.cmspage').contents().not('#DrDetail').not('#LocationsDetail').not('script').filter(function(){
            return this.nodeType === 1;
        }).wrap('<div class="DynamicContent"></div>').end().filter('.cmsPageContent, .CmsInfoButtonsContainer').unwrap();

        // then wrap all .DynamicContent divs into a .DynamicContentWrap div and remove the .DynamicContent divs
        $(':not(.DynamicContent) + .DynamicContent, * > .DynamicContent:first-of-type').each(function() {
            $(this).nextUntil(':not(.DynamicContent)').addBack().wrapAll('<div class="DynamicContentWrap ClearFix"><div class="DynamicContentInner"><div class="DynamicContentInner2"></div></div></div>');
			$('.PageContentWrap').removeClass('ClearFix'); //this allows module content to align beside the right or left column.
        });
        $('.DynamicContent > *').unwrap();

		// remove empty inline panel divs (would happen if admin places more inline containers in the cmspage area than they place panels)
        $('.InlinePanel:empty').remove();

		// creating jumplink anchors if .JumpLinks exists and IDs if .JumpNavSections exist
		//createCustomJumpLinks();

		// add class so we
        $('.cmspage').addClass('DoneLoading');
	}

	$('.PageContentWrap .PageContentInner').wrapInner('<div class="PageContentInner2"></div>'); //Needed for left and right templates
	
	if($('body#RightColumn').length || $('body#LeftColumn').length) {
		$('.DynamicContentWrap').appendTo('.cmsPageContent');
	}
	if($('.DynamicContentInner2').length) {
		$('.DynamicContentInner2 > *').appendTo('.PageContentWrap:last .PageContentInner2');
	}
	$('.DynamicContentInner2').each(function () {
		if($(this).is(':empty')) {
			$(this).parents('.DynamicContentWrap').remove();
		}
	});
	// remove empty inline content divs
	$('.InlineContentInner2').each(function () {
		if ($.trim($(this).text()) === '' && $(this).children().length === 0) {
			$(this).closest('.InlineContent').remove();
		}
	});

	// Remove #CallToAction if empty
	if ($('#CallToAction').length && $('#CallToAction').is(':empty')) {
		$('#CallToAction').remove();
	}

	if ($('#CallToAction .cmspanel').length) {
		// Check if first heading in CallToAction is h2, if not update it to h2
		var firstHeading = $('#CallToAction .cmspanel').find('h1, h2, h3, h4, h5, h6').first();
		if (firstHeading.length && !firstHeading.is('h2')) {
			var headingText = firstHeading.html();
			firstHeading.replaceWith('<h2>' + headingText + '</h2>');
		}
		
		// Move CallToAction: check for MoveCTA class first, then check first element in cmsPageContent
		var $callToAction = $('#CallToAction');
		if ($callToAction.length) {
			var $moveCTA = $('.Move-CTA-Here');
			var $drResults = $('#DrResults');
			
			if ($drResults.length) {
				// If DrResults exists, place CallToAction before it
				$callToAction.insertBefore($drResults);
			} else if ($moveCTA.length) {
				// If Move-CTA-Here class exists, append to it
				$moveCTA.append($callToAction);
			} else {
				// Check first element in cmsPageContent
				var $firstElement = $('.cmsPageContent').children().first();
				if ($firstElement.hasClass('InlineContent')) {
					// If first element is InlineContent, find first PageContentWrap and prepend
					var $firstPageContentWrap = $('.cmsPageContent').find('.PageContentWrap .PageContentInner2').first();
					if ($firstPageContentWrap.length) {
						$firstPageContentWrap.prepend($callToAction);
					}
				} else if ($firstElement.hasClass('PageContentWrap')) {
					// If first element is PageContentWrap, insert before first h2
					var $firstH2 = $firstElement.find('h2').first();
					if ($firstH2.length) {
						var $calloutWide = $firstH2.closest('.CalloutWide');
						if ($calloutWide.length) {
							$callToAction.insertBefore($calloutWide);
						} else {
							$callToAction.insertBefore($firstH2);
						}
					}
				}
			}
		}

	}


	// moving the prox nav and call to action into the .cmsPageContent div
	// after all of the .PageContentWrap divs are built out so that it doesn't get wrapped inside one of those
	// if (!$('#Hub-ContentSection').length && !$('body#Home').length) {
	// 	var windowWidth = Math.max($window.width(), window.innerWidth);

	// 	// adding prox container only if proximity nav or a call to action exists - location based on screen size
	// 	if ($('#CallToAction .cmspanel').length || $('#ProximityNav ul a').length || $('#RightColumnPanels > .cmspanel').length || $('#LeftColumnPanels > .cmspanel').length) {
	// 		if (windowWidth >= 1024) {
	// 			if ($('.PageContentWrap').length) {
	// 				// if regular page content exists, outside of inline panel or inline content, then insert right after
	//  				$('.PageContentWrap:first > .PageContentInner').append('<div id="Prox-CTA-Wrap"></div>');
	// 			} else if ($('.DynamicContentWrap').length) {
	// 				// if regular page content does not exist, but dynamic content does exist then insert right after dynamic content
	//  				$('.DynamicContentWrap:first > .DynamicContentInner').append('<div id="Prox-CTA-Wrap"></div>');
	// 			}
	// 			$('#RightColumnPanels, #LeftColumnPanels').appendTo('#Prox-CTA-Wrap');
	// 		} else {
	// 			if ($('.PageContentWrap:first-child').length) {
	// 				$('.PageContentWrap:first-child').prepend('<div id="Prox-CTA-Wrap"></div>');
	// 			} else {
	// 				$('.cmsPageContent > div:nth-child(2)').prepend('<div id="Prox-CTA-Wrap"></div>');
	// 			}
	// 			$('#RightColumnPanels, #LeftColumnPanels').appendTo('.PageContentWrap:first .PageContentInner:first');
	// 		}
	// 	}

	// 	// moving prox nav to prox nav container - all sizes
	// 	$('#ProximityNavWrap').prependTo('#Prox-CTA-Wrap');

	// 	// moving CTA to correct place based on screen size & when Move-CTA-Here exists
	// 	if ($('#CallToAction .cmspanel').length) {
	// 		if ($('.Services-Banner .Move-CTA-Here').length) {
	// 			//if services banner with Move-CTA-Here do this on all sizes
	// 			$('#CallToAction').prependTo('.Move-CTA-Here');
	// 		} else if ($('.Move-CTA-Here').length) {
	// 			//if services banner Move-CTA-Here does not exist but Move-CTA-Here exists do this based on size
	// 			if (windowWidth >= 1024) {
	// 				$('#CallToAction').prependTo('#Prox-CTA-Wrap');
	// 			} else {
	// 				$('#CallToAction').prependTo('.Move-CTA-Here');
	// 			}
	// 		} else {
	// 			//if Move-CTA-Here does not exist
	// 			if (windowWidth >= 1024) {
	// 				$('#CallToAction').prependTo('#Prox-CTA-Wrap');
	// 			} else {
	// 				if ($('.PageContentWrap:first-child').length) {
	// 					$('#CallToAction').insertAfter('.PageContentWrap:first .PageContentInner .PageContentInner2');
	// 				} else {
	// 					$('#CallToAction').prependTo('#Prox-CTA-Wrap');
	// 				}
	// 			}
	// 		}
	// 	} else {
	// 		$('#CallToAction').remove();
	// 	}
	// 	if (windowWidth >= 1024) {
	// 		//top margin on column content
	// 		adjustRightColumnTop();
	// 	}
	// } else { 
	// 	//Prox Section Setup in Hub templates
	// 	proxCTAwrapHub();
	// }
	$('.BeforePageStuctureLoad').removeClass('BeforePageStuctureLoad');
}

function pageStructure_AlsoOnResize() {
	// Moving Prox nav on all templates except for hub templates
	if (!$('#Hub-ContentSection').length && !$('body#Home').length) {
		var windowWidth = Math.max($window.width(), window.innerWidth);

		// adding prox container only if proximity nav or a call to action exists - location based on screen size
		// if ($('#CallToAction .cmspanel').length || $('#ProximityNav ul a').length || $('#RightColumnPanels > .cmspanel').length || $('#LeftColumnPanels > .cmspanel').length) {
		// 	if (windowWidth >= 1024) {
		// 		if ($('.PageContentWrap').length) {
		// 			// if regular page content exists, outside of inline panel or inline content, then insert right after
	 	// 			$('#Prox-CTA-Wrap').appendTo('.PageContentWrap:first .PageContentInner:first');
		// 		} else if ($('.DynamicContentWrap').length) {
		// 			// if regular page content does not exist, but dynamic content does exist then insert right after dynamic content
	 	// 			$('#Prox-CTA-Wrap').appendTo('.DynamicContentWrap:first .DynamicContentInner:first');
		// 		}

		// 		if (!$('.Services-Banner .Move-CTA-Here').length) {
		// 			$('#CallToAction').prependTo('#Prox-CTA-Wrap');
		// 		}

		// 		$('#RightColumnPanels, #LeftColumnPanels').appendTo('#Prox-CTA-Wrap');
		// 		if ($('#ProximityToggle').attr('aria-expanded') === "false") { 
		// 			$('#ProximityToggle').attr('aria-expanded', 'true');
		// 			$('#ProximityNavContent').attr('aria-hidden', 'false').removeAttr('style');
		// 		}

		// 		//top margin on column content
		// 		adjustRightColumnTop();

		// 	} else {
		// 		if ($('.PageContentWrap:first-child').length) {
		// 			$('#Prox-CTA-Wrap').prependTo('.PageContentWrap:first-child');
		// 		} else {
		// 			$('#Prox-CTA-Wrap').prependTo('.cmsPageContent > div:nth-child(2)');
		// 		}
				
		// 		if ($('.Services-Banner .Move-CTA-Here').length) {
		// 			//everything stays the same
		// 		} else if ($('.Move-CTA-Here').length) {
		// 			$('#CallToAction').prependTo('.Move-CTA-Here');
		// 		} else {
		// 			if ($('.PageContentWrap:first-child').length) {
		// 				$('#CallToAction').appendTo('.PageContentWrap:first .PageContentInner');
		// 			} else {
		// 				$('#CallToAction').prependTo('#Prox-CTA-Wrap');
		// 			}
		// 		}

		// 		// $('#RightColumnPanels, #LeftColumnPanels').appendTo('.PageContentWrap:first .PageContentInner:first'); //needs to stay placed below CTA moving
		// 		$('#CallToAction').removeAttr('style');
		// 	}
		// }
	}
}

function adjustRightColumnTop() {
	//top margin on column content
	var columnTopMargin;
	if($('.cmsPageContent > div:first-child').hasClass('InlineContent')) {
		columnTopMargin = $('.cmsPageContent > .InlineContent:first-child').outerHeight() - 40;
	}
	else if ($('.cmsPageContent > div:first-child').hasClass('InlinePanel')) {
		columnTopMargin = $('.cmsPageContent > .InlinePanel:first-child').outerHeight() - 40;
	}

	$('.PageContentWrap:nth-child(2) #Prox-CTA-Wrap > #CallToAction').css('margin-top', -columnTopMargin);
	$('.DynamicContentWrap:nth-child(2) #Prox-CTA-Wrap > #CallToAction').css('margin-top', -columnTopMargin);
}

function breadArrow() {
	'use strict';
	// replace greater than sign within breadcrumbs
	if ($('#Breadcrumbs').length) {
		$('#Breadcrumbs p').html(
			$('#Breadcrumbs p').html().replace(/&gt;/g, '/')
		);
	}

	if ($('#LocationsDetail .ReturnLink').length) {
		$('.ReturnLink').prependTo('#Breadcrumbs');
	}
}

function ariaFixes() {
    //Unwrap the fieldset from the site search.
    $('#Search fieldset input').unwrap();
    if(location.pathname === "/") {
        $('#Logo .cmsPanelContent a').attr('aria-current', 'page'); //optional aria
    }
	//applying role and/or aria attributes to various areas
	$('#LocationAdvancedSearch fieldset').attr('role', 'group').attr('aria-label', 'Advanced Location Search');
	$('#ProviderAdvancedSearch fieldset').attr('role', 'group').attr('aria-label', 'Advanced Provider Search');
	$('#ClinicalTrialsResults fieldset').attr('role', 'group').attr('aria-label', 'Clinical Trials Search');
	$('#BabySearchContainer fieldset').attr('role', 'group').attr('aria-label', 'Baby Photo Search');
	$('#MainNav li.Active strong').attr('aria-current', 'page'); //optional aria
	$('#ProximityNav li.Active strong').attr('aria-current', 'page'); //optional aria
	$('.CheerPersonalize > fieldset:nth-of-type(2)').attr('aria-label', 'Enter sender information');
	$('.CheerPersonalize > fieldset:nth-of-type(3)').attr('aria-label', 'Enter recipient information');
	$('.CheerPersonalize > fieldset:nth-of-type(4)').attr('aria-label', 'Enter delivery location information');
    $('#ServicesSearch .AlphabetLinksInner li.Active a').attr('aria-current', 'true');
    $('#ServicesSearch .AlphabetLinksInner li.NoItems').each(function(){
        $(this).find('a').attr('aria-disabled', 'true').attr('tabindex', '-1');
    });
	$('#VsMasterPage_MainContent_BabyPhotoImage').attr('alt', '').attr('role', 'presentation').attr('aria-hidden', 'true');

	// event smartpanel - adding aria-label to event links to make them different from each other (accessibility fix)
    var month,
        day,
        time,
        title,
        eventNum = 1;
    $('.Events-Upcoming-Calendar li').each(function () {
        month = $(this).find('.BoxMo').text().trim(),
        day = $(this).find('.BoxDate').text().trim(),
        time = $(this).find('.EventTime').text().trim(),
        title = $(this).find('.EventName').text().trim();
        if ($(this).find('.BoxMo').length) {
            $(this).find('.EventName a').attr('aria-label', 'Event ' + eventNum + ': ' + title + ' on ' + month + ' ' + day + ', ' + time);
        } else if ($(this).find('.Ongoing').length) {
            $(this).find('.EventName a').attr('aria-label', 'Event ' + eventNum + ': ' + title + ': Ongoing Event');
        }
        eventNum++;
    });
}

function removeCoreNavHeadings() {
	// Temporary fix to remove core nav headings
	$('#MainNav > h2').remove();
	$('#Breadcrumbs > h2').remove();
	$('#ProximityNav > h2').replaceWith(function() {
		return '<div class="Section-Heading">' + $(this).html() + '</div>';
	});
}

function clinicalTrialHeadings() {
	//Changing heading markup for details page
	if ($('.ClinicalTrialDetail').length) {
		var TrialShortTitle = $('h2#VsMasterPage_MainContent_h2TrialShortTitle'),
			TrialLongTitle = $('h3#VsMasterPage_MainContent_h3TrialLongTitle');

		if (TrialShortTitle.length) {			
			var h1Text = TrialShortTitle.text();
			TrialShortTitle.replaceWith("<h1>" + h1Text + "</h1>");
		}
		if (TrialLongTitle.length) {
			var h2Text = TrialLongTitle.text();
			TrialLongTitle.replaceWith("<h2>" + h2Text + "</h2>");
		}
	}
}

function clinicalTrialsTabResults() {
	if ($('#ClinicalTrialsSearch .TabContainer').length) {
		$('#ClinicalTrialsSearch .TabContainer .Tab').each(function () { 

			$(this).find('dl').replaceWith(function() {
				return '<ul>' + $(this).html() + '</ul>';
			});
			
			$(this).find('dt').replaceWith(function() {
				return '<li>' + $(this).html() + '</li>';
			});
			
			$(this).find('dd').replaceWith(function() {
				return '<li>' + $(this).html() + '</li>';
			});
		});
	}
}

function proxCTAwrapHub() {
	/* CTA / Prox Nav on Content Hub Interior */
	if ($('#CallToAction .cmspanel').length || $('ProximityNav ul a').length) {
		$('<div id="Prox-CTA-Wrap"></div>').prependTo('.PageContentWrap:first');
	}
}

function proxNav_01() {
	/* adding expand buttons via js so that it doesn't show if js is disabled. */
	if (!$('#Hub-ContentSection').length) { // not content hub
		// $('<strong class="h2-style" id="ProximityHeading">In this Section</strong>').insertBefore('#ProximityNavContent');
		$('#ProximityNav h2 strong, #ProximityNav h2 a').unwrap().wrap('<div class="Section-Heading"></div>');
		$('<button id="ProximityToggle" aria-expanded="false" aria-controls="#ProximityNav ul" class="ProxNavButton">In this Section</button>').insertAfter('.Section-Heading');
	}
	else { // if content hub
		$('<button id="ProximityToggle" aria-expanded="false" aria-controls="#ProximityNav ul" class="ProxNavButton">In this Section</button>').insertAfter('.Section-Heading');
	}

	if ($('#ProximityNavWrap ul li.Active ul').length) {
        $('#ProximityNavWrap ul li.Active strong').wrap('<button class="ProxSubPages" aria-expanded="false" aria-controls=".ProxSubPagesContent"></button>');
        $('#ProximityNavWrap ul li.Active ul').addClass('ProxSubPagesContent');
    }

	/* Drop Downs for Mobile (prox nav dropdown) */
	$('#ProximityNavWrap').on('click', '.ProxNavButton', function () {
		// $('#ProximityNav ul:first').slideToggle();
		$(this).toggleClass('Active');
		if($('.ProxNavButton.Active').length) {
			$('#ProximityNav ul:first').attr('aria-hidden', 'false');
			$(this).attr('aria-expanded', 'true');
			$('#ProximityNav ul:first').addClass('Open');
		} else {
			$('#ProximityNav ul:first').attr('aria-hidden', 'true');
			$(this).attr('aria-expanded', 'false');
			$('#ProximityNav ul:first').removeClass('Open');
		}
		return false;
	});

	/* Drop Down for desktop - sub prox nav
    ----------------------------------------------------------------- */
    $('#ProximityNavWrap').on('click', '.ProxSubPages', function () {
        // $('.ProxSubPagesContent').slideToggle();
        $(this).toggleClass('Active');
        if ($('.ProxSubPages.Active').length) {
            $('.ProxSubPagesContent').attr('aria-hidden', 'false');
            $('.ProxSubPagesContent').addClass('Open');
            $(this).attr('aria-expanded', 'true');
        } else {
            $('.ProxSubPagesContent').attr('aria-hidden', 'true');
            $(this).attr('aria-expanded', 'false');
            $('.ProxSubPagesContent').removeClass('Open');
        }
        return false;
    });

	/* Remove In This Section button if no proximity nav is present */
	if ($('#ProximityNav ul a').length === 0) {
		$('#ProximityNavWrap').remove();
	}

	handleProxViewMore();
}

/* View More toggle for proximity nav - Medium breakpoint and up only */
function handleProxViewMore() {
	var windowWidth = Math.max($window.width(), window.innerWidth);
	var $proxNavFirstUl = $('#ProximityNav > ul').first();
	var $proxNavListItems = $proxNavFirstUl.find('> li');
	var $existingBtn = $('.prox-view-more');
	
	if (windowWidth >= 1024 && $proxNavListItems.length > 4) {
		// Desktop: show View More button and hide items beyond 4th
		// Check if button is expanded, otherwise hide items
		var isExpanded = $existingBtn.attr('aria-expanded') === 'true';
		if (!isExpanded) {
			$proxNavListItems.slice(4).addClass('hidden-prox-item');
		}
		
		// Add button if it doesn't exist
		if (!$existingBtn.length) {
			var $viewMoreBtn = $('<button class="prox-view-more" aria-expanded="false">View More</button>');
			$proxNavFirstUl.after($viewMoreBtn);
			
			// Toggle functionality (use off first to prevent duplicate handlers)
			$('#ProximityNavWrap').off('click', '.prox-view-more').on('click', '.prox-view-more', function() {
				var $btn = $(this);
				var isExpanded = $btn.attr('aria-expanded') === 'true';
				
				if (isExpanded) {
					$proxNavListItems.slice(4).addClass('hidden-prox-item');
					$btn.attr('aria-expanded', 'false').text('View More');
				} else {
					$proxNavListItems.slice(4).removeClass('hidden-prox-item');
					$btn.attr('aria-expanded', 'true').text('View Less');
				}
				
				return false;
			});
		}
	} else {
		// Mobile: remove button and show all items
		if ($existingBtn.length) {
			$existingBtn.remove();
		}
		$proxNavListItems.removeClass('hidden-prox-item');
	}
}

function minBodyHeight() {
	// Setting #BodyWrap height (helps keep footer at bottom of shorter content pages)
	var windowHeight = Math.max($window.height(), window.innerHeight),
		footerHeight = $('footer').outerHeight();
    $('#BodyWrap').not('body#Blank #BodyWrap').css('min-height', windowHeight - footerHeight);
}

function panelBackgrounds() {
	/* Adding additional panel background options */
	$('.Background-Light').parents('.cmspanel').addClass('Background-Light');
	$('.Background-Mid').parents('.cmspanel').addClass('Background-Mid');
	$('.Background-Dark').parents('.cmspanel').addClass('Background-Dark');
	$('.Background-Dark2').parents('.cmspanel').addClass('Background-Dark2');
	$('.Background-Dark3').parents('.cmspanel').addClass('Background-Dark3');
	$('.Background-Top-Bar-Warning').parents('.cmspanel').addClass('Warning');
}

function smartPanelGrid() {
	/* Adding grid option for locations or providers options */
	$('.Grid').parents('.cmspanel').addClass('Grid');
	if ($('.cmspanel.Grid').length) {
		$('.cmspanel.Grid .SmartPanel').addClass('Grid');

		// add classes to identify if default image is used for news 
		$('.Grid .Thumbnail img').each(function() {
			var src = $(this).attr('src');
			if (src && (src.includes('../app/files/public/Rex-logo-for-social.png') || src.includes('../app/files/public/Chatham-logo-for-social.png') || src.includes('../app/files/public/UNC-logo-for-social.png') || src.includes('../app/files/public/Logo-for-social.png') || src.includes('app/files/public/Logo-for-social.png') || src.includes('app/files/public/UNCHealthJohnstonLogo%20-%20social%20sharing2.png') || src.includes('app/files/public/2022RockinghamLogo-SocialSharing.png') || src.includes('app/files/public/Wayne-logo-for-social.png'))) {
				$(this).parent('.Thumbnail').addClass('DefaultThumbnailWrap');
				$(this).addClass('DefaultThumbnail');
			}
		});
	}
}

function breadcrumbsBackgroundSwap() {
	/* Swapping breadcrumb background to match first background of the page */
	if ($('.cmsPageContent > div.Background-Light:first-child').length || $('#DrDetail div.Background-Light:first-child').length || $('#LocationsDetail div.Background-Light:first-child').length) {
		$('#BreadcrumbsWrap').addClass('Background-Light');
	}
	if ($('.cmsPageContent > div.Background-Mid:first-child').length || $('#DrDetail div.Background-Mid:first-child').length || $('#LocationsDetail div.Background-Mid:first-child').length) {
		$('#BreadcrumbsWrap').addClass('Background-Mid');
	}
	if ($('.cmsPageContent > div.Background-Dark:first-child').length || $('#DrDetail div.Background-Dark:first-child').length || $('#LocationsDetail div.Background-Dark:first-child').length) {
		$('#BreadcrumbsWrap').addClass('Background-Dark');
	}
	if ($('.cmsPageContent > div.InlineContent.Wide:first-child').length) {
		$('#BreadcrumbsWrap').addClass('Wide');
	}
}

function swapSPSliderMarkup() {
	// wide SmartPanels to get updated markup for slider
	var SPListSlider = $('#DrSmartPanel, #SmartPanelLocations, .SP-CmsPage-Images, #SmartPanelNewsRecent, #SmartPanelNewsRelated, #SmartPanelPagesRelated').not('.SmartPanel.Grid').not('.Sidebar .Events-Upcoming-Calendar').not('.Sidebar #DrSmartPanel').not('.Sidebar #SmartPanelLocations').not('.Sidebar .SP-CmsPage-Images').not('#CallToAction .Events-Upcoming-Calendar').not('#CallToAction #DrSmartPanel').not('#CallToAction #SmartPanelLocations').not('#CallToAction .SP-CmsPage-Images').not('.Section-75-25 > div:nth-child(even) .Events-Upcoming-Calendar').not('.Section-75-25 > div:nth-child(even) #DrSmartPanel').not('.Section-75-25 > div:nth-child(even) #SmartPanelLocations').not('.Section-75-25 > div:nth-child(even) .SP-CmsPage-Images').not('.Section-25-75 > div:nth-child(odd) .Events-Upcoming-Calendar').not('.Section-25-75 > div:nth-child(odd) #DrSmartPanel').not('.Section-25-75 > div:nth-child(odd) #SmartPanelLocations').not('.Section-25-75 > div:nth-child(odd) .SP-CmsPage-Images').not('.Section-66-33 > div:nth-child(even) .Events-Upcoming-Calendar').not('.Section-66-33 > div:nth-child(even) #DrSmartPanel').not('.Section-66-33 > div:nth-child(even) #SmartPanelLocations').not('.Section-66-33 > div:nth-child(even) .SP-CmsPage-Images').not('.Section-33-66 > div:nth-child(odd) .Events-Upcoming-Calendar').not('.Section-33-66 > div:nth-child(odd) #DrSmartPanel').not('.Section-33-66 > div:nth-child(odd) #SmartPanelLocations').not('.Section-33-66 > div:nth-child(odd) .SP-CmsPage-Images');

	//swap elements before creating slider
	$(SPListSlider).find('.SPList li.SPItem').each(function () {
		$(this).parents('.SmartPanel').not('.Grid').addClass('BecomesSlider');
		$(this).parent().wrap('<div class="SPList"></div>').contents().unwrap();
		$(this).wrap('<div class="SPItem"></div>').contents().unwrap();
	});

	//swap li for div in old flexslider markup
	$('.flexslider .slides > li, #Gallery ul > li').each(function () {
		$(this).wrap('<div></div>').contents().unwrap();
	});

	$('#Gallery ul').each(function () {
		$(this).wrap('<div class="GallerySlides"></div>').contents().unwrap();
	});
}

function sliderArrow() {
	// Use setTimeout to ensure Slick has finished building/rebuilding arrows
	setTimeout(function() {
		$('.slick-prev-icon').each(function () {
			// Only update if SVG isn't already present
			if (!$(this).find('svg').length) {
				$(this).html('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none"><path d="M17 7H1M1 7L7 1M1 7L7 13" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
			}
		});
		$('.slick-next-icon').each(function () {
			// Only update if SVG isn't already present
			if (!$(this).find('svg').length) {
				$(this).html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
			}
		});
	}, 100);
}

function sliders() {
	//slider functionality
	$('.Slider, .slides').not('.slick-initialized').on('afterChange',function(){
		$('iframe').each(function(){ //on change slide = do action (pause iframe video)
			$(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
		});
	}).slick({
		dots: false,
		arrows: true,
		infinite: false,
		autoplay: false,
		autoplaySpeed: 8000,
		speed: 500,
		fade: true,
		adaptiveHeight: true,
		arrowsPlacement: 'afterSlides',
		cssEase: 'linear'
	});
	$('.Slider-Auto').not('.slick-initialized').on('afterChange',function(){
		$('iframe').each(function(){ //on change slide = do action (pause iframe video)
			$(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
		});
	}).slick({
		dots: false,
		arrows: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 8000,
		speed: 500,
		fade: true,
		arrowsPlacement: 'afterSlides',
		cssEase: 'linear'
	});

	$('.Carousel-4up').not('.slick-initialized').on('afterChange',function(){
		$('iframe').each(function(){ //on change slide = do action (pause iframe video)
			$(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
		});
	}).slick({
		dots: false,
		arrows: true,
		arrowsPlacement: 'afterSlides',
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint:1024,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint:960,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
	$('.Carousel-3up').not('.slick-initialized').on('afterChange',function() {
		$('iframe').each(function(){ //on change slide = do action (pause iframe video)
			$(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
		});
	}).slick({
		dots: false,
		arrows: true,
		arrowsPlacement: 'afterSlides',
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint:1570,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint:1280,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint:1024,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint:960,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
	$('.Carousel-2up').not('.slick-initialized').on('afterChange',function(){
		$('iframe').each(function(){ //on change slide = do action (pause iframe video)
			$(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
		});
	}).slick({
		dots: false,
		arrows: true,
		arrowsPlacement: 'afterSlides',
		infinite: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint:1570,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint:1280,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
	// $('div:not(#BelowMainLeftRight, .Section-50-50) .Events-Upcoming-Calendar .BecomesSlider .SPList').not('.slick-initialized').slick({
	// 	dots: false,
	// 	infinite: false,
	// 	arrowsPlacement: 'afterSlides',
	// 	slidesToShow: 5,
	// 	slidesToScroll: 1,
	// 	responsive: [
	// 		{
	// 			breakpoint:1481,
	// 			settings: {
	// 				slidesToShow: 4
	// 			}
	// 		},
	// 		{
	// 			breakpoint:1281,
	// 			settings: {
	// 				slidesToShow: 3
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 900,
	// 			settings: {
	// 				slidesToShow: 2
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 600,
	// 			settings: {
	// 				slidesToShow: 1
	// 			}
	// 		}
	// 	]
	// });


	$('div:not(#BelowMainLeftRight, .Section-50-50) .BecomesSlider#SmartPanelLocations .SPList, div:not(#BelowMainLeftRight, .Section-50-50) .BecomesSlider#SmartPanelNewsRecent .SPList, div:not(#BelowMainLeftRight, .Section-50-50) .BecomesSlider#SmartPanelPagesRelated .SPList').not('.slick-initialized').slick({
		dots: false,
		infinite: false,
		arrowsPlacement: 'afterSlides',
		slidesToShow: 4.25,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint:1281,
				settings: {
					slidesToShow: 3.25
				}
			},
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 2.25
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1.25
				}
			}
		]
	});
	$('div:not(#BelowMainLeftRight, .Section-50-50) .BecomesSlider#DrSmartPanel .SPList').not('.slick-initialized').slick({
		dots: false,
		infinite: false,
		arrowsPlacement: 'afterSlides',
		slidesToShow: 5.25,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint:1481,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint:1181,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
	$('.Sidebar .cmspanel.Hub.ItemsLoaded .Hub-Stories').not('.slick-initialized').slick({
		dots: false,
		infinite: false,
		arrowsPlacement: 'afterSlides',
		slidesToShow: 1,
		slidesToScroll: 1
	});
	$('.Hub.ItemsLoaded .Section-50-50 .Hub-Stories, .Hub.ItemsLoaded .Grid-50-50-1Left-2Right .Hub-Stories, #BelowMainLeftRight .cmspanel.Hub.ItemsLoaded .Hub-Stories').not('.slick-initialized').slick({
		dots: false,
		infinite: false,
		arrowsPlacement: 'afterSlides',
		slidesToShow: 2,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1040,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
	$('div:not(#BelowMainLeftRight, .Sidebar) .Hub.ItemsLoaded *:not(.Section-50-50, .Grid-50-50-1Left-2Right) .Hub-Stories').not('.slick-initialized').slick({
		dots: false,
		infinite: false,
		arrowsPlacement: 'afterSlides',
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
	$('#Gallery .GallerySlides').not('.slick-initialized').slick({
		dots: false,
		infinite: false,
		arrowsPlacement: 'afterSlides',
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
	// $('.A-Z-Slider').not('.slick-initialized').slick({
	// 	dots: false,
	// 	infinite: false,
	// 	slidesToShow: 16,
	// 	slidesToScroll: 16,
	// 	responsive: [
	// 		{ breakpoint: 1600, settings: {slidesToShow: 16, slidesToScroll: 16} },
	// 		{ breakpoint: 1500, settings: {slidesToShow: 15, slidesToScroll: 15} },
	// 		{ breakpoint: 1400, settings: {slidesToShow: 14, slidesToScroll: 14} },
	// 		{ breakpoint: 1300, settings: {slidesToShow: 13, slidesToScroll: 13} },
	// 		{ breakpoint: 1200, settings: {slidesToShow: 12, slidesToScroll: 12} },
	// 		{ breakpoint: 1100, settings: {slidesToShow: 11, slidesToScroll: 11} },
	// 		{ breakpoint: 1000, settings: {slidesToShow: 10, slidesToScroll: 10} },
	// 		{ breakpoint: 900, settings: {slidesToShow: 9, slidesToScroll: 9} },
	// 		{ breakpoint: 800, settings: {slidesToShow: 8, slidesToScroll: 8} },
	// 		{ breakpoint: 700, settings: {slidesToShow: 7, slidesToScroll: 7} },
	// 		{ breakpoint: 600, settings: {slidesToShow: 6, slidesToScroll: 6} },
	// 		{ breakpoint: 500, settings: {slidesToShow: 5, slidesToScroll: 5} },
	// 		{ breakpoint: 400, settings: {slidesToShow: 4, slidesToScroll: 4} },
	// 		{ breakpoint: 300, settings: {slidesToShow: 3, slidesToScroll: 3} },
	// 		{ breakpoint: 200, settings: {slidesToShow: 2, slidesToScroll: 2} }
	// 	]
	// });

	$('#LocationsDetail .LocationWrap').not('.slick-initialized').slick({
		mobileFirst: true,              // makes breakpoints act as min-width
		dots: false,
		infinite: false,
		arrowsPlacement: 'afterSlides', // A11Y fork option is fine here
		slidesToShow: 1,                // base (mobile)
		slidesToScroll: 1,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 800,            // ≥800px
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 1024,           // ≥1024px
				settings: 'unslick'         // disables the slider at desktop and up
			}
		]
	});

	$('.NcSurgery .LocationWrap.Loaded').not('.slick-initialized').slick({
		mobileFirst: true,              // makes breakpoints act as min-width
		dots: false,
		infinite: false,
		arrowsPlacement: 'afterSlides', // A11Y fork option is fine here
		slidesToShow: 1,                // base (mobile)
		slidesToScroll: 1,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 800,            // ≥800px
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 1024,           // ≥1024px
				settings: 'unslick'         // disables the slider at desktop and up
			}
		]
	});

	$('.InlineContent #ProviderList .LocationProvidersModaal').not('.slick-initialized').slick({
		mobileFirst: true,              // makes breakpoints act as min-width
		dots: false,
		infinite: false,
		arrowsPlacement: 'afterSlides', // A11Y fork option is fine here
		slidesToShow: 1,                // base (mobile)
		slidesToScroll: 1,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 800,            // ≥800px
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 1024,           // ≥1024px
				settings: 'unslick'         // disables the slider at desktop and up
			}
		]
	});

	// Move MoreLink after slick-next for BecomesSlider panels
	$('.BecomesSlider').each(function() {
		var $panel = $(this);
		var $moreLink = $panel.find('.MoreLink');
		var $slickPrev = $panel.find('.slick-prev');
		var $slickNext = $panel.find('.slick-next');
		
		if ($moreLink.length && $slickPrev.length && $slickNext.length) {
			$moreLink.insertAfter($slickNext);
		}
	});
}

function runFocusPoint() {
	// check if focuspoint function defined
	if (typeof $().focusPoint === "function") {
		// Banner Focus Point
		$('.focuspoint').focusPoint({
			reCalcOnWindowResize: true,
			throttleDuration: 100,
		});
	}
}

function findFocusPointImgSize(thisImg, width, height) {
	if ($(thisImg).hasClass('Img-Focus-Left')) {
		$(thisImg).wrap('<div class="focuspoint" data-focus-x="-.5" data-focus-y="0" data-image-w="' + width + '" data-image-h="' + height + '"></div>');
	}
	if ($(thisImg).hasClass('Img-Focus-Right')) {
		$(thisImg).wrap('<div class="focuspoint" data-focus-x=".5" data-focus-y="0" data-image-w="' + width + '" data-image-h="' + height + '"></div>');
	}
	if ($(thisImg).hasClass('Img-Focus-Center')) {
		$(thisImg).wrap('<div class="focuspoint" data-focus-x="0" data-focus-y="0" data-image-w="' + width + '" data-image-h="' + height + '"></div>');
	}
	runFocusPoint();
}

function addFocalPoint() {
	// if pulling this function - also pull findFocusPointImgSize & runFocusPoint functions
	var realWidth = '0',
		realHeight = '0';
        
	$('img.Img-Focus-Left, img.Img-Focus-Right, img.Img-Focus-Center').each(function(i, elem) {
		$("<img>").attr("src", $(this).attr("src")).on('load', function() {
			realWidth = this.width;
			realHeight = this.height;
			findFocusPointImgSize(elem, realWidth, realHeight); //call a function here and send the values outside 
		});
	});
}

function tablesContainer() {
	/* Add TableContainer around tables to make scrollable on small screens */
	$('.cmspage table, .cmspanel table').each(function() {
		$(this).wrap('<div class="TableContainer" tabindex="0" />');
	});
}

function youTubeContainer() {
	/* On iframed YouTube videos: add .VideoContainer div for responsiveness + move class names from iframe to this container for any additional styling such as right or left alignments & wrap with max width of iframe width, keeping the video from expanding beyond initial size */
	$('iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"]').not('iframe.modaal-video-frame').each(function () {
		var setVideoWidth = $(this).attr('width');
		var setClassName = $(this).attr('class');
        $(this).wrap('<div style="max-width:' + setVideoWidth + 'px;"><div class="VideoContainer ' + setClassName + '" /></div>').removeAttr('class');
	});
}

function hideDescriptionOrThumbnail() {
	/* Adding option to hide descriptions only or thumbnails only on related or recent pages SmartPanel */
    $('.cmspanel .Hide-Panel-Descriptions').parents('.cmspanel').addClass('NoDescriptions');
	$('.cmspanel .Hide-Panel-Thumbnails').parents('.cmspanel').addClass('NoThumbnails');
}

function realImageSize(thisImg, width) {
	// Needed for addCaptionWidth function
	$(thisImg).parent('figure.Caption').attr('style','max-width: ' + width + 'px;');
}

function addCaptionWidth() {
	// Apply width to caption to match actual image width - making captions width flexible
	var realWidth = '0';

	$('figure.Caption > img').each(function (i, elem) {
		var $elem = $(elem);

		if ($elem.attr('width') !== undefined) {
			realWidth = $elem.attr('width');
			realImageSize(elem, realWidth);
		} else {
			$("<img>").attr("src", $elem.attr("src")).on('load', function () {
				realWidth = this.width;
				realImageSize(elem, realWidth);
			});
		}
	});
}

function countUpToNumber() {
	// Count up to number Script
	$('.InlineContent').each(function(i) {
		$(this).find('.count-number-function').data('countToOptions', {
			formatter: function (value, options) {
				return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
			}
		});

		function count(options) {
			var $this = $(this);
			options = $.extend({}, options || {}, $this.data('countToOptions') || {});
			$this.countTo(options);
		}

		var counter = 0;
		var coordinates = $(this).find('.count-number-function').offset();
		var $timers = $(this).find('.count-number-function');
		var timerInView = false;

		function onScroll() {
			var myPosition = $(window).scrollTop() + $(window).height();
			if(coordinates) {
				if (myPosition >= coordinates.top) {
					if (counter === 0) {
						$timers.each(count);
					}
					counter = 1;
					timerInView = true;
				} else {
					timerInView = false;
				}
			}
			if (timerInView) {
				$(window).off('scroll', onScroll);
			}
		}

		$timers.each(function() {
			var timerCoordinates = $(this).offset();
			if (timerCoordinates) {
				if ($(window).scrollTop() + $(window).height() > timerCoordinates.top && $(window).scrollTop() < timerCoordinates.top + $(this).outerHeight()) {
					count.call(this);
					timerInView = true;
				}
			}
		});

		if (timerInView) {
			$(window).off('scroll', onScroll);
		} else {
			$(window).on('scroll', onScroll);
		}
	});
}

function relatedHubContent() {
    // variables set globally to apply to hub home and hub panels on interior
    var relatedTermIds = ["930e39ce-3f4a-ed11-a86c-000d3a619f08"];//relatedTermIds should be the term id of the Content Hub Page Term under the Content Hub Page facet.

    // HUB PANEL CONTENT MARKUP
    //====================================================
    var panelCards = function (page) {
        var element = "<article aria-labelledby='article" + page.pageid + "' class='item " + page.contentTopic + " " + page.serviceLines + " " + page.contentAuthor + "' id='" + page.pageid + "'>" +
			"<a href='" + page.url + "'>" +
				"<span class='ImageWrap2'><span class='ImageWrap'>" + page.image + page.contentTopicTag + "</span></span>" +
				"<span class='ContentWrap'>" +
					"<span class='Title' id='article" + page.pageid + "' role='heading' aria-level='2'>" + page.title + "</span>" +
					"<span class='Date'>" + page.newDateFormat + "</span>" +
					"<span class='Description'>" + page.snippet + " <span class='ReadMore'>Read More</span></span>" +
				"</span>" +
			"</a>" +
		"</article>";
        return element;
    };

    // BUILD OUT PUB DATE
    //====================================================
    function buildPubDate(cmspage) {
        var pubDate = cmspage.OriginalPublicationDate;
        return convertDate(pubDate);
    }
    // REFORMATTING PUBLICATION DATE
    //====================================================
    function convertDate(date) {
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            splitDate = date.split('-');
        return months[parseInt(splitDate[1])-1] + " " + splitDate[2] + ", " + splitDate[0];
    }
    // SETTING VARIABLES FOR HUB STORIES PANEL
    //====================================================
    var totalRecords = '',
        pageNum = 1,
        pageSizeValue = 10,
        hubPanelLoaded = 'no',
        items = [],
        itemCount = 0,
		$panelContainer,
        currentPageId = $('meta[name="CmsPageId"]').attr('content');

	// KICKING OFF PANELS FOR HUB STORIES
    //====================================================
    $('.cmspanel, .InlineContent').each(function() {
        if ($(this).find('.Hub-Stories').length) {
            $(this).addClass('Hub');
        }
    });
     
    if ($('.Hub-Stories').length) {
        // running page API for: Content Hub Page term
        hubPanelLoaded = 'Yes';
        pageSizeValue = 10;
        getHubPanelContent( hubPanelLoaded, relatedTermIds, pageSizeValue, pageNum, currentPageId );
    }

	// Finding taxonomy terms from the page to relate content
	//====================================================
	$('.Hub-Stories').each(function() {
		//CURRENTLY HUB PAGE AND STANDARD INTERIOR PAGE ARE USING THE SAME FACETS FOR THIS PANEL, BUT THIS IS SETUP TO ALLOW FOR DIFFERENT IF NEEDED

		if (("taxonomy" in VitalSite) && VitalSite.taxonomy !== null && $('body.ContentInterior').length) {
			var taxonomy = VitalSite.taxonomy;
			$(taxonomy).each(function (i, element) {
				$(element.Terms).each(function (j, elm) { //loop through all of the terms for the page
					if (element.FacetName === 'Service Line' || element.FacetName === 'Healthy Together Topic') { //found 'Service Line' or 'Healthy Together Topic'
						relatedTermIds.push( elm.TermId );
					}
				});
			});
            //console.log('content hub page');
		} else if (("taxonomy" in VitalSite) && VitalSite.taxonomy !== null && !$('body.ContentInterior').length) {
			var taxonomy = VitalSite.taxonomy;
			$(taxonomy).each(function (i, element) {
				$(element.Terms).each(function (j, elm) { //loop through all of the terms for the page
					if (element.FacetName === 'Service Line' || element.FacetName === 'Healthy Together Topic') { //found 'Service Line' or 'Healthy Together Topic'
						relatedTermIds.push( elm.TermId );
					}
				});
			});
            //console.log('basic page');
		}

		$panelContainer = $(this);
		hubPanelLoaded = 'Yes';
		pageSizeValue = 10;
		getHubPanelContent( $panelContainer, hubPanelLoaded, relatedTermIds, pageSizeValue, pageNum, currentPageId );
	});
	
    // GETTING CONTENT FOR HUB STORIES PANEL
    //====================================================
    async function getHubPanelContent( $panelContainer, hubPanelLoaded, relatedTermIds, pageSizeValue, pageNum, currentPageId ) {
        $.getCmsPages({
            pageNumber: pageNum,
            pageSize: pageSizeValue,
            sort: 11,
            fields  : "PageId, Name, publichref, originalPublicationDate, Description, Images, Taxonomy",
            criteria: {
                originalpublicationbegindate: "01/01/2013",
                relatedTermIds: relatedTermIds
            }
        }, function (data) {
            //store totalRecords in variable
            totalRecords = data.TotalRecords;
            //var pages = Math.ceil(totalRecords / pageSizeValue);
            for (var i in data.Values) {
                var cmspage = data.Values[i];
                var item = {
                    title: cmspage.Name,
                    pageid: cmspage.PageId,
                    url: cmspage.PublicHRef.replace(/~/g, ''),
                    newDateFormat: buildPubDate(cmspage),
                    snippetRaw: cmspage.Description,
					snippet: '',
                    imageSrc: (typeof cmspage.Images[0] !== 'undefined') ? "/app/files/public/" + cmspage.Images[0].FileName : "/imgs/hub-thumb.jpg",
                    image: (typeof cmspage.Images[0] !== 'undefined') ? "<img aria-hidden='true' alt='" + cmspage.Images[0].FileTitle + "' src='/app/files/public/" + cmspage.Images[0].FileName + "'/>" : "<img aria-hidden='true' alt='' src='/imgs/hub-thumb.jpg' />",
                    contentTopic: '',
                    eachTopicTermWithNobr: '',
                    contentTopicTag: '',
                    serviceLines: '',          
                    contentAuthor: '',
                    eachAuthorTermWithNobr: '',
                    contentAuthorTag: '',
                    topicTerms: [],
                    serviceTerms: [],
                    authorTerms: [],
					maxLength: 18
                };
				
				if(((item.snippetRaw).split(/\s+/)).length > (item.maxLength)) {
					item.snippet = ((item.snippetRaw).split(/\s+/).slice(0,18).join(" "))+'<span>... </span>';
				} else {
					item.snippet = item.snippetRaw;
				}

                for (i in cmspage.Taxonomy) {
                    //set variable to taxonomyy object
                    var Taxonomy = cmspage.Taxonomy[i];
                    //check for taxonomy = Healthy Together Topic
                    if (Taxonomy.FacetName === 'Healthy Together Topic') {
                        //loop through taxonomy for terms
                        for (i in Taxonomy.Terms) {
                            //set variable to terms object
                            var topicTerm = Taxonomy.Terms[i];
                            //add terms to array
                            item.topicTerms.push(topicTerm.Name);
                        }
                        item.contentTopic = (item.topicTerms.toString().replace(/\s+/g, '').replace(/,/g, ' ').replace(/[^a-zA-Z 0-9]+/g,''));
                        //(this takes topics from taxonomy and if it's not undefined & it's not marked "_No Topic" then set any others to this variable), also add in comma between each Topic term
                        item.eachTopicTermWithNobr = "<span class='nobr'>" + (item.topicTerms.toString().replace(/,/g, ',</span> <span class="nobr">')) + "</span>";
                        item.contentTopicTag = (item.topicTerms.toString() !== 'undefined' && item.topicTerms.toString() !== '_No Topic') ? "<div class='Topic'><span>" + item.eachTopicTermWithNobr + "</span></div>" : "";
                    }
                    //check for taxonomy = Service Line
                    if (Taxonomy.FacetName === 'Service Line') {
                        //loop through taxonomy for terms
                        for (i in Taxonomy.Terms) {
                            //set variable to terms object
                            var serviceTerm = Taxonomy.Terms[i];
                            //add terms to array
                            item.serviceTerms.push(serviceTerm.Name);
                        }
                        item.serviceLines = (item.serviceTerms.toString().replace(/\s+/g, '').replace(/,/g, ' ').replace(/[^a-zA-Z 0-9]+/g,''));
                    }
                    //check for taxonomy = Healthy Together Author
                    if (Taxonomy.FacetName === 'Healthy Together Author') {
                        //loop through taxonomy for terms
                        for (i in Taxonomy.Terms) {
                            //set variable to terms object
                            var authorTerm = Taxonomy.Terms[i];
                            //add terms to array
                            item.authorTerms.push(authorTerm.Name);
                        }
                        item.contentAuthor = (item.authorTerms.toString().replace(/\s+/g, '').replace(/[^a-zA-Z 0-9]+/g,''));
                        //(this takes authors from taxonomy and if it's not undefined & it's not marked "_No Author" then set any others to this variable), also add in comma between each author term
                        item.eachAuthorTermWithNobr = "<span class='nobr'>" + (item.authorTerms.toString().replace(/,/g, ',</span> <span class="nobr">')) + "</span>";
                        item.contentAuthorTag = (item.topicTerms.toString() !== 'undefined' && item.authorTerms.toString() !== '_No Topic') ? "<div class='Topic'><span>" + item.eachAuthorTermWithNobr + "</span></div>" : "";
                    }
                } //end taxonomy loop
                 
                if (data.Values.length > 0 && $($panelContainer).length) {
                    if (item.pageid != currentPageId) {
                        items.push(item);
                    } else {
                        //if the items page id is the current page remove one from the total records since it's not written in the markup
					    totalRecords = totalRecords - 1;
                    }
                }
                 
                //IF THERE ARE RESULTS THEN BUILD OUT BASED ON CARDS DATA
                for (itemCount; itemCount < pageSizeValue*pageNum && itemCount < items.length; itemCount++) {
                    var cardsData = panelCards(items[itemCount]);
                    //Hub panels will have .Hub-Stories
                    $($panelContainer).append (cardsData);
                }
            }
             
            $($panelContainer).parents('.cmspanel.Hub, .InlineContent.Hub').addClass('ItemCount' + totalRecords + '');
            $('.Loading').remove();
            if (hubPanelLoaded === 'Yes') { //hubPanelLoaded is 'no' until final api call is made
                $($panelContainer).parents('.cmspanel.Hub, .InlineContent.Hub').addClass('ItemsLoaded');
                sliders();
				sliderArrow();
            }
            // remove hub panel if no stories load
            $($panelContainer).parents('.cmspanel.Hub, .InlineContent.Hub').each(function() {
                if ($(this).hasClass('ItemCount0')) {
                    $(this).remove();
                }
            });
        });
    }
}

function replaceTime(el) {
	//updating time formats
    $all = el.html();
    //finds non-on-the-hour (1:30) time and removes space between number and AM/PM 
    $all = $all.replace(/(1[012]|[1-9])(:[1-5][0-9])+ ?([AaPp][mM])/g, "$1$2$3");
    //finds on-the-hour time (1:00) time and removes the :00 as well as the space between number and AM/PM 
    $all = $all.replace(/(1[012]|[1-9])(:[0][0])+ ?([AaPp][mM])/g, "$1$3");
    //removes the space before and after - seperating start/end time 
    $all = $all.replace(/([0-9][aApP][mM]|[0-9]:[0-9][0-9][aApP][mM]|[1][0-9]:[0-9][0-9][aApP][mM]|[1][0-9][aApP][mM]) - ([0-9][aApP][mM]|[0-9]:[0-9][0-9][aApP][mM]|[1][0-9]:[0-9][0-9][aApP][mM]|[1][0-9][aApP][mM])/g, "$1-$2");
    //removes the space before and after to seperating start/end time 
    $all = $all.replace(/([0-9][aApP][mM]|[0-9]:[0-9][0-9][aApP][mM]|[1][0-9]:[0-9][0-9][aApP][mM]|[1][0-9][aApP][mM]) to ([0-9][aApP][mM]|[0-9]:[0-9][0-9][aApP][mM]|[1][0-9]:[0-9][0-9][aApP][mM]|[1][0-9][aApP][mM])/g, "$1-$2");

    //replaces capital AM/PM after time format to am/pm lowercase 
    $all = $all.replace(/([0-9][aApP][mM] ?)/g, function (x) { return x.toLowerCase() });
    //changing 12pm to 12noon 
    $all = $all.replace(/([1][2])([pm][m])/g, "noon");
    el.html($all);
}

function updateTimeFormat() {
	// if pulling this make sure to also pull the replaceTime(el) function
	// (alter as needed or remove) Altering time display to match 9am-12:30pm and 12noon
	$(".EventTime").each(function () {
		replaceTime($(this));
	});
	$(".EventTimes").each(function () {
		replaceTime($(this));
	});
	$(".TimeCol").each(function () {
		replaceTime($(this));
	});
	$(".ResultsContainer").each(function () {
		replaceTime($(this));
	});
}

function arrowLinkStyle() {
	// ADDING ARROW STYLE ON "Arrow-Link" CLASS
	$('a.Arrow-Link, a.Button-Arrow-Link, a.Button-Secondary-Arrow-Link').each(function () {
		//add nowrap span to last word so that last word and arrow don't wrap separately
		$(this).html(function(){
			// separate the text by spaces
			var text= $(this).text().split(' ');
			// drop the last word and store it in a variable
			var last = text.pop();
			// join the text back and if it has more than 1 word add the span tag to the last word
			return text.join(" ") + (text.length >= 0 ? ' <span class="nowrap">'+last+'</span>' : last);
		});
		//add arrow button
		$(this).find('> span').append(' <span class="ArrowIcon" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.833496 6.66665H12.5002M12.5002 6.66665L6.66683 0.833313M12.5002 6.66665L6.66683 12.5" stroke="#004263" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></span>');
	});
	// ADDING CHEVRON STYLE ON "Chevron-Link" CLASS
	$('a.Chevron-Link, a.Button-Chevron-Link, a.Button-Secondary-Chevron-Link').each(function () {
		//add nowrap span to last word so that last word and arrow don't wrap separately
		$(this).html(function(){
			// separate the text by spaces
			var text= $(this).text().split(' ');
			// drop the last word and store it in a variable
			var last = text.pop();
			// join the text back and if it has more than 1 word add the span tag to the last word
			return text.join(" ") + (text.length >= 0 ? ' <span class="nowrap">'+last+'</span>' : last);
		});
		//add arrow button
		$(this).find('> span').append(' <span class="ChevronIcon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M0.833252 10.8334L5.83325 5.83337L0.833252 0.833374" stroke="#D5E5F0" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></span>');
	});
}

function resizeEvent() {
	//Needed for Lightbox options multi video
	$(window).trigger('resize');
}

function lightboxOptions() {
	// Lightbox Options
	$('a.Lightbox-for-multi-videos').modaal({
		custom_class: 'Multi-Video-Lightbox modaal-video',
		after_open: resizeEvent
	});
	$('a.Lightbox-for-inline').modaal();
	$("a.Lightbox-for-img").modaal({ type: 'image' });
	$("a.YouTubeVideo").modaal({ type: 'video' }); // .YouTubeVideo also adds the video icon overtop of the image inside this link
	$("a.Lightbox-for-video").modaal({ type: 'video' });
	$("a.Lightbox-for-iframe").modaal({ 
		type: 'iframe',
		width: 1000
	});
}

function drSmartPanelMarkup() {
	$('#DrSmartPanel.BecomesSlider').parents('.cmspanel').addClass('NoMarginRight');

	if ($('#DrSmartPanel').length) {
		$('#DrSmartPanel dl').each(function() {
			$(this).replaceWith(
				$(this).html()
					.replace(/<dl/gi, "<div ")
					.replace(/<dd/gi, "<div")
					.replace(/<\/dd>/gi, "</div>")
					.replace(/<dt/gi, "<div class=\"Name\"><strong")
					.replace(/<\/dt>/gi, "</strong></div>")
					.replace(/<\/dl/gi, "</div")
			);
		});
		// $('#DrSmartPanel .SPItem .Picture img').each(function() {
		// 	var src = $(this).attr('src');
		// 	$(this).attr('src', src.replace('?size=small', '?size=medium'));
		// 	$(this).unwrap('a');
		// });
		$('#DrSmartPanel .SPItem .Picture img').each(function() {
			var src = $(this).attr('src');
			if ((src.includes('/imgs/doctors/silhouette_female.gif')) || (src.includes('/imgs/doctors/silhouette_male.gif'))) {
				$(this).attr('src', '/imgs/shared/doctors/silhouette.svg');
			} else {
				$(this).attr('src', $(this).attr('src').replace('?size=small','?size=medium'));
			}
			$(this).unwrap('a');
		});
	}
}

function locationSmartPanelMarkup() {
	$('#SmartPanelLocations.BecomesSlider').parents('.cmspanel').addClass('NoMarginRight');

	// look to see if HideImage class exists in panel
	$('.HideImage').parents('.cmspanel').addClass('HideImage');
	if ($('.cmspanel.HideImage').length) {
		$('.cmspanel.HideImage .SmartPanel').addClass('HideImage');
	}
	// Uncomment below if statement if you need to float the image to the left. 
	// This will wrap contents under the image in a div and fix all other elements to divs for accessibility
	// Then you just need to add a float: left to the .Picture and an Overflow: hidden to the .LocationInfo

	if ($('#SmartPanelLocations').length) {
		$('#SmartPanelLocations dl').each(function () {
			$('#SmartPanelLocations dd.Picture').replaceWith(function() {
				return '<div class="Picture">' + $(this).html() + '</div>';
			});

			$(this).find('dt, dd.Phone, dd.Address').wrapAll('<div class="LocationInfo" />');
			$(this).find('dt').replaceWith(function() {
				return '<strong class="Name">' + $(this).html() + '</strong>';
			});
			$(this).find('dd.Phone').replaceWith(function() {
				return '<div class="Phone">' + $(this).html() + '</div>';
			});
			$(this).find('dd.Address').replaceWith(function() {
				return '<div class="Address">' + $(this).html() + '</div>';
			});
			$(this).find('> *').unwrap();
		});
	}
	// $('#SmartPanelLocations .SPItem .Picture img').each(function() {
	// 	$(this).unwrap('a');
	// 	$(this).attr('src', $(this).attr('src').replace('?size=locsmall',''));
	// });

	$('#SmartPanelLocations .SPItem .Picture img').each(function() {
		var src = $(this).attr('src');
		if (src.includes('/imgs/locations/silhouette_small.gif')) {
			$(this).attr('src', '/imgs/shared/locations/silhouette.svg');
		} else {
			$(this).attr('src', $(this).attr('src').replace('?size=locsmall',''));
		}
		$(this).unwrap('a');
	});
}


// Location profile functions start here
function setOpenAllHours() {
    'use strict';
    // check location hours for 24 hours and set button text
    var hoursWrap = $('#LocationsDetail .HoursWrap, .NcSurgery .HoursWrap'),
		hoursButton = $('#LocationsDetail .HoursOpButton, .NcSurgery .HoursOpButton'),
        hoursButtonText = $('#LocationsDetail .HoursOpButton .Button span.Current, .NcSurgery .HoursOpButton .Button span.Current'),
		hoursHoursText = $('#LocationsDetail .HoursOpButton .Button span.HoursText, .NcSurgery .HoursOpButton .Button span.HoursText'),
		hoursHoursInfo = $('#LocationsDetail #HoursInfoWrap, .NcSurgery #HoursInfoWrap'),
        hoursOpenCount = 0;

    $("#LocationsDetail .Hours .DaySchedule .Times:contains('Open 24 Hours'), .NcSurgery .Hours .DaySchedule .Times:contains('Open 24 Hours')").closest('.DaySchedule').addClass('OpenHours');
    
    $('#LocationsDetail .Hours .DaySchedule.OpenHours, .NcSurgery .Hours .DaySchedule.OpenHours').each(function () {
        hoursOpenCount++;
        if ((hoursOpenCount = 7) && ($('#OfficeHoursComment p').length > 0)) {
            $(hoursButton).addClass('OpenAllHoursComment');
			$(hoursWrap).addClass('OpenAllHoursCommentWrap');
            $(hoursButtonText).text('Open 24 Hours');
			$(hoursHoursText).addClass('Hide');
			$(hoursHoursInfo).addClass('OpenAllHoursInfo');
            $('#LocationsDetail #HoursInfoWrap .Hours > .Heading').addClass('Hide');
			$('#LocationsDetail #HoursInfoWrap .Hours > .DaySchedule').addClass('Hide');
			$('#OfficeHoursComment').addClass('AllHours');
            
        } else if ((hoursOpenCount = 7) && ($('#OfficeHoursComment p').length === 0)) {
            $(hoursButton).addClass('OpenAllHours');
			$(hoursWrap).addClass('OpenAllHoursWrap');
            $(hoursButtonText).text('Open 24 Hours');
			$(hoursHoursText).addClass('Hide');
			$(hoursHoursInfo).addClass('OpenAllHoursInfo');
            $('.HoursOpButton .Button img, .HoursOpButton .Button span').unwrap();
            $('.HoursOpButton img, .HoursOpButton span').wrapAll('<span class="Button"></span>');
            $('#LocationsDetail #HoursInfoWrap').addClass('Hide');
        }
    });
}

function locationHours() {
	/* Location profile hours dropdow and button text
	------------------------------------------------------------------ */
    $('#LocationsDetail, .NcSurgery').on('click', '.HoursOpButton:not(.OpenAllHours) .Button', function () {
        $('#LocationsDetail #HoursInfoWrap, .NcSurgery #HoursInfoWrap').slideToggle();
        $(this).toggleClass('Active');
        $('#HoursInfoWrap').toggleClass('Active');
        if($('#LocationsDetail .HoursOpButton .Button.Active, .NcSurgery .HoursOpButton .Button.Active').length) {
            $('#LocationsDetail #HoursInfoWrap, .NcSurgery #HoursInfoWrap').attr('aria-hidden', 'false');
            $(this).attr('aria-expanded', 'true');
        } else {
            $('#LocationsDetail #HoursInfoWrap, .NcSurgery #HoursInfoWrap').attr('aria-hidden', 'true');
            $(this).attr('aria-expanded', 'false');
        }
        return false;
    });

	$('#LocationsDetail #HoursInfoWrap .Hours .DaySchedule.TodaysWeekday, .NcSurgery #HoursInfoWrap .Hours .DaySchedule.TodaysWeekday').clone().appendTo(".HoursOpButton .Button span.Current");
    setOpenAllHours();

    // ANY CLICK OUTSIDE OF THE LOCATION PROFILE HOURS DROPDOWN AREA WILL CLOSE THE HOURS BOX
	//====================================================
    $(document.body).on('click', function (e) {
		if ($('#HoursInfoWrap').has(e.target).length === 0) {
			$('.HoursOpButton .Button.Active').toggleClass('Active');
            $('#HoursInfoWrap').attr('aria-expanded', 'false');
            $('#HoursInfoWrap').toggleClass('Active').attr('style','display: none;');
		}
	});

    /* If Location Profile doesn't have hours - remove section
	------------------------------------------------------------------ */
	if ($('#LocationsDetail #HoursInfoWrap > div').length === 0) {
        $('#LocationsDetail .HoursOpButton').remove();
        $('#LocationsDetail #HoursInfoWrap').remove();
        $('#LocationsDetail .AdrPhone').addClass('NoHours');
    }
	if ($('#LocationsDetail #HoursInfoWrap .Hours').length === 0) {
        $('#LocationsDetail #HoursInfoWrap').addClass('NoHours');
    }
    if ($('#LocationsDetail #HoursInfoWrap .Hours .DaySchedule').length === 0) {
        $('#LocationsDetail .HoursOpButton .Button span.Current').text('Hours of Operation');
    }

	 /* If Location Profile doesn't have hours - remove section
	------------------------------------------------------------------ */
	if (($('#LocationsDetail #HoursInfoWrap .Hours').length === 0) && ($('#LocationsDetail #HoursInfoWrap #OfficeHoursComment').length === 0)) {
        $('#LocationsDetail .HoursOpButton').remove();
        $('#LocationsDetail #HoursInfoWrap').remove();
    }
}

function pagesSmartPanelMarkup() {
	$('#SmartPanelNewsRecent.BecomesSlider, #SmartPanelNewsRelated.BecomesSlider, #SmartPanelPagesRelated.BecomesSlider').parents('.cmspanel').addClass('NoMarginRight');
	// $('#SmartPanelNewsRecent .SPItem img').each(function () {
	// 	var src = $(this).attr('src');
	// 	$(this).attr('src', src.replace('?size=small', ''));
	// });
	// In SmartPanel page results replace the small from image
	$('.SP-CmsPage-Images .SPItem .Thumbnail img').each(function () {
		var src = $(this).attr('src');
		$(this).attr('src', src.replace('?size=small', ''));
	});
	// Reordering elements in pages with image smartpanel
	$('.SP-CmsPage-Images .SPItem').each(function () {
		$(this).find('.Headline, .Article').wrapAll('<div class="Card"></div>');
		$(this).find('.Article').insertAfter($(this).find('.Headline'));
		$(this).find('.PublicationDate').insertBefore($(this).find('.Description'));
	});
	// add classes to identify if default image is used for news 
	$('#SmartPanelNewsRecent.BecomesSlider .Thumbnail img, #SmartPanelNewsRelated.BecomesSlider .Thumbnail img, #SmartPanelPagesRelated.BecomesSlider .Thumbnail img').each(function() {
		var src = $(this).attr('src');
		if (src && (src.includes('../app/files/public/Rex-logo-for-social.png') || src.includes('../app/files/public/Chatham-logo-for-social.png') || src.includes('../app/files/public/UNC-logo-for-social.png') || src.includes('../app/files/public/Logo-for-social.png') || src.includes('app/files/public/Logo-for-social.png') || src.includes('app/files/public/UNCHealthJohnstonLogo%20-%20social%20sharing2.png') || src.includes('app/files/public/2022RockinghamLogo-SocialSharing.png') || src.includes('app/files/public/Wayne-logo-for-social.png'))) {
			$(this).parent('.Thumbnail').addClass('DefaultThumbnailWrap');
			$(this).addClass('DefaultThumbnail');
		}
	});
}

function viewMoreLinkFixes() {
	// updates to the view more text for accessibility (no more repetative 'View More' text)
    $('.Events-Upcoming-Calendar .MoreLink > a, .Events-Upcoming .MoreLink > a').text('More Upcoming Events');
    $('.Events-Related .MoreLink > a').text('More Related Events');
	$('#SmartPanelServiceDirectory .MoreLink > a').text('More Services');
	$('#SmartPanelLocations .MoreLink > a').text('More Locations');
	$('#DrSmartPanel .MoreLink > a').text('More Doctors');

    //custom - define more link text based on first h2 or h3 if it exists
    // if ($('#DrSmartPanel .MoreLink > a').length) {
    //     var headerText = 'doctors';
    //     if ($('#DrSmartPanel').parent().prev('.cmsPanelContent').find('> h2:first-child').length) {
    //         var headerText = $('#DrSmartPanel').parent().prev('.cmsPanelContent').find('> h2:first-child').text();
    //         $('#DrSmartPanel .MoreLink > a').text("More " + headerText);
    //     }
    //     else if ($('#DrSmartPanel').parent().prev('.cmsPanelContent').find('> h3:first-child').length) {
    //         var headerText = $('#DrSmartPanel').parent().prev('.cmsPanelContent').find('> h3:first-child').text();
    //         $('#DrSmartPanel .MoreLink > a').text("More " + headerText);
    //     }
    //     else {
    //         $('#DrSmartPanel .MoreLink > a').text("More " + headerText);
    //     }
    // }
    //custom - define more link text based on first h2 or h3 if it exists
    // if ($('#SmartPanelLocations .MoreLink > a').length) {
    //     var headerText = 'locations';
    //     if ($('#SmartPanelLocations').parent().prev('.cmsPanelContent').find('> h2:first-child').length) {
    //         var headerText = $('#SmartPanelLocations').parent().prev('.cmsPanelContent').find('> h2:first-child').text();
    //         $('#SmartPanelLocations .MoreLink > a').text("More " + headerText);
    //     }
    //     else if ($('#SmartPanelLocations').parent().prev('.cmsPanelContent').find('> h3:first-child').length) {
    //         var headerText = $('#SmartPanelLocations').parent().prev('.cmsPanelContent').find('> h3:first-child').text();
    //         $('#SmartPanelLocations .MoreLink > a').text("More " + headerText);
    //     }
    //     else {
    //         $('#SmartPanelLocations .MoreLink > a').text("More " + headerText);
    //     }
    // }

    $('#SmartPanelPagesRelated, #SmartPanelNewsRecent').each(function() {
        var headerText = 'View more';
        if ($(this).parents('.cmspanel').find('.SmartPanel-Link-Text').length) {
            headerText = $(this).parents('.cmspanel').find('.SmartPanel-Link-Text').text();
            $(this).find('.MoreLink > a').text(headerText);
        }
    });


}

function siteSearch() {
	// SITE SEARCH: change Site Search tab to "All"
	$('#SiteSearchContainer .Tabnav li:contains("Site Search") > *').text('All');

	// SITE SEARCH: change view more button text for accessibility (no more repetative 'View More' text)
	$("#SiteSearchContainer h2:contains('Related Pages')").closest('.group').addClass('Pages');
    $('#SiteSearchContainer .Pages a.Button').text('View More Pages');

    $("#SiteSearchContainer h2:contains('Related Providers')").closest('.group').addClass('Doctors');
    $('#SiteSearchContainer .Doctors > p a.Button').text('View More Doctors');

    $("#SiteSearchContainer h2:contains('Related Locations')").closest('.group').addClass('Locations');
    $('#SiteSearchContainer .Locations > p a.Button').text('View More Locations');

    $("#SiteSearchContainer h2:contains('Related Events')").closest('.group').addClass('Events');
    $('#SiteSearchContainer .Events a.Button').text('View More Events');

}

function pagesModuleMarkup() {
	// Swap tags in pages results with strong tag for accessibility.
	if ($('.PageList > ul > li .Headline h3').length) {
		$('.PageList > ul > li .Headline h3').each(function() {
			$(this).replaceWith(function () {
				return $('<strong/>', {html: this.innerHTML});
			  });
		});
	}
	// In page results with image for module results move pub date before description for consistency & remove small on image
	if ($('[id*="_PageListItem_ListItemImage"]').length) {
		$('[id*="_PageListItem_ListItem"]').each(function () {
			$(this).find('.PublicationDate').insertBefore($(this).find('.Description'));
		});

		$('[id*="_PageListItem_ListItemImage"] img').each(function() {
			var src = $(this).attr('src');
			$(this).attr('src', src.replace('small', 'loclarge'));
		});
	}
}

function formsDocumentsMarkup() {
	$('#FormsAndDocuments .Overflow dl').each(function () {
		var $dl = $(this);

		$dl.find('dt').each(function () {
			$(this).replaceWith(function () {
				return $('<li/>', {
					html: this.innerHTML,
					'class': this.className
				});
			});
		});

		$dl.replaceWith(function () {
			return $('<ul/>', {
				html: this.innerHTML,
				'class': this.className
			});
		});
	});
}

function calendarModuleMarkup() {
	// moving event status
	if ($('.CalendarDetailContent .EventStatus').length) {
		$('.CalendarDetailContent .EventStatus').insertAfter('.CalendarDetailContent fieldset');
	}
	// swap out header for correct hierarchy
	$('.CalendarDetailTop h4.Trigger').each(function() {
		$(this).replaceWith(function () {
			return $('<h2/>', {html: this.innerHTML}).addClass('Trigger');
		});
	});
	// check to see how many inputs are in the searchbox and then apply a class so we can style accordingly
	if ($('#PageContent .cmspage .CalendarList .SearchBox .categoryDropDownDiv').length) {
		$('.CalendarList .SearchBox').addClass('WithDropdown');
	}
	// Swap tags in events results for accessibility.
	$('.EventResults > h3, .RegDetails > h4, .FeeDetails > h4').each(function() {
		$(this).replaceWith(function () {
			return $('<h2/>', {html: this.innerHTML});
		});
	});
	// swap out header for correct hierarchy
	$('.EventResults .ResultsContainer h4').each(function() {
		$(this).replaceWith(function () {
			return $('<h3/>', {html: this.innerHTML});
		});
	});
	$('.EventResults .ResultsContainer dd > h5').each(function() {
		$(this).replaceWith(function () {
			return $('<strong/>', {html: this.innerHTML});
		});
	});

	//if ($('.cmspage .CalendarDetail').length) { convertTable(); }

	// function convertTable() {
	// // Convert table to divs with classes
	// 	$('.CalendarDetailContent table.CalendarEventDetailHeader').replaceWith(
	// 		$('.CalendarDetailContent table.CalendarEventDetailHeader').html()
	// 			.replace(/<tbody/gi, "<div class='Table'")
	// 			.replace(/<tr/gi, "<div")
	// 			.replace(/<\/tr>/gi, "</div>")
	// 			.replace(/<td/gi, "<div")
	// 			.replace(/<\/td>/gi, "</div>")
	// 			.replace(/<\/tbody/gi, "</div")
	// 	);

	// 	// Convert table to divs with classes
	// 	$('.AccordionContentInside table.CalendarEventDetailHeader').replaceWith(
	// 		$('.AccordionContentInside table.CalendarEventDetailHeader').html()
	// 			.replace(/<tbody/gi, "<div class='Table'")
	// 			.replace(/<tr/gi, "<div")
	// 			.replace(/<\/tr>/gi, "</div>")
	// 			.replace(/<td/gi, "<div")
	// 			.replace(/<\/td>/gi, "</div>")
	// 			.replace(/<\/tbody/gi, "</div")
	// 	);
	// }
}

function servicesModuleMarkup() {
	// SERVICES MODULE: moving h2 back out of tab container
	$('#ServicesSearch h2.TabHeader').insertBefore('#ServicesSearch .Tab').replaceWith(function() {
		return '<h2>' + $(this).text() + '</h2>';
	});
	// SERVICES MODULE: removeing tab on 'Services (A-Z) because there are no other clickable tab and empty input
	$('#ServicesSearch ul.Tabnav, #ServicesSearch input.ActiveTabFld').remove();
}

function doctorsSearchModuleMarkup() {
	// DOCTORS MODULE SEARCH: moving gender after physician last name field
	$('.DrSearch .Gender').insertAfter('.DrSearch .PhysicianLast');
}

function locationHoursOnProviders() {
	var locCount = 0;

	// DOCTORs MODULE DETAILS: add hours of operation (this gets called within the razor partial - do not remove this) (locationHoursOnProviders gets called only on page load, buildLocationHours gets called within this and on infiniteScroll if used)
    $('#DrDetail .LocationsContainer > ul > li, #DrResults.ModuleSearchResults li.GMapAddressList').each(function () {
        buildLocationHours(this);
    });

	function buildLocationHours(el) {

		var locId = $(el).attr('id') !== null && $(el).attr('id') !== undefined ? $(el).attr('id') : '',
			$hoursContainer = $(el).find('.HoursLink');

		if (locId !== '') {

			$.getLocationById({
				locationId: locId,
				fields: 'Name, HoursOfOperation, OfficeHoursList, OfficeHourComment'
			}, function(data) {
				var LocName = data.Name,
					LocHoursOfOperation = data.HoursOfOperation, // Old office hours
					LocOfficeHoursList = data.OfficeHoursList, // New office hours
					LocOfficeHourComment = data.OfficeHourComment, // New office hours comment box
					LocOfficeHoursListHTML = '',
					emptyDays = 0,
					open24hrDays = 0;

				locCount++;

				$.each(LocOfficeHoursList, function(days) {

					if (this.Status === 'Open24Hours') {
						LocOfficeHoursListHTML +=
							'<div class="DaySchedule">' +
							'<span class="Day">' + days + ': </span>' +
							'<span class="Times">Open 24 Hours</span>' +
							'</div>';
						open24hrDays++;
					}
					else if (this.OfficeHours.length > 0) {
						LocOfficeHoursListHTML +=
							'<div class="DaySchedule">' +
							'<span class="Day">' + days + ': </span>';

						$.each(this.OfficeHours, function(i, time) {

							var openTime = time.OpenTime,
								closeTime = time.CloseTime;

							openTime = getFormattedTime(openTime.replace(/[:]/g, ""));
							closeTime = getFormattedTime(closeTime.replace(/[:]/g, ""));

							if (i > 0) {
								LocOfficeHoursListHTML += ", ";
							}

							LocOfficeHoursListHTML += '<span class="Times">' + openTime + '<span class="RangeSeparator">-</span>' + closeTime + '</span>';

						});
						LocOfficeHoursListHTML += '</div>';
					}
					else {
						LocOfficeHoursListHTML +=
							'<div class="DaySchedule">' +
								'<span class="Day">' + days + ': </span>' +
								'<span class="Times">' + this.Status + '</span>' +
							'</div>';
						emptyDays++;
					}

				});

				if(open24hrDays === 7) { // All days are open 24 hours so this will replace the days listing
					LocOfficeHoursListHTML = '<div class="alwaysopen">Always Open</div>';
				}
				if(emptyDays === 7) { // New office hours are empty
					if(LocOfficeHourComment.length > 0) { // Display new office hour comments box if populated
						LocOfficeHoursListHTML = '<div class="HoursComments">' + LocOfficeHourComment + '</div>';
					} else { // If neither of the new Office hour fields are present, show the old office hours info
						LocOfficeHoursListHTML = '<div class="hours">' + LocHoursOfOperation + '</div>';
					}
				} else {
					if(LocOfficeHourComment.length > 0) { // Display new office hours and the new office hour comments box if populated
						LocOfficeHoursListHTML += '<div class="HoursComments">' + LocOfficeHourComment + '</div>';
					}
				}

				//build out Hours markup
				$hoursContainer.append('<div class="LocationHours Lightbox"><div class="LightboxInner LocationHoursInner"><h4>Hours at ' + LocName + '</h4>' + LocOfficeHoursListHTML + '</div></div>');

				//extras after markup is built out
				$(".LocationHours .hours:empty").parents('.HoursLink').remove(); //remove empty hours container if no hours exist

				//check if hours link exists already and if not, add it
				if ($hoursContainer.find('> a').length === 0) {
					//adding count to hours link and id to hours container for lightbox
					$('<a data-modaal-content-source="#Loc' + locCount + '" class="Lightbox-for-inline modaal" data-modaal-type="inline" data-modaal-animation="fade">Hours at this location</a>').insertBefore($(el).find('.LocationHours')); // adding Hours link with increments
					$(el).find('.LocationHours').attr('id', 'Loc' + locCount); // adding incrementing ids to location container
				}

				// highlight current day of week for business hours
				var FindDate = new Date();
				var WeekDays = FindDate.getDay();
				WeekDays = WeekDays > 0 ? WeekDays - 0 : 6; // zero is sunday, not monday in javascript

				if (WeekDays === 0) {
					$('.Day:contains("Sunday"), .DayOfWeek:contains("Sunday")').addClass('Today');
				} else if (WeekDays === 1) {
					$('.Day:contains("Monday"), .DayOfWeek:contains("Monday")').addClass('Today');
				} else if (WeekDays === 2) {
					$('.Day:contains("Tuesday"), .DayOfWeek:contains("Tuesday")').addClass('Today');
				} else if (WeekDays === 3) {
					$('.Day:contains("Wednesday"), .DayOfWeek:contains("Wednesday")').addClass('Today');
				} else if (WeekDays === 4) {
					$('.Day:contains("Thursday"), .DayOfWeek:contains("Thursday")').addClass('Today');
				} else if (WeekDays === 5) {
					$('.Day:contains("Friday"), .DayOfWeek:contains("Friday")').addClass('Today');
				} else {
					$('.Day:contains("Saturday"), .DayOfWeek:contains("Saturday")').addClass('Today');
				}
				$('.LocationHours .DaySchedule').eq(WeekDays).addClass('TodaysWeekday');     
			});
		}
	}
	function getFormattedTime(fourDigitTime) {
		var hours24 = parseInt(fourDigitTime.substring(0, 2),10),
			hours = ((hours24 + 11) % 12) + 1,
			amPm = hours24 > 11 ? 'pm' : 'am',
			minutes = fourDigitTime.substring(2);

		return hours + ':' + minutes + amPm;
	}
}

function truncateBoxDay() {
	$('.BoxDay span:contains("Sunday")').text("Sun");
	$('.BoxDay span:contains("Monday")').text("Mon");
	$('.BoxDay span:contains("Tuesday")').text("Tue");
	$('.BoxDay span:contains("Wednesday")').text("Wed");
	$('.BoxDay span:contains("Thursday")').text("Thur");
	$('.BoxDay span:contains("Friday")').text("Fri");
	$('.BoxDay span:contains("Saturday")').text("Sat");
}

function setCurrentDay() {
	// highlight current day of week for business hours 
	var FindDate = new Date(),
		WeekDays = FindDate.getDay();
                
	if (WeekDays === 0) {
		$('.Day:contains("Sunday"), .DayOfWeek:contains("Sunday")').addClass('Today');
	} else if (WeekDays === 1) {
		$('.Day:contains("Monday"), .DayOfWeek:contains("Monday")').addClass('Today');
	} else if (WeekDays === 2) {
		$('.Day:contains("Tuesday"), .DayOfWeek:contains("Tuesday")').addClass('Today');
	} else if (WeekDays === 3) {
		$('.Day:contains("Wednesday"), .DayOfWeek:contains("Wednesday")').addClass('Today');
	} else if (WeekDays === 4) {
		$('.Day:contains("Thursday"), .DayOfWeek:contains("Thursday")').addClass('Today');
	} else if (WeekDays === 5) {
		$('.Day:contains("Friday"), .DayOfWeek:contains("Friday")').addClass('Today');
	} else {
		$('.Day:contains("Saturday"), .DayOfWeek:contains("Saturday")').addClass('Today');
	}
	$('.DaySchedule').eq(WeekDays).addClass('TodaysWeekday');
}

function servicesList() {
	// adding a-z services list
	if (($('#ServicesSearch').not('.ModuleSearchResults')).length) {
		$('<div class="ServiceLineListCont"><p class="TextAlignCenter"><img src="/imgs/ajax-loader.gif" alt="Loading Services" /><br />Loading Services List...</p></div>').insertAfter('#ServicesSearch .SearchBox');
		$('.ServicesSearch').prev('script').remove();
		$.getFacetsAndObjectCountHtml({
			ObjectTypeCode: 17,
			OutputFacetIds: 'ce9349e1-1bda-4c59-af2f-e2dedcc42790',
			RelativeViewPath: 'Views/ServiceLines/serviceline-object-count.cshtml'
		}, function (data) {
			$('table.Paging, #ServicesSearch .TabContainer').remove();
			$('.ServiceLineListCont').html(data);
			sliders();
		});
	} else {
        $('.js ul.ServiceLineList').show();
	}
}

function jumpLinkNavigation() {

	var sections = $('.JumpSections'), //setting variable for Sections within Dr profile
	nav = $('.JumpLinksWrap'), //setting variable for the container of the jump links (to be used for height)
	topNav = $('#MainNavWrap'), //setting variable for main menu for desktop - will be overwritten with other value when on mobile
	navHeight = nav.outerHeight() + topNav.outerHeight(), //combined height of the main nav and dr jumpnav
	windowWidth = Math.max($window.width(), window.innerWidth);

    // DOCTOR DETAILS: Adding elements for mobile jumpnav (looks like select drop down)
	$('<button class="init" aria-expanded="false"><span>Jump to section ...</span></button>').prependTo('.JumpLinks');
	if (windowWidth < 1024) {
		$('.JumpLinksWrap2').css('height', $('.JumpLinks ul li.init').outerHeight());
	}

    /* DOCTOR DETAILS: Dr sticky nav & active state on scroll
    ----------------------------------------------------------------- */
    $(window).on('scroll', function () {
        if ($('.JumpLinks ul').length) {
            var drstickyNavTop = $(".JumpLinksWrap2").offset().top; //top of jumpnav section (the - 20 is because of the -20px CSS position)
            var drscrollTop = $(window).scrollTop() + topNav.outerHeight(); //position to stop below fixed main nav
            navHeight = topNav.outerHeight(); //height of main menu for desktop
            //var cur_pos = 0;

            //tablet big and desktop screen size
            if ($('.Medium .JumpLinks ul, .Large .JumpLinks ul, .XL .JumpLinks ul').length) {
                if (drscrollTop > drstickyNavTop) {
                    $('.JumpLinksWrap').insertAfter('#HeaderTopWrap #HeaderTop2');
                    navHeight = nav.outerHeight() + topNav.outerHeight();
                } else {
                    $('.JumpLinksWrap').appendTo('.JumpLinksWrap2');
                }

                //active state on jump nav on scroll (this creates the underline style) - larger screens
                var cur_pos = $(this).scrollTop() + navHeight + 1;
                nav.find('a').removeClass('active');
				nav.find('button').removeClass('active');
                sections.each(function () {
                    var top = $(this).offset().top,
                        bottom = top + $(this).outerHeight();
                    if (cur_pos >= top && cur_pos < bottom - 1) {
                        nav.find('a[href="#' + $(this).attr('id') + '"]').addClass('active');
						nav.find('button.'+ $(this).attr('id') +'').addClass("active");
                    }
                });
            }

            //smaller screen sizes
            if ($('.Default .JumpLinks ul, .Small .JumpLinks ul').length) {
				topNav = $('.MenuButton'); // fixed nav for mobile
                // drstickyNavTop = $(".JumpLinksWrap2").offset().top; //top of jumpnav section
				// nav = $('.JumpLinks ul li.init'); //jumplinks for mobile
				
				navHeight = nav.outerHeight() + topNav.outerHeight(); //height of main menu for mobile
				// drscrollTop = $(window).scrollTop() + topNav.outerHeight(); //position to stop below fixed main nav

                if (drscrollTop > drstickyNavTop) {
                    $('.JumpLinksWrap').insertAfter('#HeaderTopWrap #HeaderTop2');
                } else {
					$('.JumpLinksWrap').appendTo('.JumpLinksWrap2');
                }
                //active state on jump nav on scroll (this creates the underline style) - smaller screens
                cur_pos = $(this).scrollTop() + navHeight;
                nav.find('a').removeClass('active');
                $('.JumpLinks .init span').text('Jump to section ...');
                sections.each(function () {
                    var top = $(this).offset().top,
                        bottom = top + $(this).outerHeight();

                    if (cur_pos >= top && cur_pos <= bottom) {
						var activeItem = nav.find('a[href="#' + $(this).attr('id') + '"]');
                        nav.find('a[href="#' + $(this).attr('id') + '"]').addClass('active');
                        $('.Default .JumpLinks ul li:not(".init"), .Small .JumpLinks ul li:not(".init")').removeClass('selected');
						activeItem.parent('li').addClass('selected');
						var initText = nav.find('a[href="#' + $(this).attr('id') + '"]').html();
                        var parentText = "";

						if (activeItem.parent('li').parent('ul').parent('li').hasClass('HasDropdown')) {
							parentText = activeItem.parents('li.HasDropdown').find('a').html();
						}

						if (parentText.length) {
							$('.JumpLinks .init span').text(parentText +': '+ initText);
						} else {
							$('.JumpLinks .init span').text(initText);
						}
                    }
                });
            }
        }
    });

    /* DOCTOR DETAILS: click functionality to activate scroll on jump nav - larger screens
    ----------------------------------------------------------------- */
    $('.Medium .JumpLinks ul li:not(".init"), .Large .JumpLinks ul li:not(".init"), .XL .JumpLinks ul li:not(".init")').on('click', 'a', function (e) {
        e.preventDefault();
        topNav = $('#MainNavWrap'); //main menu for desktop
        var topNavHeight = topNav.outerHeight(), //#MainNav outer height
            jumpNavHeight = nav.outerHeight(); //jumpNav outer height

        //this determines on click if each of the menus is fixed on the page and then determines the height for the offset when scrolling based on that.
		if ($('.JumpLinksWrap2 .JumpLinksWrap').length > 0) {
			jumpNavHeight = nav.outerHeight(); // height of the jump nav when fixed on page top (-17 is the padding that has been removed from the jump nav when it is fixed at top of browser)
		}
		if ($('#HeaderTopWrap.Fixed').length === 0) {
			topNavHeight = topNav.outerHeight(); // height of the main nav when fixed on page top (-41 is the padding that has been removed for the main nav when it is fixed at the top of browser)
		}

        navHeight = jumpNavHeight + topNavHeight;
        var hash = this.hash,
            destination = $(hash).offset().top - navHeight;

        $('body,html').animate({
            scrollTop: destination
        }, 600);
    });

    /* DOCTOR DETAILS: click functionality to activate scroll on jump nav - smaller screens
	----------------------------------------------------------------- */
	// DOCTOR DETAILS: making ul items perform like an accordion for mobile Part 1 (this part is first click on ul)
	$('.JumpLinks').on('click', '> button', function (e) {
		e.preventDefault();
		if ($(this).attr('aria-expanded') === 'false') {
			$(this).attr('aria-expanded', 'true');
		} else {
			$(this).attr('aria-expanded', 'false');
		}
		$(this).next('ul').toggleClass('Opened');
	});

	// DOCTOR DETAILS: making ul items perform like a select menu for mobile Part 2 (this part is second click on ul)
	$('body.Default .JumpLinks ul li, body.Small .JumpLinks ul li').on('click', 'a', function (e) {
		topNav = $('.MenuButton');

		$('body.Default .JumpLinks ul li, body.Small .JumpLinks ul li').removeClass('selected');
		$(this).parent().addClass('selected');
		$(this).parents('ul').removeClass('Opened');
		if ($('button.init').attr('aria-expanded') === 'false') {
			$('button.init').attr('aria-expanded', 'true');
		} else {
			$('button.init').attr('aria-expanded', 'false');
		}
		$('body.Default .JumpLinks ul, body.Small .JumpLinks ul').children('.init span').html($(this).html());
		
		$(this).each(function () {
			var hash = this.hash;
			var destination = $(hash).offset().top - navHeight + 1;
			$('body,html').animate({
				scrollTop: destination
			}, 600);
		});
	});
}

function flipCardsHeight() {
	// ADDING HEIGHT TO CARDS BASED ON CONTENT
	//clear card heights
	$('.FlipCard').css('height','auto');
	$('.flipcard-card > div').css('height','auto');
	var tallestCardHeight = 0;
	//set card heights
	$('.flipcard-card > div').each(function() {
		var actualCardHeight = $(this).outerHeight();
		if (actualCardHeight > tallestCardHeight) {
			tallestCardHeight = actualCardHeight;
		}
	});
	$('.FlipCard').each(function() {
		$(this).height(tallestCardHeight);
		$(this).find('.flipcard-card > div').css('height','100%');
	});
}

function flipCards() {
	$('.FlipCard').wrap('<div class="FlipCardWrap"></div>');
                
	$("img.Card-Background").each(function() {
		var src = $(this).attr("src"),
			backgroundEl = $(this).parents('.front');
		backgroundEl.css('background', '#fff url(' + src + ') center center/cover no-repeat');
		$(this).remove();
	});
    
	$('.FlipCard .flipcard-card .front, .FlipCard .flipcard-card .back').wrapInner('<span class="WhiteCenter"></span>');
	$('.FlipCard .flipcard-card .back .WhiteCenter').wrapInner('<span class="WhiteCenterInner"></span>');
    
	$('.FlipCard').addClass('Closed');
	$('.FlipCard .flipcard-card').attr('tabindex','0');
	$('.FlipCard').on('mouseenter focus', function() {
		$(this).addClass('Open');
		$(this).removeClass('Closed');
	}).on('mouseleave blur', function() {
		$(this).removeClass('Open');
		$(this).addClass('Closed');
	});
}

function BackToTop() {
	'use strict';
	$('footer').not('#Blank footer').after('<div role="complementary" aria-label="Return to top" id="back-top"><a href="#">back to top of page <span></span></a></div>');
	$("#back-top").hide(); // hide #back-top first
	$(function() { // fade in #back-top
		$(window).on('scroll', function() {
			if ($(this).scrollTop() > 100) {
				$('#back-top').fadeIn();
			} else {
				$('#back-top').fadeOut();
			}
		});
	});
}

function applyClickToggle() {
	//refresh slider within accordion to set width
	let buttons = document.querySelectorAll('.toggle, .toggle button');
	buttons.forEach(button => {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			$('.slick-slider.slick-initialized').slick('setPosition');
		});
	});
}

function waitTimeFormat(mins) {
	'use strict';
	// e.g. 70 -> "1 hour, 10 mins"
	var timeString = '';
	//divide the total time by 60 to see if we have hours
	var hours = Math.floor(mins / 60),
		//minutes is determined by the remainder of mins left over from the hours
		minutes = mins % 60;
	//if more than one hour add an "s"
	if (hours > 1) {
		timeString += hours + " hours, "
	} else if (hours === 1) {
		timeString += hours + " hour, "
	}

	if (minutes === 1) {
		timeString += minutes + ' min';
	} else {
		timeString += minutes + ' mins';
	}
	return timeString;
}

function waitTimeMinutes(hrs, min) {
	'use strict';
	//if hours > 0 add a comma to the string to show hours, mins
	var minutes = hrs > 0 ? ", " + min + " mins" : min + " mins";
	if (min === 1) {
		//add a comma if hours and make 'mins' singular
		minutes = hrs > 0 ? ", " + min + " min" : min + " min";
	} else if (hrs > 0 && min === 0) {
		//if we have hours and 0 mins, don't show '0 mins'
		minutes = "";
	}
	return minutes;
}

// This is used for UNC's wait times
var buildWaitTimes = (function ($) {
	'use strict';

	var ClockWise = function (settings) {
		var options = {
			hospitalName: 'Hospital Name',
			hospitalID: null,
			appendTo: '.ClockWiseWaitTimeWrapper'
		};
		if (settings) {
			$.each(settings, function (key, obj) {
				options[key] = obj;
			});
		}

		options.hospitalID = options.hospitalID.split(', ');
		options.hospitalName = options.hospitalName.split(', ');
		if (options.hospitalID !== null && options.appendTo !== null) {
			//Build Clockwise API CALL per their specifications
			//https://github.com/LightshedHealth/Website-Widget-API

			$.each(options.hospitalID, function (i, elm) {

				//Build API Call for each hospital ID given.
				var script = '<script src="https://www.clockwisemd.com/hospitals/' + options.hospitalID[i] + '/current_wait.html"></script>';
				$('head').first().append(script);
			});

			//Uses discovery function from clockwise api.js script to return wait time.
			$('body').on('clockwise_waits_loaded', function (e, id) {
				var waitTime = $(Clockwise.Waits[id]).html(),
					timeString = formatClockWiseWaitTimeString(waitTime);

				// Loop through the hospital Names and match them to their respective ID
				// Then output the html to the clockwiseWrapper element.
				if (parseInt(options.hospitalID) === id) {
					var markup = '';
					// unc pn wait times
					if (window.location.href.indexOf("/pn/") > -1) {
						if ($('div.clockwiseWaitTime').length === 0) {
							$('<div class="clockwiseWaitTime Center ' + id + '"> ' +
								'<p><strong>' + options.hospitalName + '</strong> <br/>' +
								'' + timeString + '</p> <p><a class="Button-Secondary" aria-label="Reserve my spot now at ' + options.hospitalName + '" href="//www.clockwisemd.com/hospitals/' + id + '/appointments/new">Reserve my spot now</a></p></div>').appendTo(options.appendTo);
						} else {
							markup = '<div class="clockwiseWaitTime ' + id + '"> ' +
								'<p><strong>' + options.hospitalName + '</strong> <br/>' +
								'' + timeString + '</p> <p><a class="Button-Secondary" aria-label="Reserve my spot now at ' + options.hospitalName + '" href="//www.clockwisemd.com/hospitals/' + id + '/appointments/new">Reserve my spot now</a></p></div>';
							$(markup).appendTo(options.appendTo);
						}
					}
					// all other wait times
					else {
						markup = '<div class="clockwiseWaitTime ' + id + '"> ' +
							'<p class="ERWTRow">' +
							'<span class="Name h4-style">' + options.hospitalName + '</span> ' +
							'<span class="Time" style="display: inline-block;">' + timeString + '</span> <a class="Button-Secondary" aria-label="Reserve my spot now at ' + options.hospitalName + '" href="//www.clockwisemd.com/hospitals/' + id + '/appointments/new">Reserve my spot now</a></p></div>';
						$(markup).appendTo(options.appendTo);
					}

					/*Location Profile Wait Time Changes */
					// Change Button on Location Profile if in Location CTA custom content field
					if ($('.CustomProfile #LocationCTA .clockwiseWaitTime a.Button-Secondary').length) {
						$('.CustomProfile #LocationCTA .clockwiseWaitTime a.Button-Secondary').removeClass('Button-Secondary').addClass('Button-Secondary');
					}

					// Move Custom Wait Time Label if in Location CTA custom content field
					if ($('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .WaitTimeLabel').length) {
						$('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .WaitTimeLabel').prependTo('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .clockwiseWaitTime .ERWTRow');
					}
				}
			});
		}
		// Give console error if certain requirements were not met to run plugin.
		else {
			console.error('No Hospital ID or Page Element to place after.');
		}
	};
	return {
		//Global Name: local name
		ClockWise: ClockWise
	};
})(jQuery, VitalSite);

// This is used for Pardees wait times
function formatVitalSiteWaitTimeString(waitTime) {
	// e.g. "0 - 70" -> "0 mins - 1 hour, 10 mins"
	let timeString = '';
	if (waitTime.indexOf(' - ') > -1) {
		// Handle wait time range
		let times = waitTime.split(' - ');
		timeString = waitTimeFormat(times[0]) + ' - ' + waitTimeFormat(times[1])
	} else if (parseInt(waitTime) !== NaN) {
		// Handle single number wait time
		timeString = waitTimeFormat(waitTime)
	} else {
		// Handle other non-numeric string
		timeString = waitTime;
	}
	return timeString;
}

function formatClockWiseWaitTimeString(waitTime) {
	// e.g. "0-70 mins" -> "0 mins - 1 hour, 10 mins"
	let timeString = '';
	if (waitTime.toLowerCase() === 'n/a' || waitTime.toLowerCase() === 'closed') {
		timeString = 'Closed';
	} else if (waitTime.indexOf('-') > -1) {
		// Handle wait time range
		let times = waitTime.split('-');
		times[1] = times[1].substr(0, times[1].indexOf(' ')); // get number from "10 mins"
		timeString = waitTimeFormat(times[0]) + " - " + waitTimeFormat(times[1]);
	} else if (!isNaN(parseInt(waitTime))) {
		// Handle single number wait time
		timeString = waitTimeFormat(waitTime)
	} else {
		// Handle other non-numeric string
		timeString = waitTime;
	}
	return timeString;
}

//******************************************UNC Pardee URL *********************************/
function addWwwToUrl(){

	if (window.location.href.includes("pardee") > -1) {
			
	$('.clockwiseWaitTime .ERWTRow ').each(function (i, item) {
		
		var oldHref = $(item).find('.ButtonGold').attr('href')
		var parts = oldHref.split("//");
		if (parts.length === 2 && !parts[1].includes('www')) {
			// Construct the new URL with "www." inserted
			var newUrl = parts[0] + "//www." + parts[1];
			oldHref=newUrl
			
			$(item).find('.ButtonGold').attr('href',newUrl)
		} else {
			console.log("Invalid URL format");
		}	
	});
}
}
addWwwToUrl();

function NcSurgery() {
	let url = window.location.href;
	if (url.indexOf("/nc-surgery/") > -1) {
		$('#Home').addClass('NcSurgery');

		// Get Navigation Node from the page
		var NavNode = Geonetric.Page.NavigationNode;
			
		// Get Location id from the cmspage
		if ($('#LocationId').length) {
			
			var ThisLocationId = $('#LocationId').text(),
				locationsArray = ThisLocationId.split(', '),
				markersArray = [],
				locId = [],
				locTermId = [],
				count = locationsArray.length;
			
	//		if (count > 2) {
	//			$('.RelatedLocations').wrapInner('<ul class="LocationWrap"></ul>').prepend('<h3 class="sr-only">Related Locations</h3>');
	//		} else {
	//			$('.RelatedLocations').prepend('<h3 class="sr-only">Related Location</h3>');
	//		}

			// Add container for related locations if there is more than one location
			if (count > 1) { 
				var RelatedLocations = '';
				if (count == 2) {
					RelatedLocations = '<div class="RelatedLocations"><div class="LocationWrap"></div></div>';
				} else {
					var RelatedLocations = '<div class="RelatedLocations"><div class="LocationWrap"></div></div>';
				}
			
				$('.LocationInfoWrapper .LocationInfo').append(RelatedLocations); 
				
			} 
			
			$(locationsArray).each(function (index) {
				// Pull in data from nancy
				$.get('/nancy/locations/'+locationsArray[index]+'/viewmodel.json', function (data) {
				
					//Loop through address array
					var locNameText = (data.Name),
						locAddress = (data.Address.AddressLine1),
						locAddress2 = (data.Address.AddressLine2),
						locCity = (data.Address.City),
						locState = (data.Address.StateAbbreviation),
						locStateName = (data.Address.StateName),
						locZip = (data.Address.PostalCode),
						drivingDirections = (data.GoogleDrivingDirectionsUrl),
						locImage = '',
						locImageFile = (data.Images[0] && data.Images[0].PublicHRef ? data.Images[0].PublicHRef: null),
						webSiteLink = (data.WebSiteUrl);
						
					// Get other phone numbers
					var phoneMain = (data.PhoneNumbers.Main.WholeNumber),
						phoneAlt = (data.PhoneNumbers.Alternate.WholeNumber),
						phoneOffice = (data.PhoneNumbers.Office.WholeNumber),
						phoneMobile = (data.PhoneNumbers.Mobile.WholeNumber),
						phoneFax = (data.PhoneNumbers.Fax.WholeNumber),
						phonePager = (data.PhoneNumbers.Pager.WholeNumber);

					// Get other location information
					var locOldHours = (data.HoursOfOperation),
						locNewHours = (data.OfficeHoursList),
						locComment = (data.OfficeHourComment),
						locLat = (data.Latitude),
						locLong = (data.Longitude);

					// Get Location IDs
					locId.push(data.LocationId);
					locTermId.push(data.Term.TermId);
						
					// Add the data we need for Google Maps to an array
					// i+1 is the zindex for each location
					markersArray.push([locNameText, locLat, locLong, index+1, locAddress, locAddress2, locCity, locState, locZip, phoneMain]);
									
					if (locImageFile !== null) { 
						locImage  = '<img src="'+ locImageFile.replace('~', '') +'" alt=""/>';
					} 
					
					if (drivingDirections !== null) { 
						drivingDirections  = '<a target="_blank" class="DDLink" href="'+ drivingDirections +'"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="15" viewBox="0 0 19 15" fill="none"><path d="M3.33398 8.33356H5.83398M0.833984 5.00022L2.50065 5.83356L3.55952 2.65695C3.77808 2.00127 3.88736 1.67342 4.09006 1.43104C4.26905 1.217 4.49891 1.05133 4.75857 0.949203C5.05262 0.833557 5.39819 0.833557 6.08934 0.833557H12.2453C12.9364 0.833557 13.282 0.833557 13.5761 0.949203C13.8357 1.05133 14.0656 1.217 14.2446 1.43104C14.4473 1.67342 14.5566 2.00127 14.7751 2.65695L15.834 5.83356L17.5007 5.00022M12.5007 8.33356H15.0007M4.83398 5.83356H13.5007C14.9008 5.83356 15.6008 5.83356 16.1356 6.10604C16.606 6.34572 16.9885 6.72818 17.2282 7.19858C17.5007 7.73336 17.5007 8.43343 17.5007 9.83356V12.0836C17.5007 12.4708 17.5007 12.6644 17.4686 12.8254C17.3371 13.4865 16.8203 14.0034 16.1591 14.1349C15.9981 14.1669 15.8045 14.1669 15.4173 14.1669H15.0007C14.0802 14.1669 13.334 13.4207 13.334 12.5002C13.334 12.2701 13.1474 12.0836 12.9173 12.0836H5.41732C5.1872 12.0836 5.00065 12.2701 5.00065 12.5002C5.00065 13.4207 4.25446 14.1669 3.33398 14.1669H2.91732C2.53011 14.1669 2.3365 14.1669 2.1755 14.1349C1.51435 14.0034 0.99752 13.4865 0.866009 12.8254C0.833984 12.6644 0.833984 12.4708 0.833984 12.0836V9.83356C0.833984 8.43343 0.833984 7.73336 1.10647 7.19858C1.34615 6.72818 1.7286 6.34572 2.19901 6.10604C2.73379 5.83356 3.43385 5.83356 4.83398 5.83356Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg> Get Driving Directions<span class="sr-only"> to '+ locNameText +', opens new tab</span></a>';
					} 
					
					var ContactInformation = '',
							PhoneNumbers = '',
							Hours = '';
					
					if (index == 0) {
						ContactInformation += '<h1>' + locNameText + '</h1>';
						// ContactInformation = '<h3>Contact Information</h3>' +
						ContactInformation = ContactInformation +'<div class="LocTop"><div class="LocTopLeft">';
							if (locImage.length) {
								ContactInformation = ContactInformation + locImage;    
							}
							
							ContactInformation = ContactInformation + '</div><div class="LocTopRight Background-Dark"><div class="TopRightInner"><div class="vcard"><div class="adr">';
							
							// if (webSiteLink.length) {
							// 	ContactInformation += '<p><strong><a href="'+ webSiteLink +'">' + locNameText + '</a></strong>';
							// } else {
							// 	ContactInformation += '<p><strong>' + locNameText + '</strong>';
							// }
						
							if (locAddress.length) {
								ContactInformation = ContactInformation + '<div class="StreetAddressWrap"><span class="street-address">' + locAddress + '</span>';
							}
							if (locAddress2.length) {
								ContactInformation = ContactInformation + '<span class="street-address">' + locAddress2 + '</span></div>';
							}
							if (locCity.length && locState.length && locZip.length) {
								ContactInformation = ContactInformation + '<span class="locality">'+ locCity +'</span><text>,</text> <span class="region"><abbr title="'+ locStateName +'">'+ locState +'</abbr></span> <span class="postal-code">'+ locZip +'</span>';
							} else {
								if (locCity.length) {
									ContactInformation = ContactInformation + '<span class="locality">'+ locCity +',&nbsp;</span>';
								}
								if (locState.length) {
									ContactInformation = ContactInformation + '<span class="region"><abbr title="'+ locStateName +'">'+ locState +'</abbr>&nbsp;</span>';
								}    
								if (locZip.length) {
									ContactInformation = ContactInformation + '<span class="postal-code">'+ locZip +'</span>';
								}   
							}
							if (drivingDirections.length) {
								ContactInformation += drivingDirections;
							}
						
						ContactInformation = ContactInformation + '</div></div>';
					
						if (phoneMain !== null || phoneAlt !== null || phoneOffice !== null || phoneMobile !== null || phoneFax !== null || phonePager !== null) {

							PhoneNumbers = '<ul class="Plain PhoneNumbers">';

							if (phoneMain !== null) {
								PhoneNumbers = PhoneNumbers + '<li class="MainTelephoneNumber">' +
									'<span class="TelLabel Hide"><strong>Main:</strong></span> ' +
									'<svg class="Phone" alt="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M6.98356 7.37767C7.56356 8.58569 8.35422 9.71789 9.35553 10.7192C10.3568 11.7205 11.4891 12.5112 12.6971 13.0912C12.801 13.1411 12.8529 13.166 12.9187 13.1852C13.1523 13.2533 13.4392 13.2044 13.637 13.0627C13.6927 13.0228 13.7403 12.9752 13.8356 12.8799C14.1269 12.5886 14.2726 12.4429 14.4191 12.3477C14.9715 11.9885 15.6837 11.9885 16.2361 12.3477C16.3825 12.4429 16.5282 12.5886 16.8196 12.8799L16.9819 13.0423C17.4248 13.4852 17.6462 13.7066 17.7665 13.9444C18.0058 14.4174 18.0058 14.976 17.7665 15.4489C17.6462 15.6867 17.4248 15.9082 16.9819 16.351L16.8506 16.4824C16.4092 16.9238 16.1886 17.1444 15.8885 17.313C15.5556 17.5 15.0385 17.6345 14.6567 17.6333C14.3126 17.6323 14.0774 17.5655 13.607 17.432C11.0792 16.7146 8.69387 15.3608 6.70388 13.3709C4.7139 11.3809 3.36017 8.99557 2.6427 6.46774C2.50919 5.99737 2.44244 5.76218 2.44141 5.41806C2.44028 5.03621 2.57475 4.51913 2.76176 4.18621C2.9303 3.88618 3.15098 3.66551 3.59233 3.22416L3.72369 3.09279C4.16656 2.64992 4.388 2.42849 4.62581 2.3082C5.09878 2.06898 5.65734 2.06898 6.1303 2.3082C6.36812 2.42849 6.58955 2.64992 7.03242 3.09279L7.19481 3.25518C7.48615 3.54652 7.63182 3.69219 7.72706 3.83867C8.08622 4.39108 8.08622 5.10323 7.72706 5.65564C7.63182 5.80212 7.48615 5.94779 7.19482 6.23913C7.09955 6.33439 7.05193 6.38202 7.01206 6.4377C6.87038 6.63556 6.82146 6.92244 6.88957 7.15607C6.90873 7.22181 6.93368 7.27376 6.98356 7.37767Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="tel" itemprop="telephone"><a href="tel:' + phoneMain + '" aria-label="Call on ' + phoneMain + '">' + phoneMain + '</a></span>' +
									'</li>';
							}
							if (phoneAlt !== null) {
								PhoneNumbers = PhoneNumbers + '<li class="AlternateTelephoneNumber">' +
									'<span class="TelLabel"><strong>Alternate:</strong></span> ' +
									'<span class="tel" itemprop="telephone"><a href="tel:' + phoneAlt + '" aria-label="Call on ' + phoneAlt + '">' + phoneAlt + '</a></span>' +
									'</li>';
							}
							if (phoneOffice !== null) {
								PhoneNumbers = PhoneNumbers + '<li class="OfficeTelephoneNumber">' +
									'<span class="TelLabel"><strong>Office:</strong></span> ' +
									'<span class="tel" itemprop="telephone"><a href="tel:' + phoneOffice + '" aria-label="Call on ' + phoneOffice + '">' + phoneOffice + '</a></span>' +
									'</li>';
							}
							if (phoneMobile !== null) {
								PhoneNumbers = PhoneNumbers + '<li class="MobileTelephoneNumber">' +
									'<span class="TelLabel"><strong>Mobile:</strong></span> ' +
									'<span class="tel" itemprop="telephone"><a href="tel:' + phoneMobile + '" aria-label="Call on ' + phoneMobile + '">' + phoneMobile + '</a></span>' +
									'</li>';
							}
							if (phoneFax !== null) {
								PhoneNumbers = PhoneNumbers + '<li class="FaxNumber">' +
									'<span class="TelLabel Hide"><strong>Fax:</strong></span> ' +
									'<svg class="Fax" alt="" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path d="M14.1663 4.99998V3.49998C14.1663 2.56656 14.1663 2.09985 13.9847 1.74333C13.8249 1.42973 13.5699 1.17476 13.2563 1.01497C12.8998 0.833313 12.4331 0.833313 11.4997 0.833313H6.83301C5.89959 0.833313 5.43288 0.833313 5.07636 1.01497C4.76275 1.17476 4.50779 1.42973 4.348 1.74333C4.16634 2.09985 4.16634 2.56656 4.16634 3.49998V4.99998M4.16634 14.1666C3.39136 14.1666 3.00388 14.1666 2.68596 14.0815C1.82323 13.8503 1.14936 13.1764 0.918193 12.3137C0.833008 11.9958 0.833008 11.6083 0.833008 10.8333V8.99998C0.833008 7.59985 0.833008 6.89978 1.10549 6.365C1.34517 5.8946 1.72763 5.51215 2.19803 5.27246C2.73281 4.99998 3.43288 4.99998 4.83301 4.99998H13.4997C14.8998 4.99998 15.5999 4.99998 16.1346 5.27246C16.6051 5.51215 16.9875 5.8946 17.2272 6.365C17.4997 6.89978 17.4997 7.59985 17.4997 8.99998V10.8333C17.4997 11.6083 17.4997 11.9958 17.4145 12.3137C17.1833 13.1764 16.5095 13.8503 15.6467 14.0815C15.3288 14.1666 14.9413 14.1666 14.1663 14.1666M11.6663 7.91665H14.1663M6.83301 17.5H11.4997C12.4331 17.5 12.8998 17.5 13.2563 17.3183C13.5699 17.1585 13.8249 16.9036 13.9847 16.59C14.1663 16.2334 14.1663 15.7667 14.1663 14.8333V13.5C14.1663 12.5666 14.1663 12.0998 13.9847 11.7433C13.8249 11.4297 13.5699 11.1748 13.2563 11.015C12.8998 10.8333 12.4331 10.8333 11.4997 10.8333H6.83301C5.89959 10.8333 5.43288 10.8333 5.07636 11.015C4.76275 11.1748 4.50779 11.4297 4.348 11.7433C4.16634 12.0998 4.16634 12.5666 4.16634 13.5V14.8333C4.16634 15.7667 4.16634 16.2334 4.348 16.59C4.50779 16.9036 4.76275 17.1585 5.07636 17.3183C5.43288 17.5 5.89959 17.5 6.83301 17.5Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="tel" itemprop="telephone"><a href="tel:' + phoneFax + '" aria-label="Fax at ' + phoneFax + '">' + phoneFax + '</a></span>' +
									'</li>';
							}
							if (phonePager !== null) {
								PhoneNumbers = PhoneNumbers + '<li class="PagerNumber">' +
									'<span class="TelLabel"><strong>Pager:</strong></span> ' +
									'<span class="tel" itemprop="telephone"><a href="tel:' + phonePager + '">' + phonePager + '</a></span>' +
									'</li>';
							}
							PhoneNumbers = PhoneNumbers + '</ul>';
						}
						ContactInformation += PhoneNumbers + '</div></div></div>';

						// See if location has new hours set and times exist
						var hasNewHours = false;

						for (var day in locNewHours) {
							if (locNewHours[day].OfficeHours.length > 0) {
								hasNewHours = true;
							}
						}
						
						// Add office hours markup
						if (hasNewHours) {
							Hours = '<div class="HoursWrap"><p class="HoursOpButton"><button class="Button"><span class="Current"></span><svg class="Arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 7.5L10 12.5L15 7.5" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button></p><div id="HoursInfoWrap" aria-expanded="false" class style="display: none;"><div class="Hours"><h2 class="Heading">Hours of Operation</h2><div class="HoursOfOperation">';
							
							for (day in locNewHours) {
								var theHours = locNewHours[day].OfficeHours;

								if (theHours.length === 0) {
									Hours += '<div class="DaySchedule">' +
										'<div class="Day">' + day + ': </div>' +
										'<div class="Times">' + 'Closed' + '</div>' +
									'</div>';
								} else {
									for (var i = 0; i < theHours.length; i++ ) {
										Hours += '<div class="DaySchedule">' +
											'<div class="Day">' + day + ': </div>' +
											'<div class="Times">' + convertHours(theHours[i].OpenTime) + ' - ' + convertHours(theHours[i].CloseTime) + '</div>' +
										'</div>';
									}
								}
							}
							
							if (locComment.length) {
								Hours += '<div class="OfficeHourComment">' + locComment + '</div>';
							}
							
							Hours += '</div>';
						} else if (locOldHours.length && locComment.length ) {
							Hours = '<div class="Hours"><h3>Business Hours</h3>';
								Hours += '<div class="OfficeHourComment">' + locComment + '</div>';
							Hours += '</div>';
						} else if (hasNewHours == false && locComment.length) {
							Hours = '<div class="Hours"><h3>Business Hours</h3>';
								Hours += '<div class="OfficeHourComment">' + locComment + '</div>';
							Hours += '</div>';
						} else {
							Hours = '<div class="Hours"><h3>Business Hours</h3>';
								Hours += '<div class="DaySchedule">'+ locOldHours +'</div>';
							Hours += '</div>';
						}
						Hours = Hours + '</div></div></div>';

						// Convert 24 hour times (16:00) to 12 hour AM/PM times (4:00 PM)
						function convertHours(time) {
							// Check correct time format and split into components
							time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

							if (time.length > 1) { // If time format correct
								time = time.slice (1);  // Remove full string match value
								time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
								time[0] = +time[0] % 12 || 12; // Adjust hours
							}
							return time.join (''); // return adjusted time or original string
						}    
					
						$('.LocTopWrap .ContactInfo:first').append(ContactInformation);
						$(Hours).insertAfter('.LocTopWrap .TopRightInner');
						
						// highlight current day of week for business hours 
						var FindDate = new Date(),
							WeekDays = FindDate.getDay();
									
						if (WeekDays === 0) {
							$('.Day:contains("Sunday"), .DayOfWeek:contains("Sunday")').addClass('Today');
						} else if (WeekDays === 1) {
							$('.Day:contains("Monday"), .DayOfWeek:contains("Monday")').addClass('Today');
						} else if (WeekDays === 2) {
							$('.Day:contains("Tuesday"), .DayOfWeek:contains("Tuesday")').addClass('Today');
						} else if (WeekDays === 3) {
							$('.Day:contains("Wednesday"), .DayOfWeek:contains("Wednesday")').addClass('Today');
						} else if (WeekDays === 4) {
							$('.Day:contains("Thursday"), .DayOfWeek:contains("Thursday")').addClass('Today');
						} else if (WeekDays === 5) {
							$('.Day:contains("Friday"), .DayOfWeek:contains("Friday")').addClass('Today');
						} else {
							$('.Day:contains("Saturday"), .DayOfWeek:contains("Saturday")').addClass('Today');
						}
						$('.DaySchedule').eq(WeekDays).addClass('TodaysWeekday');

						$('.NcSurgery #HoursInfoWrap .Hours .DaySchedule.TodaysWeekday').clone().appendTo(".HoursOpButton .Button span.Current");
						
					} else {
						ContactInformation = '<div class="ContactInfo">'+
						'<div class="vcard">';
							ContactInformation += '<div class="adr">';
						
							// if (locImage.length) {
							// 	if (webSiteLink.length) {
							// 		ContactInformation += '<strong><a href="'+ webSiteLink +'">' + locImage + '<span class="Name">' + locNameText + '</span></a></strong>';
							// 	} else {
							// 		ContactInformation += '<strong><a href="/app/locations/profile.aspx?navigationNode='+ NavNode +'&amp;id='+ (data.LocationId) +'">'+ locImage +'<span class="Name">' + locNameText + '</span></a></strong>';
							// 	}
							// } else {
								if (webSiteLink.length) {
									ContactInformation += '<strong><a href="'+ webSiteLink +'"><span class="Name">' + locNameText + '</span></a></strong>';
								} else {
									ContactInformation += '<strong><a href="/app/locations/profile.aspx?navigationNode='+ NavNode +'&amp;id='+ (data.LocationId) +'"><span class="Name">' + locNameText + '</span></a></strong>';
								}
							// }
							
							if (locAddress.length) {
								ContactInformation += '<p><span class="street-address">' + locAddress + '</span>';
							}
							if (locAddress2.length) {
								ContactInformation += '<span class="street-address">' + locAddress2 + '</span>';
							}
							if (locCity.length && locState.length && locZip.length) {
								ContactInformation += '<span class="locality">'+ locCity +'</span><text>,</text> <span class="region"><abbr title="'+ locStateName +'">'+ locState +'</abbr></span> <span class="postal-code">'+ locZip +'</span>';
							} else {
								if (locCity.length) {
									ContactInformation += '<span class="locality">'+ locCity +'</span>';
								}
								if (locState.length) {
									ContactInformation += '<span class="region"><abbr title="'+ locStateName +'">'+ locState +'</abbr></span>';
								}    
								if (locZip.length) {
									ContactInformation += '<span class="postal-code">'+ locZip +'</span>';
								}   
							}
							ContactInformation += '</p>';
						
							if (drivingDirections.length) {
								ContactInformation += drivingDirections;
							}
						
						ContactInformation += '</div>';
					
						if (phoneMain !== null) {

							PhoneNumbers = '<div class="Contact"><p class="Phone">';

							if (phoneMain !== null) {
								PhoneNumbers +='<span class="sr-only">Phone: </span> '+
									'<a class="Button" href="tel:'+ phoneMain +'"><svg class="Phone" alt="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M6.98356 7.37767C7.56356 8.58569 8.35422 9.71789 9.35553 10.7192C10.3568 11.7205 11.4891 12.5112 12.6971 13.0912C12.801 13.1411 12.8529 13.166 12.9187 13.1852C13.1523 13.2533 13.4392 13.2044 13.637 13.0627C13.6927 13.0228 13.7403 12.9752 13.8356 12.8799C14.1269 12.5886 14.2726 12.4429 14.4191 12.3477C14.9715 11.9885 15.6837 11.9885 16.2361 12.3477C16.3825 12.4429 16.5282 12.5886 16.8196 12.8799L16.9819 13.0423C17.4248 13.4852 17.6462 13.7066 17.7665 13.9444C18.0058 14.4174 18.0058 14.976 17.7665 15.4489C17.6462 15.6867 17.4248 15.9082 16.9819 16.351L16.8506 16.4824C16.4092 16.9238 16.1886 17.1444 15.8885 17.313C15.5556 17.5 15.0385 17.6345 14.6567 17.6333C14.3126 17.6323 14.0774 17.5655 13.607 17.432C11.0792 16.7146 8.69387 15.3608 6.70388 13.3709C4.7139 11.3809 3.36017 8.99557 2.6427 6.46774C2.50919 5.99737 2.44244 5.76218 2.44141 5.41806C2.44028 5.03621 2.57475 4.51913 2.76176 4.18621C2.9303 3.88618 3.15098 3.66551 3.59233 3.22416L3.72369 3.09279C4.16656 2.64992 4.388 2.42849 4.62581 2.3082C5.09878 2.06898 5.65734 2.06898 6.1303 2.3082C6.36812 2.42849 6.58955 2.64992 7.03242 3.09279L7.19481 3.25518C7.48615 3.54652 7.63182 3.69219 7.72706 3.83867C8.08622 4.39108 8.08622 5.10323 7.72706 5.65564C7.63182 5.80212 7.48615 5.94779 7.19482 6.23913C7.09955 6.33439 7.05193 6.38202 7.01206 6.4377C6.87038 6.63556 6.82146 6.92244 6.88957 7.15607C6.90873 7.22181 6.93368 7.27376 6.98356 7.37767Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>'+ phoneMain +'</a>'; 
							}
						
							PhoneNumbers += '</p></div>';
						}
						
						ContactInformation += PhoneNumbers + '</div>';
						
						$('.RelatedLocations .LocationWrap').append(ContactInformation);
					}
					
					// After everything is finished running
					if(markersArray.length === locationsArray.length) {
						// Remove preloader image
						$('.RelatedLocations #loadingmessage').remove();
						$('.NcSurgery .LocationWrap').addClass('Loaded');
						
						initializeMap(markersArray);

						// Turn Array into String 
						var locTermIdString = locTermId.join();
						
						googleMapHeight();

						setTimeout(function() {
							sliders();
							sliderArrow();
						}, 250);
					}
				});
			}); 		
		} // end each locations function
		
		setTimeout(function() {
			googleMapHeight();
		}, 1000);

	}
}

// map height
function googleMapHeight() {
	"use strict";
	if ($(window).width() > 1024) {
		var LocationHeight = $('.LocationWrapper').height();
		$('.MapWrapper, #ClientLocationsMap, .MapWrapper iframe, #map, .GMap').css('height', LocationHeight);
	} else {
		$('.MapWrapper, #ClientLocationsMap, .MapWrapper iframe, #map, .GMap').css('height', '320px');
	}
}
	 
// window resize event
var waitForFinalEvent = (function () {
var timers = {};
return function (callback, ms, uniqueId) {
	if (!uniqueId) {
		uniqueId = "unc-location";
	}
	if (timers[uniqueId]) {
		clearTimeout (timers[uniqueId]);
	}
	timers[uniqueId] = setTimeout(callback, ms);
};
})();
	
var width = $(window).width();
$(window).on('resize', function() {
	'use strict';
	waitForFinalEvent(function(){
		if($(this).width() !== width) {
			width = $(this).width();
			googleMapHeight();
		} else {
			//do nothing;
		}
	}, 250, "unc-location");

});
	
// Google Map Javascript API Key
$(function (environment, apiKey) {
	'use strict';
	var siteURL = window.location.hostname;

	if(siteURL.indexOf('devs') > 0 || siteURL.indexOf('dev') > 0){
		environment = 'dev';
		apiKey = 'AIzaSyCk7Nwee6M4gXITTHVbeSEgrnCR-kMKWxs';
	}
	else if(siteURL.indexOf('stage') > 0){
		environment = 'stage';
		apiKey = 'AIzaSyCk7Nwee6M4gXITTHVbeSEgrnCR-kMKWxs';
	}
	else{
		environment = 'live';
		apiKey = 'AIzaSyD3d9WsG6f5gxpNhx9AT9zI7A5PrVmlPWc';
	}
	
	// we don't want to include the api key on a page twice, 
	// so if this is a location detail page OR a location Razor view, do NOT add the api key because it's already pulled in by Core
	if ($('.cmsPage #LocationsDetail').length || $('div.CustomProfile.Razor').length) {
		//do nothing
	} else {
		$("<script src='https://maps.googleapis.com/maps/api/js?key="+apiKey+"' async defer>").appendTo('head');
	}
});

function initializeMap(locations) {
	// Map will center on the first location entered
	var firstlocation = locations[0];
	var firstlatlng = ({lat: firstlocation[1], lng:firstlocation[2]});
	var map = new google.maps.Map(document.getElementById('map'), {
		zoom: 8,
		center: firstlatlng
	});
	setMarkers(locations, map);
}

function setMarkers(locations, map) {
	// if all the locations have the exact same address we will omit the 'fitBounds'. Ensure we have different locations.
	var differentAddress = false;
	var latitudes = [];
	var longitudes = [];
	
	// create new google map info window
	var infowindow = new google.maps.InfoWindow(), marker, i;
	
	// bounds will make sure that all the markers on the map fit within the viewport
	var bounds = new google.maps.LatLngBounds();
	
	// Adds markers to the map
	for (var i = 0; i < locations.length; i++) {
		var location = locations[i];

		// if we have more than one location check to see if they have different addresses
		if(i > 0) {
			if($.inArray(location[1], latitudes) === -1 && $.inArray(location[2], longitudes) === -1) {
				differentAddress = true;
			}
		}
		
		latitudes.push(location[1]);
		longitudes.push(location[2]);
		
		// get lat and lng and add to the bounds variable
		var point = new google.maps.LatLng(location[1], location[2]);
		bounds.extend(point);
		
		// Build out the marker
		var marker = new google.maps.Marker({
			position: {lat: location[1], lng: location[2]},
			map: map,
			title: location[0]
		});
		
		// build out the content in the info window
		google.maps.event.addListener(marker, 'click', (function(marker, i) {
			var contentString = '<div id="siteNotice"></div>'+
					'<h3>'+ location[0] +'</h3>'+
					'<p class="address">'+ location[4] +'&nbsp;<span>'+ location[5] +'</span>'+
					'&nbsp;<span>'+ location[6] +',&nbsp;'+ location[7] +'&nbsp;'+ location[8] +'</span></p>';
					if(location[9] != null) {contentString += '<p class="phone">'+location[9]+'</p>'; }
			
			return function() {
				infowindow.setContent(contentString);
				infowindow.open(map, marker);
			}
		})(marker, i));
	}
	if (locations.length > 1 && differentAddress) {
		// zoom to the bounds
		map.fitBounds(bounds);
	}

	if($('.Home .LocationInfo .LocationWrap').children().length > 4)	{
		$('.Home .LocationInfo .LocationWrap').addClass('Overflow');
	}
}

function recipeHubInterior() {
	//Adding body class for recipe interior page
	if ($('.Recipe').length) {
		$('body').addClass('RecipeInterior');
	};
	/* add Print button to Recipes
	 * ----------------------------------------------------------------- */
	$('.Recipe').prepend('<button class="Button Right PrintRecipe">Print Recipe</button>');
	/*$('.Recipe').prepend('<img class="HiddenLogo" style="float:right;" alt="UNC Healthcare Recipes" src="/imgs/balance.svg" width="150" />');*/
	$('.Recipe').wrap('<div class="RecipeWrapper"></div>');

	//move Page Publication Date to after H1
	$('.RecipeInterior .PagePublicationDate').insertAfter('.RecipeWrapper h1:first-of-type');
	$('.RecipeInterior .RecipeWrapper h1').replaceWith(function() {
		return '<h2>' + $(this).html() + '</h2>';
	});

	$('button.PrintRecipe').on('click', function () {
		var divToPrint = $(this).parents('.RecipeWrapper').html();
		var newWin = window.open('', 'Print-Window');
		newWin.document.open();
		newWin.document.write('<html>' +
			'<head>' +
			'<style>' +
			'.PrintRecipe { display: none; }' +
			'.Recipe { font-family:Verdana, sans-serif; padding: 20px; margin-bottom: 2em; }' +
			'.Recipe .Right {float: right;}' +
			'.Recipe ul { list-style: none; padding-left: 0; margin-left: 0; }' +
			'.Recipe h2 { border-bottom: 1px solid #56a0d3; }' +
			'.Recipe .TwoCol { float: left; width: 50%; margin-top: 0;};' +
			'.Recipe ul li {padding: 0 0 1.25em !important;}' +
			'.Recipe ol { counter-reset: item; list-style: none; margin-left: 1.875em; padding-left: 1.875em; margin-top: .5em; }' +
			'.Recipe ol li { padding-bottom: 1.5em; }' +
			'.Recipe ol li:before { width: 30px;height: 30px;line-height: 30px;-webkit-border-radius: 50%;-moz-border-radius: 50%;border-radius: 50%;text-align: center;counter-increment: item;position: absolute;border: 1px solid #ccc;color: #777;content: counter(item) "";margin: -6px 0 0 -2.5em;} ' +
			'</style>' +
			'</head>' +
			'<body onload="window.print()">' + divToPrint + '</body></html>');
		// newWin.document.close();
		// setTimeout(function () { newWin.close(); }, 10);
	});

	/* add Tags to bottom of interior Recipe Hub pages or any page with div class "Tags"
	 * ----------------------------------------------------------------- */
	if ($('.HubTags').length > 0) {
		// relatedTags();
		relatedHealthyTags();
	}
}
// Related panel for single filter Healthy Recipes
function relatedHealthyTags() {
	"use strict";

	var hubCategoryTopic = '',
		hubTopicUrl = '';

	// if (url.indexOf('/rh/care-treatment/heart-vascular/north-carolina-heart-vascular-hospital/heart-healthy-recipes/') > 0) {
	// 	hubTopicUrl = "/rh/care-treatment/heart-vascular/north-carolina-heart-vascular-hospital/heart-healthy-recipes/#"
	// }
	if (("taxonomy" in VitalSite) && VitalSite.taxonomy !== null) {
		var taxonomy = VitalSite.taxonomy;
		$(taxonomy).each(function (i, element) {

			if ((element.FacetName === 'Healthy Recipe Categories') && $('.RelatedRecipeHeader').length === 0) { //build out the balance tags header once - only if topic or serviceline content exists
				$('.HubTags').prepend("<h3 class='RelatedRecipeHeader'>Related Recipe Categories</h3>");
			}
			$(element.Terms).each(function (j, elm) { //loop through all of the terms for the page

				if (element.FacetName === 'Healthy Recipe Categories') {
					hubCategoryTopic = (elm.Name);
					var hubCategoryTopicHash = (hubCategoryTopic.toString().replace(/\s+/g, '').replace(/[^a-zA-Z 0-9]+/g,''));
					$('.HubTags').append("<a href='/rh/healthy-recipes/#" + hubCategoryTopicHash + "'>" + hubCategoryTopic + "</a> ");
				}
			});
		});
	}
	//removing last comma from tag list
	var strVal = $.trim($('.HubTags').html());
	var lastChar = strVal.slice(-1);
	if (lastChar === ',') {
		strVal = strVal.slice(0, -1);
	}

	$('.RecipeInterior .cmspanel:has(.HubTags)').insertAfter('.RecipeWrapper');
}



function BMIcalculator() {
/* BMI Calculator
    ----------------------------------------------------------------- */

	var bmicomment = "";
	var bmianswer = "0";

	// Calculate BMI
	$('#CalBMI').click(function () {

		function mod(div, base) {
			return Math.round(div - (Math.floor(div / base) * base));
		}

		var w = $('.BMIWeight').val() * 1;
		var HeightFeetInt = $('.BMIhtf').val() * 1;
		var HeightInchesInt = $('.BMIhti').val() * 1;
		var HeightFeetConvert = HeightFeetInt * 12;
		var h = HeightFeetConvert + HeightInchesInt;
		var displaybmi = (Math.round((w * 703) / (h * h)));
		var rvalue = true;

		if ((w <= 35) || (w >= 500) || (h <= 48) || (h >= 120)) {
			alert("The weight or height you entered is not supported by this calculator. This tool is accurate for heights between 4 feet 10 inches and 7 feet 0 inches and excludes pregnant women, children and atheletes.");
			rvalue = false;
		}
		if (rvalue) {
			$('.BMIInput').addClass('Hide');
			$('.BMIResults').addClass('Show');
			$('#CalBMI').attr('aria-pressed','true');
			$('.BMIInput').attr('aria-hidden','true');
			$('.BMIanswer, .BMIcomment').attr('aria-hidden','false');
			if (HeightInchesInt > 11) {
				var reminderinches = mod(HeightInchesInt, 12);
				$('.BMIhti').val(reminderinches);
				$('.BMIhtf').val(HeightFeetInt + ((HeightInchesInt - reminderinches) / 12));
				//$('.BMIanswer').append(displaybmi);
			}
			if (displaybmi < 19) {
				bmicomment = "Underweight";
			}
			else if (displaybmi >= 19 && displaybmi <= 25) {
				bmicomment = "Desirable";
			}
			else if (displaybmi >= 26 && displaybmi <= 29) {
				bmicomment = "Overweight, prone to health risks";
			}
			else if (displaybmi >= 30 && displaybmi <= 40) {
				bmicomment = "Obese";
			}
			else if (displaybmi > 40) {
				bmicomment = "Extremely obese";
			}
			else {
				bmicomment = "Error, please try again";
			}
			$('.BMIanswer').append(displaybmi);
			$('.BMIcomment').append(bmicomment);
		}
		return rvalue;

	});

	// Reset BMI Calculator
	$('#ResetBMI').click(function () {
		$('.BMIInput').removeClass('Hide');
		$('.BMIResults').removeClass('Show');
		$('.BMIResults').attr('aria-hidden','true');
		$('.BMIInput').attr('aria-hidden','false');
		$('#ResetBMI').attr('aria-pressed','true');
		$('.BMIanswer, .BMIcomment').attr('aria-hidden','true');
		bmicomment = "";
		bmianswer = 0;
		$('.BMIanswer').empty();
		$('.BMIcomment').empty();
	});
}

$(window).on('resize', function() {
// Runs as soon as the window is resized
	if (isAndroidDevice && $('input').is(':focus')) {
		//do nothing if input has focus
	} else {
		windowSize();
		header05_AlsoOnResize();
		pageStructure_AlsoOnResize();
		flipCardsHeight();
		applyClickToggle(); //refreshes slider in tab container
		// sliderArrow(); //re-apply slider arrow SVGs after resize
		handleProxViewMore(); //handle proximity nav view more button
		sliders(); // call to slick slider to refresh on resize
		sliderArrow();
	}
});

$window.on('orientationchange', function () {
// Runs as soon as the screen orientation is changed
	windowSize();
	header05_AlsoOnResize();
	handleProxViewMore();
	pageStructure_AlsoOnResize();
	flipCardsHeight();
});

$(function () {
// Runs as the page is loading
	windowSize();
	alertPanel();
	smartPanelGrid();
	header05_AlsoOnResize();
	header05();
	MainNavDropDownsOnClick(); // -- use with header 2
	// MainNavDropDownsOnHover(); // -- use with header 2
	// stickyNavigation();
	$('.focuspoint').focusPoint();
	onlyOnErrorAppPage();
	onlyOnHomePage();
	BasicSearch();
	paymentForm();
	animationHandler();
	pageStructure();
	pageStructure_AlsoOnResize();
	breadcrumbsBackgroundSwap();
	proxNav_01();
	minBodyHeight();

	// DA initializers ---------------------------------------------
	var tabsAccordions = TabsAccordions.Create({
		Breakpoint: 1000,
		Animation: 400
	});
	tabsAccordions.Setup();

	var clickToCall = ClickToCall.Create();
	clickToCall.Setup();
	// END DA initializers ---------------------------------------------

	ariaFixes(); // remove after core accessibility fixes
	removeCoreNavHeadings(); // remove after core updates for nav headings
	clinicalTrialHeadings(); // remove after core accessibility fixes
	clinicalTrialsTabResults(); // remove after core accessibility fixes
	removeEmptyElements(); // needing some of these for accessibility fixes
	breadArrow();
	// panelBackgrounds(); //not using just use inline panel and set background there
	swapSPSliderMarkup();
	addFocalPoint();
	tablesContainer();
	youTubeContainer();
	hideDescriptionOrThumbnail();
	addCaptionWidth();
	countUpToNumber(); // -- expanded option
	relatedHubContent(); // -- included with a content hub project
	arrowLinkStyle();
	drSmartPanelMarkup();
	locationSmartPanelMarkup();
	pagesSmartPanelMarkup();
	viewMoreLinkFixes();
	NcSurgery();
	//updateTimeFormat(); // -- expanded option - only if needed to meet client specific format
	siteSearch();
	pagesModuleMarkup();
	formsDocumentsMarkup();
	servicesModuleMarkup();
	calendarModuleMarkup();
	formsDocumentsMarkup();
	doctorsSearchModuleMarkup();
	//locationHoursOnProviders(); // expanded option
	truncateBoxDay();
	setCurrentDay();
	locationHours();
	flipCardsHeight();
	flipCards();
	//servicesList(); // -- expanded option, if used change scss import to use 'modules/services-02'
	//jumpLinkNavigation(); // expanded option
    lightboxOptions();
	BackToTop();
	applyClickToggle(); //refreshes slider in tab container
	sliders(); // make sure this stays below the click to call DA
	sliderArrow();
	recipeHubInterior();
	BMIcalculator();
	AOS.init({offset: 0}); // Trigger animations when elements are 0px from the bottom

		/*Location Profile Wait Time Changes */
	// Change Button on Location Profile if in Location CTA custom content field
	if ($('.CustomProfile #LocationCTA .clockwiseWaitTime a.ButtonGold').length) {
		$('.CustomProfile #LocationCTA .clockwiseWaitTime a.ButtonGold').removeClass('ButtonGold').addClass('Button');
	}

	// Move Custom Wait Time Label if in Location CTA custom content field
	if ($('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .WaitTimeLabel').length) {
		$('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .WaitTimeLabel').prependTo('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .clockwiseWaitTime .ERWTRow');
	}

	// Adds minutes to Pardee wait time
	$('.ERWTRow .Time').each(function (i, elem) {
		var waitTime = $(elem).html();
		var timeString = formatVitalSiteWaitTimeString(waitTime);
		$(elem).html(timeString);
	});
});